"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2552],{

/***/ 87868:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DICT1; }
/* harmony export */ });
/* harmony import */ var _common_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55746);


const map = {
    'bǎng páng pāng': ['膀'],
    líng: [
        '〇',
        '伶',
        '凌',
        '刢',
        '囹',
        '坽',
        '夌',
        '姈',
        '婈',
        '孁',
        '岺',
        '彾',
        '掕',
        '昤',
        '朎',
        '柃',
        '棂',
        '櫺',
        '欞',
        '泠',
        '淩',
        '澪',
        '灵',
        '燯',
        '爧',
        '狑',
        '玲',
        '琌',
        '瓴',
        '皊',
        '砱',
        '祾',
        '秢',
        '竛',
        '笭',
        '紷',
        '綾',
        '绫',
        '羐',
        '羚',
        '翎',
        '聆',
        '舲',
        '苓',
        '菱',
        '蓤',
        '蔆',
        '蕶',
        '蛉',
        '衑',
        '裬',
        '詅',
        '跉',
        '軨',
        '輘',
        '酃',
        '醽',
        '鈴',
        '錂',
        '铃',
        '閝',
        '陵',
        '零',
        '霊',
        '霗',
        '霛',
        '霝',
        '靈',
        '駖',
        '魿',
        '鯪',
        '鲮',
        '鴒',
        '鸰',
        '鹷',
        '麢',
        '齡',
        '齢',
        '龄',
        '龗',
        '㥄',
    ],
    yī: [
        '一',
        '乊',
        '伊',
        '依',
        '医',
        '吚',
        '咿',
        '噫',
        '壱',
        '壹',
        '夁',
        '嫛',
        '嬄',
        '弌',
        '揖',
        '撎',
        '檹',
        '毉',
        '洢',
        '渏',
        '漪',
        '瑿',
        '畩',
        '祎',
        '禕',
        '稦',
        '繄',
        '蛜',
        '衤',
        '譩',
        '辷',
        '郼',
        '醫',
        '銥',
        '铱',
        '鷖',
        '鹥',
        '黟',
        '黳',
    ],
    'dīng zhēng': ['丁'],
    'kǎo qiǎo yú': ['丂'],
    qī: [
        '七',
        '倛',
        '僛',
        '凄',
        '嘁',
        '墄',
        '娸',
        '悽',
        '慼',
        '慽',
        '戚',
        '捿',
        '柒',
        '桤',
        '桼',
        '棲',
        '榿',
        '欺',
        '沏',
        '淒',
        '漆',
        '紪',
        '緀',
        '萋',
        '褄',
        '諆',
        '迉',
        '郪',
        '鏚',
        '霋',
        '魌',
        '鶈',
    ],
    shàng: ['丄', '尙', '尚', '恦', '緔', '绱'],
    xià: [
        '丅',
        '下',
        '乤',
        '圷',
        '夏',
        '夓',
        '懗',
        '梺',
        '疜',
        '睱',
        '罅',
        '鎼',
        '鏬',
    ],
    hǎn: ['丆', '喊', '浫', '罕', '豃', '㘎'],
    'wàn mò': ['万'],
    zhàng: [
        '丈',
        '仗',
        '墇',
        '嶂',
        '帐',
        '帳',
        '幛',
        '扙',
        '杖',
        '涱',
        '痮',
        '瘬',
        '瘴',
        '瞕',
        '粀',
        '胀',
        '脹',
        '賬',
        '账',
        '障',
    ],
    sān: ['三', '厁', '叁', '弎', '毵', '毶', '毿', '犙', '鬖'],
    'shàng shǎng shang': ['上'],
    'qí jī': ['丌', '其', '奇'],
    'bù fǒu': ['不'],
    'yǔ yù yú': ['与'],
    miǎn: [
        '丏',
        '偭',
        '免',
        '冕',
        '勉',
        '勔',
        '喕',
        '娩',
        '愐',
        '汅',
        '沔',
        '湎',
        '睌',
        '緬',
        '缅',
        '腼',
        '葂',
        '靦',
        '鮸',
        '𩾃',
    ],
    gài: [
        '丐',
        '乢',
        '匃',
        '匄',
        '戤',
        '概',
        '槩',
        '槪',
        '溉',
        '漑',
        '瓂',
        '葢',
        '鈣',
        '钙',
        '𬮿',
    ],
    chǒu: ['丑', '丒', '侴', '吜', '杽', '瞅', '矁', '醜', '魗'],
    zhuān: [
        '专',
        '叀',
        '嫥',
        '専',
        '專',
        '瑼',
        '甎',
        '砖',
        '磗',
        '磚',
        '蟤',
        '諯',
        '鄟',
        '顓',
        '颛',
        '鱄',
        '䏝',
    ],
    'qiě jū': ['且'],
    pī: [
        '丕',
        '伓',
        '伾',
        '噼',
        '坯',
        '岯',
        '憵',
        '批',
        '披',
        '炋',
        '狉',
        '狓',
        '砒',
        '磇',
        '礔',
        '礕',
        '秛',
        '秠',
        '耚',
        '豾',
        '邳',
        '鈚',
        '鉟',
        '銔',
        '錃',
        '錍',
        '霹',
        '駓',
        '髬',
        '魾',
        '𬳵',
    ],
    shì: [
        '世',
        '丗',
        '亊',
        '事',
        '仕',
        '侍',
        '冟',
        '势',
        '勢',
        '卋',
        '呩',
        '嗜',
        '噬',
        '士',
        '奭',
        '嬕',
        '室',
        '市',
        '式',
        '弑',
        '弒',
        '恀',
        '恃',
        '戺',
        '拭',
        '揓',
        '是',
        '昰',
        '枾',
        '柿',
        '栻',
        '澨',
        '烒',
        '煶',
        '眂',
        '眎',
        '眡',
        '睗',
        '示',
        '礻',
        '筮',
        '簭',
        '舐',
        '舓',
        '襫',
        '視',
        '视',
        '觢',
        '試',
        '誓',
        '諡',
        '謚',
        '试',
        '谥',
        '貰',
        '贳',
        '軾',
        '轼',
        '逝',
        '遾',
        '釈',
        '释',
        '釋',
        '鈰',
        '鉃',
        '鉽',
        '铈',
        '飾',
        '餙',
        '餝',
        '饰',
        '鰘',
        '䏡',
        '𬤊',
    ],
    qiū: [
        '丘',
        '丠',
        '坵',
        '媝',
        '恘',
        '恷',
        '楸',
        '秋',
        '秌',
        '穐',
        '篍',
        '緧',
        '萩',
        '蘒',
        '蚯',
        '蝵',
        '蟗',
        '蠤',
        '趥',
        '邱',
        '鞦',
        '鞧',
        '鰌',
        '鰍',
        '鳅',
        '鶖',
        '鹙',
        '龝',
    ],
    bǐng: [
        '丙',
        '屛',
        '怲',
        '抦',
        '昞',
        '昺',
        '柄',
        '棅',
        '炳',
        '禀',
        '秉',
        '稟',
        '苪',
        '蛃',
        '邴',
        '鈵',
        '陃',
        '鞆',
        '餅',
        '餠',
        '饼',
    ],
    yè: [
        '业',
        '亱',
        '僷',
        '墷',
        '夜',
        '嶪',
        '嶫',
        '抴',
        '捙',
        '擛',
        '擪',
        '擫',
        '晔',
        '曄',
        '曅',
        '曗',
        '曳',
        '曵',
        '枼',
        '枽',
        '業',
        '洂',
        '液',
        '澲',
        '烨',
        '燁',
        '爗',
        '璍',
        '皣',
        '瞱',
        '瞸',
        '礏',
        '腋',
        '葉',
        '謁',
        '谒',
        '邺',
        '鄴',
        '鍱',
        '鐷',
        '靥',
        '靨',
        '頁',
        '页',
        '餣',
        '饁',
        '馌',
        '驜',
        '鵺',
        '鸈',
    ],
    cóng: [
        '丛',
        '从',
        '叢',
        '婃',
        '孮',
        '従',
        '徔',
        '徖',
        '悰',
        '樷',
        '欉',
        '淙',
        '灇',
        '爜',
        '琮',
        '藂',
        '誴',
        '賨',
        '賩',
        '錝',
    ],
    dōng: [
        '东',
        '倲',
        '冬',
        '咚',
        '埬',
        '岽',
        '崬',
        '徚',
        '昸',
        '東',
        '氡',
        '氭',
        '涷',
        '笗',
        '苳',
        '菄',
        '蝀',
        '鮗',
        '鯟',
        '鶇',
        '鶫',
        '鸫',
        '鼕',
        '𬟽',
    ],
    sī: [
        '丝',
        '俬',
        '凘',
        '厮',
        '司',
        '咝',
        '嘶',
        '噝',
        '媤',
        '廝',
        '恖',
        '撕',
        '斯',
        '楒',
        '泀',
        '澌',
        '燍',
        '禗',
        '禠',
        '私',
        '糹',
        '絲',
        '緦',
        '纟',
        '缌',
        '罳',
        '蕬',
        '虒',
        '蛳',
        '蜤',
        '螄',
        '蟖',
        '蟴',
        '鉰',
        '銯',
        '鍶',
        '鐁',
        '锶',
        '颸',
        '飔',
        '騦',
        '鷥',
        '鸶',
        '鼶',
        '㟃',
    ],
    chéng: [
        '丞',
        '呈',
        '城',
        '埕',
        '堘',
        '塍',
        '塖',
        '宬',
        '峸',
        '惩',
        '懲',
        '成',
        '承',
        '挰',
        '掁',
        '揨',
        '枨',
        '棖',
        '橙',
        '檙',
        '洆',
        '溗',
        '澂',
        '珵',
        '珹',
        '畻',
        '程',
        '窚',
        '筬',
        '絾',
        '脭',
        '荿',
        '誠',
        '诚',
        '郕',
        '酲',
        '鋮',
        '铖',
        '騬',
        '鯎',
    ],
    diū: ['丟', '丢', '銩', '铥'],
    liǎng: [
        '両',
        '两',
        '兩',
        '唡',
        '啢',
        '掚',
        '緉',
        '脼',
        '蜽',
        '裲',
        '魉',
        '魎',
        '𬜯',
    ],
    yǒu: [
        '丣',
        '卣',
        '友',
        '梄',
        '湵',
        '牖',
        '禉',
        '羑',
        '聈',
        '苃',
        '莠',
        '蜏',
        '酉',
        '銪',
        '铕',
        '黝',
    ],
    yán: [
        '严',
        '厳',
        '啱',
        '喦',
        '嚴',
        '塩',
        '壛',
        '壧',
        '妍',
        '姸',
        '娫',
        '娮',
        '岩',
        '嵒',
        '嵓',
        '巌',
        '巖',
        '巗',
        '延',
        '揅',
        '昖',
        '楌',
        '檐',
        '櫩',
        '欕',
        '沿',
        '炎',
        '炏',
        '狿',
        '琂',
        '盐',
        '碞',
        '筵',
        '簷',
        '莚',
        '蔅',
        '虤',
        '蜒',
        '言',
        '訁',
        '訮',
        '詽',
        '讠',
        '郔',
        '閆',
        '閻',
        '闫',
        '阎',
        '顏',
        '顔',
        '颜',
        '鹽',
        '麣',
        '𫄧',
    ],
    bìng: [
        '並',
        '併',
        '倂',
        '傡',
        '垪',
        '摒',
        '栤',
        '病',
        '窉',
        '竝',
        '誁',
        '靐',
        '鮩',
    ],
    'sàng sāng': ['丧'],
    gǔn: [
        '丨',
        '惃',
        '滚',
        '滾',
        '磙',
        '緄',
        '绲',
        '蓘',
        '蔉',
        '衮',
        '袞',
        '輥',
        '辊',
        '鮌',
        '鯀',
        '鲧',
    ],
    jiū: [
        '丩',
        '勼',
        '啾',
        '揪',
        '揫',
        '朻',
        '究',
        '糾',
        '纠',
        '萛',
        '赳',
        '阄',
        '鬏',
        '鬮',
        '鳩',
        '鸠',
    ],
    'gè gě': ['个', '個', '各'],
    yā: [
        '丫',
        '圧',
        '孲',
        '庘',
        '押',
        '枒',
        '桠',
        '椏',
        '錏',
        '鐚',
        '鴉',
        '鴨',
        '鵶',
        '鸦',
        '鸭',
    ],
    pán: [
        '丬',
        '媻',
        '幋',
        '槃',
        '洀',
        '瀊',
        '爿',
        '盘',
        '盤',
        '磐',
        '縏',
        '蒰',
        '蟠',
        '蹒',
        '蹣',
        '鎜',
        '鞶',
    ],
    'zhōng zhòng': ['中'],
    jǐ: [
        '丮',
        '妀',
        '己',
        '戟',
        '挤',
        '掎',
        '撠',
        '擠',
        '橶',
        '泲',
        '犱',
        '脊',
        '虮',
        '蟣',
        '魢',
        '鱾',
        '麂',
    ],
    jiè: [
        '丯',
        '介',
        '借',
        '唶',
        '堺',
        '屆',
        '届',
        '岕',
        '庎',
        '徣',
        '戒',
        '楐',
        '犗',
        '玠',
        '琾',
        '界',
        '畍',
        '疥',
        '砎',
        '蚧',
        '蛶',
        '衸',
        '褯',
        '誡',
        '诫',
        '鎅',
        '骱',
        '魪',
    ],
    fēng: [
        '丰',
        '仹',
        '偑',
        '僼',
        '凨',
        '凬',
        '凮',
        '妦',
        '寷',
        '封',
        '峯',
        '峰',
        '崶',
        '枫',
        '楓',
        '檒',
        '沣',
        '沨',
        '渢',
        '灃',
        '烽',
        '犎',
        '猦',
        '琒',
        '疯',
        '瘋',
        '盽',
        '砜',
        '碸',
        '篈',
        '蘴',
        '蜂',
        '蠭',
        '豐',
        '鄷',
        '酆',
        '鋒',
        '鎽',
        '鏠',
        '锋',
        '霻',
        '靊',
        '飌',
        '麷',
    ],
    'guàn kuàng': ['丱'],
    chuàn: ['串', '汌', '玔', '賗', '釧', '钏'],
    chǎn: [
        '丳',
        '产',
        '冁',
        '剷',
        '囅',
        '嵼',
        '旵',
        '浐',
        '滻',
        '灛',
        '產',
        '産',
        '簅',
        '蒇',
        '蕆',
        '諂',
        '譂',
        '讇',
        '谄',
        '鏟',
        '铲',
        '閳',
        '闡',
        '阐',
        '骣',
        '𬊤',
    ],
    lín: [
        '临',
        '冧',
        '壣',
        '崊',
        '嶙',
        '斴',
        '晽',
        '暽',
        '林',
        '潾',
        '瀶',
        '燐',
        '琳',
        '璘',
        '瞵',
        '碄',
        '磷',
        '粦',
        '粼',
        '繗',
        '翷',
        '臨',
        '轔',
        '辚',
        '遴',
        '邻',
        '鄰',
        '鏻',
        '阾',
        '隣',
        '霖',
        '驎',
        '鱗',
        '鳞',
        '麐',
        '麟',
        '𬴊',
        '𬭸',
    ],
    zhuó: [
        '丵',
        '劅',
        '卓',
        '啄',
        '圴',
        '妰',
        '娺',
        '撯',
        '擆',
        '擢',
        '斫',
        '斮',
        '斱',
        '斲',
        '斵',
        '晫',
        '椓',
        '浊',
        '浞',
        '濁',
        '灼',
        '烵',
        '琸',
        '硺',
        '禚',
        '窡',
        '籗',
        '籱',
        '罬',
        '茁',
        '蠗',
        '蠿',
        '諁',
        '諑',
        '謶',
        '诼',
        '酌',
        '鐲',
        '镯',
        '鵫',
        '鷟',
        '䓬',
        '𬸦',
    ],
    zhǔ: [
        '丶',
        '主',
        '劯',
        '嘱',
        '囑',
        '宔',
        '帾',
        '拄',
        '渚',
        '濐',
        '煑',
        '煮',
        '燝',
        '瞩',
        '矚',
        '罜',
        '詝',
        '陼',
        '鸀',
        '麈',
        '𬣞',
    ],
    bā: [
        '丷',
        '仈',
        '八',
        '叭',
        '哵',
        '夿',
        '岜',
        '巴',
        '捌',
        '朳',
        '玐',
        '疤',
        '笆',
        '粑',
        '羓',
        '芭',
        '蚆',
        '豝',
        '釟',
    ],
    wán: [
        '丸',
        '刓',
        '完',
        '岏',
        '抏',
        '捖',
        '汍',
        '烷',
        '玩',
        '琓',
        '笂',
        '紈',
        '纨',
        '翫',
        '芄',
        '貦',
        '頑',
        '顽',
    ],
    dān: [
        '丹',
        '勯',
        '匰',
        '単',
        '妉',
        '媅',
        '殚',
        '殫',
        '甔',
        '眈',
        '砃',
        '箪',
        '簞',
        '耼',
        '耽',
        '聃',
        '聸',
        '褝',
        '襌',
        '躭',
        '郸',
        '鄲',
        '酖',
        '頕',
    ],
    'wèi wéi': ['为'],
    'jǐng dǎn': ['丼'],
    'lì lí': ['丽'],
    jǔ: [
        '举',
        '弆',
        '挙',
        '擧',
        '椇',
        '榉',
        '榘',
        '櫸',
        '欅',
        '矩',
        '筥',
        '聥',
        '舉',
        '莒',
        '蒟',
        '襷',
        '踽',
        '齟',
        '龃',
    ],
    piě: ['丿', '苤', '鐅', '𬭯'],
    fú: [
        '乀',
        '伏',
        '俘',
        '凫',
        '刜',
        '匐',
        '咈',
        '哹',
        '垘',
        '孚',
        '岪',
        '巿',
        '帗',
        '幅',
        '幞',
        '弗',
        '彿',
        '怫',
        '扶',
        '柫',
        '栿',
        '桴',
        '氟',
        '泭',
        '浮',
        '涪',
        '澓',
        '炥',
        '玸',
        '甶',
        '畉',
        '癁',
        '祓',
        '福',
        '稪',
        '符',
        '箙',
        '紱',
        '紼',
        '絥',
        '綍',
        '绂',
        '绋',
        '罘',
        '罦',
        '翇',
        '艀',
        '芙',
        '芣',
        '苻',
        '茀',
        '茯',
        '菔',
        '葍',
        '虙',
        '蚨',
        '蜉',
        '蝠',
        '袚',
        '袱',
        '襆',
        '襥',
        '諨',
        '豧',
        '踾',
        '輻',
        '辐',
        '郛',
        '鉘',
        '鉜',
        '韍',
        '韨',
        '颫',
        '髴',
        '鮄',
        '鮲',
        '鳧',
        '鳬',
        '鴔',
        '鵩',
        '黻',
    ],
    'yí jí': ['乁'],
    yì: [
        '乂',
        '义',
        '亄',
        '亦',
        '亿',
        '伇',
        '伿',
        '佾',
        '俋',
        '億',
        '兿',
        '刈',
        '劓',
        '劮',
        '勚',
        '勩',
        '匇',
        '呓',
        '呭',
        '呹',
        '唈',
        '囈',
        '圛',
        '坄',
        '垼',
        '埸',
        '奕',
        '嫕',
        '嬑',
        '寱',
        '屹',
        '峄',
        '嶧',
        '帟',
        '帠',
        '幆',
        '廙',
        '异',
        '弈',
        '弋',
        '役',
        '忆',
        '怈',
        '怿',
        '悒',
        '意',
        '憶',
        '懌',
        '懿',
        '抑',
        '挹',
        '敡',
        '易',
        '晹',
        '曀',
        '曎',
        '杙',
        '枍',
        '棭',
        '榏',
        '槸',
        '檍',
        '歝',
        '殔',
        '殪',
        '殹',
        '毅',
        '浂',
        '浥',
        '浳',
        '湙',
        '溢',
        '潩',
        '澺',
        '瀷',
        '炈',
        '焲',
        '熠',
        '熤',
        '熼',
        '燚',
        '燡',
        '燱',
        '獈',
        '玴',
        '異',
        '疫',
        '痬',
        '瘗',
        '瘞',
        '瘱',
        '癔',
        '益',
        '瞖',
        '穓',
        '竩',
        '篒',
        '縊',
        '繶',
        '繹',
        '绎',
        '缢',
        '義',
        '羿',
        '翊',
        '翌',
        '翳',
        '翼',
        '耴',
        '肄',
        '肊',
        '膉',
        '臆',
        '艗',
        '艺',
        '芅',
        '苅',
        '萟',
        '蓺',
        '薏',
        '藙',
        '藝',
        '蘙',
        '虉',
        '蜴',
        '螠',
        '衪',
        '袣',
        '裔',
        '裛',
        '褹',
        '襼',
        '訲',
        '訳',
        '詍',
        '詣',
        '誼',
        '譯',
        '議',
        '讛',
        '议',
        '译',
        '诣',
        '谊',
        '豙',
        '豛',
        '豷',
        '貖',
        '贀',
        '跇',
        '轶',
        '逸',
        '邑',
        '鄓',
        '醷',
        '釴',
        '鈠',
        '鎰',
        '鐿',
        '镒',
        '镱',
        '阣',
        '隿',
        '霬',
        '饐',
        '駅',
        '驛',
        '驿',
        '骮',
        '鮨',
        '鶂',
        '鶃',
        '鶍',
        '鷁',
        '鷊',
        '鷧',
        '鷾',
        '鸃',
        '鹝',
        '鹢',
        '黓',
        '齸',
        '𬬩',
        '㑊',
        '𫄷',
        '𬟁',
    ],
    nǎi: ['乃', '倷', '奶', '嬭', '廼', '氖', '疓', '艿', '迺', '釢'],
    wǔ: [
        '乄',
        '五',
        '仵',
        '伍',
        '侮',
        '倵',
        '儛',
        '午',
        '啎',
        '妩',
        '娬',
        '嫵',
        '庑',
        '廡',
        '忤',
        '怃',
        '憮',
        '摀',
        '武',
        '潕',
        '熓',
        '牾',
        '玝',
        '珷',
        '瑦',
        '甒',
        '碔',
        '舞',
        '躌',
        '迕',
        '逜',
        '陚',
        '鵡',
        '鹉',
        '𣲘',
    ],
    jiǔ: [
        '久',
        '乆',
        '九',
        '乣',
        '奺',
        '杦',
        '汣',
        '灸',
        '玖',
        '紤',
        '舏',
        '酒',
        '镹',
        '韭',
        '韮',
    ],
    'tuō zhé': ['乇', '杔', '馲'],
    'me mó ma yāo': ['么'],
    zhī: [
        '之',
        '倁',
        '卮',
        '巵',
        '搘',
        '支',
        '栀',
        '梔',
        '椥',
        '榰',
        '汁',
        '泜',
        '疷',
        '祗',
        '祬',
        '秓',
        '稙',
        '綕',
        '肢',
        '胑',
        '胝',
        '脂',
        '芝',
        '蘵',
        '蜘',
        '衼',
        '隻',
        '鳷',
        '鴲',
        '鼅',
        '𦭜',
    ],
    'wū wù': ['乌'],
    zhà: [
        '乍',
        '咤',
        '宱',
        '搾',
        '榨',
        '溠',
        '痄',
        '蚱',
        '詐',
        '诈',
        '醡',
        '霅',
        '䃎',
    ],
    hū: [
        '乎',
        '乯',
        '匢',
        '匫',
        '呼',
        '唿',
        '嘑',
        '垀',
        '寣',
        '幠',
        '忽',
        '惚',
        '昒',
        '歑',
        '泘',
        '淴',
        '滹',
        '烀',
        '苸',
        '虍',
        '虖',
        '謼',
        '軤',
        '轷',
        '雐',
    ],
    fá: [
        '乏',
        '伐',
        '傠',
        '坺',
        '垡',
        '墢',
        '姂',
        '栰',
        '浌',
        '瞂',
        '笩',
        '筏',
        '罚',
        '罰',
        '罸',
        '藅',
        '閥',
        '阀',
    ],
    'lè yuè yào lào': ['乐', '樂'],
    yín: [
        '乑',
        '吟',
        '噖',
        '嚚',
        '圁',
        '垠',
        '夤',
        '婬',
        '寅',
        '峾',
        '崟',
        '崯',
        '檭',
        '殥',
        '泿',
        '淫',
        '滛',
        '烎',
        '犾',
        '狺',
        '璌',
        '硍',
        '碒',
        '荶',
        '蔩',
        '訔',
        '訚',
        '訡',
        '誾',
        '鄞',
        '鈝',
        '銀',
        '银',
        '霪',
        '鷣',
        '齦',
    ],
    pīng: ['乒', '俜', '娉', '涄', '甹', '砯', '聠', '艵', '頩'],
    pāng: ['乓', '滂', '胮', '膖', '雱', '霶'],
    qiáo: [
        '乔',
        '侨',
        '僑',
        '嫶',
        '憔',
        '桥',
        '槗',
        '樵',
        '橋',
        '櫵',
        '犞',
        '瞧',
        '硚',
        '礄',
        '荍',
        '荞',
        '蕎',
        '藮',
        '譙',
        '趫',
        '鐈',
        '鞒',
        '鞽',
        '顦',
    ],
    hǔ: ['乕', '琥', '萀', '虎', '虝', '錿', '鯱'],
    guāi: ['乖'],
    'chéng shèng': ['乗', '乘', '娍'],
    yǐ: [
        '乙',
        '乛',
        '以',
        '倚',
        '偯',
        '嬟',
        '崺',
        '已',
        '庡',
        '扆',
        '攺',
        '敼',
        '旑',
        '旖',
        '檥',
        '矣',
        '礒',
        '笖',
        '舣',
        '艤',
        '苡',
        '苢',
        '蚁',
        '螘',
        '蟻',
        '裿',
        '踦',
        '輢',
        '轙',
        '逘',
        '酏',
        '釔',
        '鈘',
        '鉯',
        '钇',
        '顗',
        '鳦',
        '齮',
        '𫖮',
        '𬺈',
    ],
    'háo yǐ': ['乚'],
    'niè miē': ['乜'],
    qǐ: [
        '乞',
        '企',
        '启',
        '唘',
        '啓',
        '啔',
        '啟',
        '婍',
        '屺',
        '杞',
        '棨',
        '玘',
        '盀',
        '綺',
        '绮',
        '芑',
        '諬',
        '起',
        '邔',
        '闙',
    ],
    yě: ['也', '冶', '嘢', '埜', '壄', '漜', '野'],
    xí: [
        '习',
        '喺',
        '媳',
        '嶍',
        '席',
        '椺',
        '檄',
        '漝',
        '習',
        '蓆',
        '袭',
        '襲',
        '覡',
        '觋',
        '謵',
        '趘',
        '郋',
        '鎴',
        '隰',
        '霫',
        '飁',
        '騱',
        '騽',
        '驨',
        '鰼',
        '鳛',
        '𠅤',
        '𫘬',
    ],
    xiāng: [
        '乡',
        '厢',
        '廂',
        '忀',
        '楿',
        '欀',
        '湘',
        '瓖',
        '稥',
        '箱',
        '緗',
        '缃',
        '膷',
        '芗',
        '萫',
        '葙',
        '薌',
        '襄',
        '郷',
        '鄉',
        '鄊',
        '鄕',
        '鑲',
        '镶',
        '香',
        '驤',
        '骧',
        '鱜',
        '麘',
        '𬙋',
    ],
    shū: [
        '书',
        '倏',
        '倐',
        '儵',
        '叔',
        '姝',
        '尗',
        '抒',
        '掓',
        '摅',
        '攄',
        '書',
        '枢',
        '梳',
        '樞',
        '殊',
        '殳',
        '毹',
        '毺',
        '淑',
        '瀭',
        '焂',
        '疎',
        '疏',
        '紓',
        '綀',
        '纾',
        '舒',
        '菽',
        '蔬',
        '踈',
        '軗',
        '輸',
        '输',
        '鄃',
        '陎',
        '鮛',
        '鵨',
    ],
    dǒu: ['乧', '抖', '枓', '蚪', '鈄', '阧', '陡'],
    shǐ: [
        '乨',
        '使',
        '兘',
        '史',
        '始',
        '宩',
        '屎',
        '榁',
        '矢',
        '笶',
        '豕',
        '鉂',
        '駛',
        '驶',
    ],
    jī: [
        '乩',
        '僟',
        '击',
        '刉',
        '刏',
        '剞',
        '叽',
        '唧',
        '喞',
        '嗘',
        '嘰',
        '圾',
        '基',
        '墼',
        '姬',
        '屐',
        '嵆',
        '嵇',
        '撃',
        '擊',
        '朞',
        '机',
        '枅',
        '樭',
        '機',
        '毄',
        '激',
        '犄',
        '玑',
        '璣',
        '畸',
        '畿',
        '癪',
        '矶',
        '磯',
        '积',
        '積',
        '笄',
        '筓',
        '箕',
        '簊',
        '緁',
        '羁',
        '羇',
        '羈',
        '耭',
        '肌',
        '芨',
        '虀',
        '覉',
        '覊',
        '譏',
        '譤',
        '讥',
        '賫',
        '賷',
        '赍',
        '跻',
        '踑',
        '躋',
        '躸',
        '銈',
        '錤',
        '鐖',
        '鑇',
        '鑙',
        '隮',
        '雞',
        '鞿',
        '韲',
        '飢',
        '饑',
        '饥',
        '魕',
        '鳮',
        '鶏',
        '鶺',
        '鷄',
        '鸄',
        '鸡',
        '齎',
        '齏',
        '齑',
        '𬯀',
        '𫓯',
        '𫓹',
        '𫌀',
    ],
    náng: ['乪', '嚢', '欜', '蠰', '饢'],
    jiā: [
        '乫',
        '佳',
        '傢',
        '加',
        '嘉',
        '抸',
        '枷',
        '梜',
        '毠',
        '泇',
        '浃',
        '浹',
        '犌',
        '猳',
        '珈',
        '痂',
        '笳',
        '糘',
        '耞',
        '腵',
        '葭',
        '袈',
        '豭',
        '貑',
        '跏',
        '迦',
        '鉫',
        '鎵',
        '镓',
        '鴐',
        '麚',
        '𬂩',
    ],
    jù: [
        '乬',
        '倨',
        '倶',
        '具',
        '剧',
        '劇',
        '勮',
        '埧',
        '埾',
        '壉',
        '姖',
        '屦',
        '屨',
        '岠',
        '巨',
        '巪',
        '怇',
        '惧',
        '愳',
        '懅',
        '懼',
        '拒',
        '拠',
        '昛',
        '歫',
        '洰',
        '澽',
        '炬',
        '烥',
        '犋',
        '秬',
        '窭',
        '窶',
        '簴',
        '粔',
        '耟',
        '聚',
        '虡',
        '蚷',
        '詎',
        '讵',
        '豦',
        '距',
        '踞',
        '躆',
        '遽',
        '邭',
        '醵',
        '鉅',
        '鐻',
        '钜',
        '颶',
        '飓',
        '駏',
        '鮔',
    ],
    shí: [
        '乭',
        '十',
        '埘',
        '塒',
        '姼',
        '实',
        '実',
        '寔',
        '實',
        '峕',
        '嵵',
        '时',
        '旹',
        '時',
        '榯',
        '湜',
        '溡',
        '炻',
        '祏',
        '竍',
        '蚀',
        '蝕',
        '辻',
        '遈',
        '鉐',
        '飠',
        '饣',
        '鮖',
        '鰣',
        '鲥',
        '鼫',
        '鼭',
    ],
    mǎo: ['乮', '冇', '卯', '峁', '戼', '昴', '泖', '笷', '蓩', '鉚', '铆'],
    mǎi: ['买', '嘪', '荬', '蕒', '買', '鷶'],
    luàn: ['乱', '亂', '釠'],
    rǔ: ['乳', '擩', '汝', '肗', '辱', '鄏'],
    xué: [
        '乴',
        '学',
        '學',
        '峃',
        '嶨',
        '斈',
        '泶',
        '澩',
        '燢',
        '穴',
        '茓',
        '袕',
        '踅',
        '鷽',
        '鸴',
    ],
    yǎn: [
        '䶮',
        '乵',
        '俨',
        '偃',
        '儼',
        '兖',
        '兗',
        '厣',
        '厴',
        '噞',
        '孍',
        '嵃',
        '巘',
        '巚',
        '弇',
        '愝',
        '戭',
        '扊',
        '抁',
        '掩',
        '揜',
        '曮',
        '椼',
        '檿',
        '沇',
        '渷',
        '演',
        '琰',
        '甗',
        '眼',
        '罨',
        '萒',
        '蝘',
        '衍',
        '褗',
        '躽',
        '遃',
        '郾',
        '隒',
        '顩',
        '魇',
        '魘',
        '鰋',
        '鶠',
        '黡',
        '黤',
        '黬',
        '黭',
        '黶',
        '鼴',
        '鼹',
        '齴',
        '龑',
        '𬸘',
        '𬙂',
        '𪩘',
    ],
    fǔ: [
        '乶',
        '俌',
        '俛',
        '俯',
        '府',
        '弣',
        '抚',
        '拊',
        '撫',
        '斧',
        '椨',
        '滏',
        '焤',
        '甫',
        '盙',
        '簠',
        '腐',
        '腑',
        '蜅',
        '輔',
        '辅',
        '郙',
        '釜',
        '釡',
        '阝',
        '頫',
        '鬴',
        '黼',
        '㕮',
        '𫖯',
    ],
    shā: [
        '乷',
        '唦',
        '杀',
        '桬',
        '殺',
        '毮',
        '猀',
        '痧',
        '砂',
        '硰',
        '紗',
        '繺',
        '纱',
        '蔱',
        '裟',
        '鎩',
        '铩',
        '閷',
        '髿',
        '魦',
        '鯊',
        '鯋',
        '鲨',
    ],
    nǎ: ['乸', '雫'],
    qián: [
        '乹',
        '亁',
        '仱',
        '偂',
        '前',
        '墘',
        '媊',
        '岒',
        '拑',
        '掮',
        '榩',
        '橬',
        '歬',
        '潛',
        '潜',
        '濳',
        '灊',
        '箝',
        '葥',
        '虔',
        '軡',
        '鈐',
        '鉗',
        '銭',
        '錢',
        '鎆',
        '钤',
        '钱',
        '钳',
        '靬',
        '騚',
        '騝',
        '鰬',
        '黔',
        '黚',
    ],
    suǒ: [
        '乺',
        '唢',
        '嗩',
        '所',
        '暛',
        '溑',
        '溹',
        '琐',
        '琑',
        '瑣',
        '索',
        '褨',
        '鎖',
        '鎻',
        '鏁',
        '锁',
    ],
    yú: [
        '乻',
        '于',
        '亐',
        '伃',
        '余',
        '堣',
        '堬',
        '妤',
        '娛',
        '娯',
        '娱',
        '嬩',
        '崳',
        '嵎',
        '嵛',
        '愚',
        '扵',
        '揄',
        '旟',
        '楡',
        '楰',
        '榆',
        '欤',
        '歈',
        '歟',
        '歶',
        '渔',
        '渝',
        '湡',
        '漁',
        '澞',
        '牏',
        '狳',
        '玗',
        '玙',
        '瑜',
        '璵',
        '盂',
        '睮',
        '窬',
        '竽',
        '籅',
        '羭',
        '腴',
        '臾',
        '舁',
        '舆',
        '艅',
        '茰',
        '萮',
        '萸',
        '蕍',
        '蘛',
        '虞',
        '虶',
        '蝓',
        '螸',
        '衧',
        '褕',
        '覦',
        '觎',
        '諛',
        '謣',
        '谀',
        '踰',
        '輿',
        '轝',
        '逾',
        '邘',
        '酑',
        '鍝',
        '隅',
        '雓',
        '雩',
        '餘',
        '馀',
        '騟',
        '骬',
        '髃',
        '魚',
        '魣',
        '鮽',
        '鯲',
        '鰅',
        '鱼',
        '鷠',
        '鸆',
        '齵',
    ],
    zhù: [
        '乼',
        '伫',
        '佇',
        '住',
        '坾',
        '墸',
        '壴',
        '嵀',
        '拀',
        '杼',
        '柱',
        '樦',
        '殶',
        '注',
        '炷',
        '疰',
        '眝',
        '祝',
        '祩',
        '竚',
        '筯',
        '箸',
        '篫',
        '簗',
        '紵',
        '紸',
        '纻',
        '羜',
        '翥',
        '苎',
        '莇',
        '蛀',
        '註',
        '貯',
        '贮',
        '跓',
        '軴',
        '鉒',
        '鋳',
        '鑄',
        '铸',
        '馵',
        '駐',
        '驻',
    ],
    zhě: ['乽', '者', '褶', '襵', '赭', '踷', '鍺', '锗'],
    'qián gān': ['乾'],
    'zhì luàn': ['乿'],
    guī: [
        '亀',
        '圭',
        '妫',
        '媯',
        '嫢',
        '嬀',
        '帰',
        '归',
        '摫',
        '椝',
        '槻',
        '槼',
        '櫷',
        '歸',
        '珪',
        '瑰',
        '璝',
        '瓌',
        '皈',
        '瞡',
        '硅',
        '茥',
        '蘬',
        '規',
        '规',
        '邽',
        '郌',
        '閨',
        '闺',
        '騩',
        '鬶',
        '鬹',
    ],
    'lǐn lìn': ['亃'],
    jué: [
        '亅',
        '决',
        '刔',
        '劂',
        '匷',
        '厥',
        '噊',
        '孒',
        '孓',
        '崛',
        '崫',
        '嶥',
        '彏',
        '憠',
        '憰',
        '戄',
        '抉',
        '挗',
        '掘',
        '攫',
        '桷',
        '橛',
        '橜',
        '欮',
        '氒',
        '決',
        '灍',
        '焳',
        '熦',
        '爑',
        '爴',
        '爵',
        '獗',
        '玃',
        '玦',
        '玨',
        '珏',
        '瑴',
        '瘚',
        '矍',
        '矡',
        '砄',
        '絕',
        '絶',
        '绝',
        '臄',
        '芵',
        '蕝',
        '蕨',
        '虳',
        '蟨',
        '蟩',
        '觖',
        '觮',
        '觼',
        '訣',
        '譎',
        '诀',
        '谲',
        '貜',
        '赽',
        '趉',
        '蹷',
        '躩',
        '鈌',
        '鐍',
        '鐝',
        '钁',
        '镢',
        '鴂',
        '鴃',
        '鷢',
        '𫘝',
        '㵐',
        '𫔎',
    ],
    'le liǎo': ['了'],
    'gè mā': ['亇'],
    'yǔ yú': ['予', '懙'],
    zhēng: [
        '争',
        '佂',
        '凧',
        '姃',
        '媜',
        '峥',
        '崝',
        '崢',
        '征',
        '徰',
        '炡',
        '烝',
        '爭',
        '狰',
        '猙',
        '癥',
        '眐',
        '睁',
        '睜',
        '筝',
        '箏',
        '篜',
        '聇',
        '脀',
        '蒸',
        '踭',
        '鉦',
        '錚',
        '鏳',
        '鬇',
    ],
    èr: ['二', '刵', '咡', '弍', '弐', '樲', '誀', '貮', '貳', '贰', '髶'],
    chù: [
        '亍',
        '傗',
        '儊',
        '怵',
        '憷',
        '搐',
        '斶',
        '歜',
        '珿',
        '琡',
        '矗',
        '竌',
        '絀',
        '绌',
        '臅',
        '触',
        '觸',
        '豖',
        '鄐',
        '閦',
        '黜',
    ],
    kuī: ['亏', '刲', '岿', '巋', '盔', '窥', '窺', '聧', '虧', '闚', '顝'],
    yún: [
        '云',
        '伝',
        '勻',
        '匀',
        '囩',
        '妘',
        '愪',
        '抣',
        '昀',
        '橒',
        '沄',
        '涢',
        '溳',
        '澐',
        '熉',
        '畇',
        '秐',
        '筼',
        '篔',
        '紜',
        '縜',
        '纭',
        '耘',
        '芸',
        '蒷',
        '蕓',
        '郧',
        '鄖',
        '鋆',
        '雲',
    ],
    hù: [
        '互',
        '冱',
        '嗀',
        '嚛',
        '婟',
        '嫭',
        '嫮',
        '岵',
        '帍',
        '弖',
        '怙',
        '戶',
        '户',
        '戸',
        '戽',
        '扈',
        '护',
        '昈',
        '槴',
        '沍',
        '沪',
        '滬',
        '熩',
        '瓠',
        '祜',
        '笏',
        '簄',
        '粐',
        '綔',
        '蔰',
        '護',
        '豰',
        '鄠',
        '鍙',
        '頀',
        '鱯',
        '鳠',
        '鳸',
        '鸌',
        '鹱',
    ],
    qí: [
        '亓',
        '剘',
        '埼',
        '岐',
        '岓',
        '崎',
        '嵜',
        '愭',
        '掑',
        '斉',
        '斊',
        '旂',
        '旗',
        '棊',
        '棋',
        '檱',
        '櫀',
        '歧',
        '淇',
        '濝',
        '猉',
        '玂',
        '琦',
        '琪',
        '璂',
        '畦',
        '疧',
        '碁',
        '碕',
        '祁',
        '祈',
        '祺',
        '禥',
        '竒',
        '簯',
        '簱',
        '籏',
        '粸',
        '綥',
        '綦',
        '肵',
        '脐',
        '臍',
        '艩',
        '芪',
        '萁',
        '萕',
        '蕲',
        '藄',
        '蘄',
        '蚑',
        '蚚',
        '蛴',
        '蜝',
        '蜞',
        '螧',
        '蠐',
        '褀',
        '軝',
        '鄿',
        '釮',
        '錡',
        '锜',
        '陭',
        '頎',
        '颀',
        '騎',
        '騏',
        '騹',
        '骐',
        '骑',
        '鬐',
        '鬿',
        '鯕',
        '鰭',
        '鲯',
        '鳍',
        '鵸',
        '鶀',
        '麒',
        '麡',
        '𨙸',
        '𬨂',
        '䓫',
    ],
    jǐng: [
        '井',
        '儆',
        '刭',
        '剄',
        '坓',
        '宑',
        '幜',
        '憬',
        '暻',
        '殌',
        '汫',
        '汬',
        '澋',
        '璄',
        '璟',
        '璥',
        '穽',
        '肼',
        '蟼',
        '警',
        '阱',
        '頚',
        '頸',
    ],
    sì: [
        '亖',
        '佀',
        '価',
        '儩',
        '兕',
        '嗣',
        '四',
        '姒',
        '娰',
        '孠',
        '寺',
        '巳',
        '柶',
        '榹',
        '汜',
        '泗',
        '泤',
        '洍',
        '洠',
        '涘',
        '瀃',
        '牭',
        '祀',
        '禩',
        '竢',
        '笥',
        '耜',
        '肂',
        '肆',
        '蕼',
        '覗',
        '貄',
        '釲',
        '鈶',
        '鈻',
        '飤',
        '飼',
        '饲',
        '駟',
        '騃',
        '驷',
    ],
    suì: [
        '亗',
        '嬘',
        '岁',
        '嵗',
        '旞',
        '檖',
        '歲',
        '歳',
        '澻',
        '煫',
        '燧',
        '璲',
        '砕',
        '碎',
        '祟',
        '禭',
        '穂',
        '穗',
        '穟',
        '繀',
        '繐',
        '繸',
        '襚',
        '誶',
        '譢',
        '谇',
        '賥',
        '邃',
        '鐆',
        '鐩',
        '隧',
        '韢',
        '𫟦',
        '𬭼',
    ],
    gèn: ['亘', '亙', '揯', '搄', '茛'],
    yà: [
        '亚',
        '亜',
        '俹',
        '冴',
        '劜',
        '圔',
        '圠',
        '埡',
        '娅',
        '婭',
        '揠',
        '氩',
        '氬',
        '犽',
        '砑',
        '稏',
        '聐',
        '襾',
        '覀',
        '訝',
        '讶',
        '迓',
        '齾',
    ],
    'xiē suò': ['些'],
    'qí zhāi': ['亝', '齊'],
    'yā yà': ['亞', '压', '垭', '壓', '铔'],
    'jí qì': ['亟', '焏'],
    tóu: ['亠', '投', '頭', '骰'],
    'wáng wú': ['亡'],
    'kàng háng gāng': ['亢'],
    dà: ['亣', '眔'],
    jiāo: [
        '交',
        '僬',
        '娇',
        '嬌',
        '峧',
        '嶕',
        '嶣',
        '憍',
        '椒',
        '浇',
        '澆',
        '焦',
        '礁',
        '穚',
        '簥',
        '胶',
        '膠',
        '膲',
        '茭',
        '茮',
        '蕉',
        '虠',
        '蛟',
        '蟭',
        '跤',
        '轇',
        '郊',
        '鐎',
        '驕',
        '骄',
        '鮫',
        '鲛',
        '鵁',
        '鷦',
        '鷮',
        '鹪',
        '䴔',
    ],
    hài: ['亥', '嗐', '害', '氦', '餀', '饚', '駭', '駴', '骇'],
    'hēng pēng': ['亨'],
    mǔ: [
        '亩',
        '姆',
        '峔',
        '拇',
        '母',
        '牡',
        '牳',
        '畂',
        '畆',
        '畒',
        '畝',
        '畞',
        '畮',
        '砪',
        '胟',
        '踇',
        '鉧',
        '𬭁',
        '𧿹',
    ],
    ye: ['亪'],
    xiǎng: [
        '享',
        '亯',
        '响',
        '想',
        '晑',
        '蚃',
        '蠁',
        '響',
        '飨',
        '餉',
        '饗',
        '饷',
        '鮝',
        '鯗',
        '鱶',
        '鲞',
    ],
    jīng: [
        '京',
        '亰',
        '兢',
        '坕',
        '坙',
        '婛',
        '惊',
        '旌',
        '旍',
        '晶',
        '橸',
        '泾',
        '涇',
        '猄',
        '睛',
        '秔',
        '稉',
        '粳',
        '精',
        '経',
        '經',
        '綡',
        '聙',
        '腈',
        '茎',
        '荆',
        '荊',
        '菁',
        '葏',
        '驚',
        '鯨',
        '鲸',
        '鶁',
        '鶄',
        '麖',
        '麠',
        '鼱',
        '䴖',
    ],
    tíng: [
        '亭',
        '停',
        '婷',
        '嵉',
        '庭',
        '廷',
        '楟',
        '榳',
        '筳',
        '聤',
        '莛',
        '葶',
        '蜓',
        '蝏',
        '諪',
        '邒',
        '霆',
        '鼮',
        '䗴',
    ],
    liàng: ['亮', '喨', '悢', '晾', '湸', '諒', '谅', '輌', '輛', '辆', '鍄'],
    'qīn qìng': ['亲', '親'],
    bó: [
        '亳',
        '仢',
        '侼',
        '僰',
        '博',
        '帛',
        '愽',
        '懪',
        '挬',
        '搏',
        '欂',
        '浡',
        '淿',
        '渤',
        '煿',
        '牔',
        '狛',
        '瓝',
        '礴',
        '秡',
        '箔',
        '簙',
        '糪',
        '胉',
        '脖',
        '膊',
        '舶',
        '艊',
        '萡',
        '葧',
        '袯',
        '襏',
        '襮',
        '謈',
        '踣',
        '郣',
        '鈸',
        '鉑',
        '鋍',
        '鎛',
        '鑮',
        '钹',
        '铂',
        '镈',
        '餺',
        '馎',
        '馛',
        '馞',
        '駁',
        '駮',
        '驳',
        '髆',
        '鵓',
        '鹁',
    ],
    yòu: [
        '亴',
        '佑',
        '佦',
        '侑',
        '又',
        '右',
        '哊',
        '唀',
        '囿',
        '姷',
        '宥',
        '峟',
        '幼',
        '狖',
        '祐',
        '蚴',
        '誘',
        '诱',
        '貁',
        '迶',
        '酭',
        '釉',
        '鼬',
    ],
    xiè: [
        '亵',
        '伳',
        '偞',
        '偰',
        '僁',
        '卨',
        '卸',
        '噧',
        '塮',
        '夑',
        '媟',
        '屑',
        '屧',
        '廨',
        '徢',
        '懈',
        '暬',
        '械',
        '榍',
        '榭',
        '泻',
        '洩',
        '渫',
        '澥',
        '瀉',
        '瀣',
        '灺',
        '炧',
        '炨',
        '燮',
        '爕',
        '獬',
        '祄',
        '禼',
        '糏',
        '紲',
        '絏',
        '絬',
        '繲',
        '纈',
        '绁',
        '缷',
        '薢',
        '薤',
        '蟹',
        '蠏',
        '褉',
        '褻',
        '謝',
        '谢',
        '躞',
        '邂',
        '靾',
        '韰',
        '齂',
        '齘',
        '齛',
        '齥',
        '𬹼',
        '𤫉',
    ],
    'dǎn dàn': ['亶', '馾'],
    lián: [
        '亷',
        '劆',
        '匲',
        '匳',
        '嗹',
        '噒',
        '奁',
        '奩',
        '嫾',
        '帘',
        '廉',
        '怜',
        '憐',
        '涟',
        '漣',
        '濂',
        '濓',
        '瀮',
        '熑',
        '燫',
        '簾',
        '籢',
        '籨',
        '縺',
        '翴',
        '联',
        '聨',
        '聫',
        '聮',
        '聯',
        '臁',
        '莲',
        '蓮',
        '薕',
        '螊',
        '蠊',
        '裢',
        '褳',
        '覝',
        '謰',
        '蹥',
        '连',
        '連',
        '鎌',
        '鐮',
        '镰',
        '鬑',
        '鰱',
        '鲢',
    ],
    duǒ: [
        '亸',
        '哚',
        '嚲',
        '埵',
        '崜',
        '朵',
        '朶',
        '綞',
        '缍',
        '趓',
        '躱',
        '躲',
        '軃',
    ],
    'wěi mén': ['亹', '斖'],
    rén: ['人', '亻', '仁', '壬', '忈', '忎', '朲', '秂', '芢', '魜', '鵀'],
    jí: [
        '亼',
        '亽',
        '伋',
        '佶',
        '偮',
        '卙',
        '即',
        '卽',
        '及',
        '叝',
        '吉',
        '堲',
        '塉',
        '姞',
        '嫉',
        '岌',
        '嵴',
        '嶯',
        '彶',
        '忣',
        '急',
        '愱',
        '戢',
        '揤',
        '极',
        '棘',
        '楫',
        '極',
        '槉',
        '檝',
        '殛',
        '汲',
        '湒',
        '潗',
        '疾',
        '瘠',
        '皍',
        '笈',
        '箿',
        '籍',
        '級',
        '级',
        '膌',
        '艥',
        '蒺',
        '蕀',
        '蕺',
        '蝍',
        '螏',
        '襋',
        '觙',
        '谻',
        '踖',
        '蹐',
        '躤',
        '輯',
        '轚',
        '辑',
        '郆',
        '銡',
        '鍓',
        '鏶',
        '集',
        '雧',
        '霵',
        '鹡',
        '㴔',
    ],
    wáng: ['亾', '仼', '兦', '莣', '蚟'],
    'shén shí': ['什'],
    lè: [
        '仂',
        '叻',
        '忇',
        '氻',
        '泐',
        '玏',
        '砳',
        '簕',
        '艻',
        '阞',
        '韷',
        '餎',
        '鰳',
        '鱳',
        '鳓',
    ],
    dīng: ['仃', '叮', '帄', '玎', '疔', '盯', '耵', '虰', '靪'],
    zè: ['仄', '崱', '庂', '捑', '昃', '昗', '汄'],
    'jǐn jìn': ['仅', '僅', '嫤'],
    'pú pū': ['仆'],
    'chóu qiú': ['仇'],
    zhǎng: ['仉', '幥', '掌', '礃'],
    jīn: [
        '今',
        '堻',
        '巾',
        '惍',
        '斤',
        '津',
        '珒',
        '琻',
        '璡',
        '砛',
        '筋',
        '荕',
        '衿',
        '襟',
        '觔',
        '金',
        '釒',
        '釿',
        '钅',
        '鹶',
        '黅',
        '𬬱',
    ],
    bīng: ['仌', '仒', '兵', '冫', '冰', '掤', '氷', '鋲'],
    réng: ['仍', '礽', '芿', '辸', '陾'],
    fó: ['仏', '坲', '梻'],
    'jīn sǎn': ['仐'],
    lún: [
        '仑',
        '伦',
        '侖',
        '倫',
        '囵',
        '圇',
        '婨',
        '崘',
        '崙',
        '棆',
        '沦',
        '淪',
        '磮',
        '腀',
        '菕',
        '蜦',
        '踚',
        '輪',
        '轮',
        '錀',
        '陯',
        '鯩',
        '𬬭',
    ],
    cāng: [
        '仓',
        '仺',
        '倉',
        '凔',
        '嵢',
        '沧',
        '滄',
        '濸',
        '獊',
        '舱',
        '艙',
        '苍',
        '蒼',
        '螥',
        '鸧',
    ],
    'zǎi zǐ zī': ['仔'],
    tā: ['他', '塌', '它', '榙', '溻', '牠', '祂', '褟', '趿', '遢', '闧'],
    fù: [
        '付',
        '偩',
        '傅',
        '冨',
        '副',
        '咐',
        '坿',
        '复',
        '妇',
        '婦',
        '媍',
        '嬔',
        '富',
        '復',
        '椱',
        '祔',
        '禣',
        '竎',
        '緮',
        '縛',
        '缚',
        '腹',
        '萯',
        '蕧',
        '蚹',
        '蛗',
        '蝜',
        '蝮',
        '袝',
        '複',
        '覄',
        '覆',
        '訃',
        '詂',
        '讣',
        '負',
        '賦',
        '賻',
        '负',
        '赋',
        '赙',
        '赴',
        '輹',
        '鍑',
        '鍢',
        '阜',
        '附',
        '馥',
        '駙',
        '驸',
        '鮒',
        '鰒',
        '鲋',
        '鳆',
        '㳇',
    ],
    xiān: [
        '仙',
        '仚',
        '佡',
        '僊',
        '僲',
        '先',
        '嘕',
        '奾',
        '屳',
        '廯',
        '忺',
        '憸',
        '掀',
        '暹',
        '杴',
        '氙',
        '珗',
        '祆',
        '秈',
        '籼',
        '繊',
        '纎',
        '纖',
        '苮',
        '褼',
        '襳',
        '跹',
        '蹮',
        '躚',
        '酰',
        '鍁',
        '锨',
        '韯',
        '韱',
        '馦',
        '鱻',
        '鶱',
        '𬸣',
    ],
    'tuō chà duó': ['仛'],
    hóng: [
        '仜',
        '吰',
        '垬',
        '妅',
        '娂',
        '宏',
        '宖',
        '弘',
        '彋',
        '汯',
        '泓',
        '洪',
        '浤',
        '渱',
        '潂',
        '玒',
        '玜',
        '竑',
        '竤',
        '篊',
        '粠',
        '紘',
        '紭',
        '綋',
        '纮',
        '翃',
        '翝',
        '耾',
        '苰',
        '荭',
        '葒',
        '葓',
        '谹',
        '谼',
        '鈜',
        '鉷',
        '鋐',
        '閎',
        '闳',
        '霐',
        '霟',
        '鞃',
        '魟',
        '鴻',
        '鸿',
        '黉',
        '黌',
        '𫟹',
        '𬭎',
    ],
    tóng: [
        '仝',
        '佟',
        '哃',
        '峂',
        '峝',
        '庝',
        '彤',
        '晍',
        '曈',
        '桐',
        '氃',
        '浵',
        '潼',
        '犝',
        '獞',
        '眮',
        '瞳',
        '砼',
        '秱',
        '童',
        '粡',
        '膧',
        '茼',
        '蚒',
        '詷',
        '赨',
        '酮',
        '鉖',
        '鉵',
        '銅',
        '铜',
        '餇',
        '鮦',
        '鲖',
        '𫍣',
        '𦒍',
    ],
    rèn: [
        '仞',
        '仭',
        '刃',
        '刄',
        '妊',
        '姙',
        '屻',
        '岃',
        '扨',
        '牣',
        '祍',
        '紉',
        '紝',
        '絍',
        '纫',
        '纴',
        '肕',
        '腍',
        '衽',
        '袵',
        '訒',
        '認',
        '认',
        '讱',
        '軔',
        '轫',
        '鈓',
        '靭',
        '靱',
        '韌',
        '韧',
        '飪',
        '餁',
        '饪',
    ],
    qiān: [
        '仟',
        '佥',
        '僉',
        '千',
        '圲',
        '奷',
        '孯',
        '岍',
        '悭',
        '愆',
        '慳',
        '扦',
        '拪',
        '搴',
        '撁',
        '攐',
        '攑',
        '攓',
        '杄',
        '櫏',
        '汘',
        '汧',
        '牵',
        '牽',
        '竏',
        '签',
        '簽',
        '籖',
        '籤',
        '粁',
        '芊',
        '茾',
        '蚈',
        '褰',
        '諐',
        '謙',
        '谦',
        '谸',
        '迁',
        '遷',
        '釺',
        '鈆',
        '鉛',
        '鏲',
        '钎',
        '阡',
        '韆',
        '顅',
        '騫',
        '骞',
        '鬜',
        '鬝',
        '鵮',
        '鹐',
    ],
    'gǎn hàn': ['仠'],
    'yì gē': ['仡'],
    dài: [
        '代',
        '侢',
        '叇',
        '垈',
        '埭',
        '岱',
        '帒',
        '带',
        '帯',
        '帶',
        '廗',
        '怠',
        '戴',
        '曃',
        '柋',
        '殆',
        '瀻',
        '玳',
        '瑇',
        '甙',
        '簤',
        '紿',
        '緿',
        '绐',
        '艜',
        '蝳',
        '袋',
        '襶',
        '貣',
        '贷',
        '蹛',
        '軑',
        '軚',
        '軩',
        '轪',
        '迨',
        '霴',
        '靆',
        '鴏',
        '黛',
        '黱',
    ],
    'lìng líng lǐng': ['令'],
    chào: ['仦', '耖', '觘'],
    'cháng zhǎng': ['仧', '兏', '長', '长'],
    sā: ['仨'],
    cháng: [
        '仩',
        '偿',
        '償',
        '嘗',
        '嚐',
        '嫦',
        '尝',
        '常',
        '徜',
        '瑺',
        '瓺',
        '甞',
        '肠',
        '腸',
        '膓',
        '苌',
        '萇',
        '镸',
        '鱨',
        '鲿',
    ],
    yí: [
        '仪',
        '侇',
        '儀',
        '冝',
        '匜',
        '咦',
        '圯',
        '夷',
        '姨',
        '宐',
        '宜',
        '宧',
        '寲',
        '峓',
        '嶬',
        '嶷',
        '巸',
        '彛',
        '彜',
        '彝',
        '彞',
        '怡',
        '恞',
        '扅',
        '暆',
        '栘',
        '椬',
        '椸',
        '沂',
        '洟',
        '熪',
        '瓵',
        '痍',
        '移',
        '簃',
        '籎',
        '羠',
        '胰',
        '萓',
        '蛦',
        '螔',
        '觺',
        '謻',
        '貽',
        '贻',
        '跠',
        '迻',
        '遺',
        '鏔',
        '頉',
        '頤',
        '頥',
        '顊',
        '颐',
        '饴',
        '鮧',
        '鴺',
    ],
    mù: [
        '仫',
        '凩',
        '募',
        '墓',
        '幕',
        '幙',
        '慔',
        '慕',
        '暮',
        '暯',
        '木',
        '楘',
        '毣',
        '沐',
        '炑',
        '牧',
        '狇',
        '目',
        '睦',
        '穆',
        '艒',
        '苜',
        '莯',
        '蚞',
        '鉬',
        '钼',
        '雮',
        '霂',
    ],
    'men mén': ['们'],
    fǎn: ['仮', '反', '橎', '返'],
    'chào miǎo': ['仯'],
    'yǎng áng': ['仰'],
    zhòng: [
        '仲',
        '众',
        '堹',
        '妕',
        '媑',
        '狆',
        '眾',
        '祌',
        '筗',
        '茽',
        '蚛',
        '衆',
        '衶',
        '諥',
    ],
    'pǐ pí': ['仳'],
    wò: [
        '仴',
        '偓',
        '卧',
        '媉',
        '幄',
        '握',
        '楃',
        '沃',
        '渥',
        '濣',
        '瓁',
        '瞃',
        '硪',
        '肟',
        '腛',
        '臥',
        '齷',
        '龌',
    ],
    jiàn: [
        '件',
        '俴',
        '健',
        '僭',
        '剑',
        '剣',
        '剱',
        '劍',
        '劎',
        '劒',
        '劔',
        '墹',
        '寋',
        '建',
        '徤',
        '擶',
        '旔',
        '楗',
        '毽',
        '洊',
        '涧',
        '澗',
        '牮',
        '珔',
        '瞷',
        '磵',
        '礀',
        '箭',
        '糋',
        '繝',
        '腱',
        '臶',
        '舰',
        '艦',
        '荐',
        '薦',
        '覸',
        '諓',
        '諫',
        '譛',
        '谏',
        '賎',
        '賤',
        '贱',
        '趝',
        '践',
        '踐',
        '踺',
        '轞',
        '鉴',
        '鍳',
        '鍵',
        '鐱',
        '鑑',
        '鑒',
        '鑬',
        '鑳',
        '键',
        '間',
        '餞',
        '饯',
        '𬣡',
    ],
    'jià jiè jie': ['价'],
    'yǎo fó': ['仸'],
    'rèn rén': ['任'],
    'fèn bīn': ['份'],
    dī: [
        '仾',
        '低',
        '啲',
        '埞',
        '堤',
        '岻',
        '彽',
        '樀',
        '滴',
        '磾',
        '秪',
        '羝',
        '袛',
        '趆',
        '隄',
        '鞮',
        '䃅',
    ],
    fǎng: [
        '仿',
        '倣',
        '旊',
        '昉',
        '昘',
        '瓬',
        '眆',
        '紡',
        '纺',
        '舫',
        '訪',
        '访',
        '髣',
        '鶭',
    ],
    zhōng: [
        '伀',
        '刣',
        '妐',
        '幒',
        '彸',
        '忠',
        '柊',
        '汷',
        '泈',
        '炂',
        '盅',
        '籦',
        '終',
        '终',
        '舯',
        '蔠',
        '蜙',
        '螤',
        '螽',
        '衳',
        '衷',
        '蹱',
        '鈡',
        '鍾',
        '鐘',
        '钟',
        '锺',
        '鴤',
        '鼨',
    ],
    pèi: [
        '伂',
        '佩',
        '姵',
        '帔',
        '斾',
        '旆',
        '沛',
        '浿',
        '珮',
        '蓜',
        '轡',
        '辔',
        '配',
        '霈',
        '馷',
    ],
    diào: [
        '伄',
        '吊',
        '弔',
        '掉',
        '瘹',
        '盄',
        '窎',
        '窵',
        '竨',
        '訋',
        '釣',
        '鈟',
        '銱',
        '鋽',
        '鑃',
        '钓',
        '铞',
        '雿',
        '魡',
    ],
    dùn: [
        '伅',
        '潡',
        '炖',
        '燉',
        '盾',
        '砘',
        '碷',
        '踲',
        '逇',
        '遁',
        '遯',
        '鈍',
        '钝',
    ],
    wěn: ['伆', '刎', '吻', '呅', '抆', '桽', '稳', '穏', '穩', '紊', '肳', '脗'],
    xǐn: ['伈'],
    kàng: ['伉', '匟', '囥', '抗', '炕', '鈧', '钪'],
    ài: [
        '伌',
        '僾',
        '塧',
        '壒',
        '嫒',
        '嬡',
        '愛',
        '懓',
        '暧',
        '曖',
        '爱',
        '瑷',
        '璦',
        '皧',
        '瞹',
        '砹',
        '硋',
        '碍',
        '礙',
        '薆',
        '譺',
        '賹',
        '鑀',
        '隘',
        '靉',
        '餲',
        '馤',
        '鱫',
        '鴱',
    ],
    'jì qí': ['伎', '薺'],
    'xiū xǔ': ['休'],
    'jìn yín': ['伒'],
    dǎn: [
        '伔',
        '刐',
        '撢',
        '玬',
        '瓭',
        '紞',
        '胆',
        '膽',
        '衴',
        '賧',
        '赕',
        '黕',
        '𬘘',
    ],
    fū: [
        '伕',
        '呋',
        '娐',
        '孵',
        '尃',
        '怤',
        '懯',
        '敷',
        '旉',
        '玞',
        '砆',
        '稃',
        '筟',
        '糐',
        '綒',
        '肤',
        '膚',
        '荂',
        '荴',
        '衭',
        '趺',
        '跗',
        '邞',
        '鄜',
        '酜',
        '鈇',
        '麩',
        '麬',
        '麱',
        '麸',
        '𫓧',
    ],
    tǎng: [
        '伖',
        '傥',
        '儻',
        '埫',
        '戃',
        '曭',
        '爣',
        '矘',
        '躺',
        '鎲',
        '钂',
        '镋',
    ],
    yōu: [
        '优',
        '優',
        '呦',
        '嚘',
        '峳',
        '幽',
        '忧',
        '悠',
        '憂',
        '攸',
        '櫌',
        '滺',
        '瀀',
        '纋',
        '羪',
        '耰',
        '逌',
        '鄾',
        '麀',
    ],
    huǒ: ['伙', '夥', '火', '煷', '邩', '鈥', '钬'],
    'huì kuài': ['会', '會', '浍', '璯'],
    yǔ: [
        '伛',
        '俁',
        '俣',
        '偊',
        '傴',
        '匬',
        '噳',
        '圄',
        '圉',
        '宇',
        '寙',
        '屿',
        '嶼',
        '庾',
        '挧',
        '敔',
        '斞',
        '楀',
        '瑀',
        '瘐',
        '祤',
        '禹',
        '穥',
        '窳',
        '羽',
        '與',
        '萭',
        '貐',
        '鄅',
        '頨',
        '麌',
        '齬',
        '龉',
        '㺄',
    ],
    cuì: [
        '伜',
        '啛',
        '忰',
        '悴',
        '毳',
        '淬',
        '焠',
        '疩',
        '瘁',
        '竁',
        '粋',
        '粹',
        '紣',
        '綷',
        '翆',
        '翠',
        '脃',
        '脆',
        '脺',
        '膬',
        '膵',
        '臎',
        '萃',
        '襊',
        '顇',
    ],
    sǎn: ['伞', '傘', '糤', '繖', '饊', '馓'],
    wěi: [
        '伟',
        '伪',
        '偉',
        '偽',
        '僞',
        '儰',
        '娓',
        '寪',
        '屗',
        '崣',
        '嶉',
        '徫',
        '愇',
        '捤',
        '暐',
        '梶',
        '洧',
        '浘',
        '渨',
        '炜',
        '煒',
        '猥',
        '玮',
        '瑋',
        '痿',
        '緯',
        '纬',
        '腲',
        '艉',
        '芛',
        '苇',
        '荱',
        '萎',
        '葦',
        '蒍',
        '蔿',
        '蜼',
        '諉',
        '诿',
        '踓',
        '鍡',
        '韑',
        '韙',
        '韡',
        '韪',
        '頠',
        '颹',
        '骩',
        '骪',
        '骫',
        '鮪',
        '鲔',
        '𫇭',
        '𬀩',
        '𬱟',
    ],
    'chuán zhuàn': ['传', '傳'],
    'chē jū': ['伡', '俥', '车'],
    'jū chē': ['車'],
    yá: [
        '伢',
        '厑',
        '厓',
        '堐',
        '岈',
        '崕',
        '崖',
        '涯',
        '漄',
        '牙',
        '玡',
        '琊',
        '睚',
        '笌',
        '芽',
        '蚜',
        '衙',
        '齖',
    ],
    qiàn: [
        '伣',
        '俔',
        '倩',
        '儙',
        '刋',
        '壍',
        '嬱',
        '悓',
        '棈',
        '椠',
        '槧',
        '欠',
        '歉',
        '皘',
        '篏',
        '篟',
        '縴',
        '芡',
        '蒨',
        '蔳',
        '輤',
        '𬘬',
    ],
    shāng: [
        '伤',
        '傷',
        '商',
        '墒',
        '慯',
        '殇',
        '殤',
        '滳',
        '漡',
        '熵',
        '蔏',
        '螪',
        '觞',
        '觴',
        '謪',
        '鬺',
    ],
    chāng: [
        '伥',
        '倀',
        '娼',
        '昌',
        '椙',
        '淐',
        '猖',
        '琩',
        '菖',
        '裮',
        '錩',
        '锠',
        '閶',
        '阊',
        '鯧',
        '鲳',
        '鼚',
    ],
    'chen cāng': ['伧'],
    xùn: [
        '伨',
        '侚',
        '卂',
        '噀',
        '巺',
        '巽',
        '徇',
        '愻',
        '殉',
        '殾',
        '汛',
        '潠',
        '狥',
        '蕈',
        '訊',
        '訓',
        '訙',
        '训',
        '讯',
        '迅',
        '迿',
        '逊',
        '遜',
        '鑂',
        '顨',
        '馴',
        '驯',
    ],
    xìn: ['伩', '囟', '孞', '脪', '舋', '衅', '訫', '釁', '阠', '顖'],
    chǐ: [
        '伬',
        '侈',
        '卶',
        '叺',
        '呎',
        '垑',
        '恥',
        '歯',
        '耻',
        '肔',
        '胣',
        '蚇',
        '裭',
        '褫',
        '豉',
        '鉹',
        '齒',
        '齿',
    ],
    'xián xuán': ['伭'],
    'nú nǔ': ['伮'],
    'bó bǎi': ['伯'],
    'gū gù': ['估'],
    nǐ: ['伱', '你', '儞', '孴', '拟', '擬', '旎', '晲', '狔', '苨', '薿', '隬'],
    'nì ní': ['伲'],
    bàn: [
        '伴',
        '办',
        '半',
        '姅',
        '怑',
        '扮',
        '瓣',
        '秚',
        '絆',
        '绊',
        '辦',
        '鉡',
        '靽',
    ],
    xù: [
        '伵',
        '侐',
        '勖',
        '勗',
        '卹',
        '叙',
        '垿',
        '壻',
        '婿',
        '序',
        '恤',
        '敍',
        '敘',
        '旭',
        '昫',
        '朂',
        '槒',
        '欰',
        '殈',
        '汿',
        '沀',
        '洫',
        '溆',
        '漵',
        '潊',
        '烅',
        '烼',
        '煦',
        '獝',
        '珬',
        '盢',
        '瞁',
        '稸',
        '絮',
        '続',
        '緒',
        '緖',
        '續',
        '绪',
        '续',
        '聓',
        '聟',
        '蓄',
        '藚',
        '訹',
        '賉',
        '酗',
        '頊',
        '鱮',
        '㳚',
    ],
    zhòu: [
        '伷',
        '僽',
        '冑',
        '呪',
        '咒',
        '咮',
        '宙',
        '昼',
        '晝',
        '甃',
        '皱',
        '皺',
        '籀',
        '籒',
        '籕',
        '粙',
        '紂',
        '縐',
        '纣',
        '绉',
        '胄',
        '荮',
        '葤',
        '詋',
        '酎',
        '駎',
        '驟',
        '骤',
        '㤘',
        '㑇',
    ],
    shēn: [
        '伸',
        '侁',
        '兟',
        '呻',
        '堔',
        '妽',
        '娠',
        '屾',
        '峷',
        '扟',
        '敒',
        '曑',
        '柛',
        '氠',
        '深',
        '燊',
        '珅',
        '甡',
        '甧',
        '申',
        '眒',
        '砷',
        '穼',
        '籶',
        '籸',
        '糂',
        '紳',
        '绅',
        '罙',
        '罧',
        '葠',
        '蓡',
        '蔘',
        '薓',
        '裑',
        '訷',
        '詵',
        '诜',
        '身',
        '駪',
        '鯓',
        '鯵',
        '鰺',
        '鲹',
        '鵢',
        '𬳽',
    ],
    qū: [
        '伹',
        '佉',
        '匤',
        '呿',
        '坥',
        '屈',
        '岖',
        '岴',
        '嶇',
        '憈',
        '抾',
        '敺',
        '浀',
        '煀',
        '祛',
        '筁',
        '粬',
        '胠',
        '蛆',
        '蛐',
        '袪',
        '覻',
        '詘',
        '诎',
        '趍',
        '躯',
        '軀',
        '阹',
        '駆',
        '駈',
        '驅',
        '驱',
        '髷',
        '魼',
        '鰸',
        '鱋',
        '鶌',
        '麯',
        '麴',
        '麹',
        '黢',
        '㭕',
        '𪨰',
        '䓛',
    ],
    'sì cì': ['伺'],
    bēng: ['伻', '嘣', '奟', '崩', '嵭', '閍'],
    'sì shì': ['似'],
    'jiā qié gā': ['伽'],
    'yǐ chì': ['佁'],
    'diàn tián': ['佃', '钿'],
    'hān gàn': ['佄'],
    mài: [
        '佅',
        '劢',
        '勱',
        '卖',
        '唛',
        '売',
        '脈',
        '衇',
        '賣',
        '迈',
        '邁',
        '霡',
        '霢',
        '麥',
        '麦',
        '鿏',
    ],
    dàn: [
        '但',
        '僤',
        '啖',
        '啗',
        '啿',
        '噉',
        '嚪',
        '帎',
        '憺',
        '旦',
        '柦',
        '氮',
        '沊',
        '泹',
        '淡',
        '狚',
        '疍',
        '癚',
        '禫',
        '窞',
        '腅',
        '萏',
        '蓞',
        '蛋',
        '蜑',
        '觛',
        '訑',
        '誕',
        '诞',
        '贉',
        '霮',
        '餤',
        '饏',
        '駳',
        '髧',
        '鴠',
        '𫢸',
    ],
    bù: [
        '佈',
        '勏',
        '吥',
        '咘',
        '埗',
        '埠',
        '布',
        '廍',
        '怖',
        '悑',
        '步',
        '歨',
        '歩',
        '瓿',
        '篰',
        '荹',
        '蔀',
        '踄',
        '部',
        '郶',
        '鈈',
        '钚',
        '餢',
    ],
    bǐ: [
        '佊',
        '俾',
        '匕',
        '夶',
        '妣',
        '彼',
        '朼',
        '柀',
        '比',
        '毞',
        '沘',
        '疕',
        '秕',
        '笔',
        '筆',
        '粃',
        '聛',
        '舭',
        '貏',
        '鄙',
    ],
    'zhāo shào': ['佋'],
    cǐ: ['佌', '此', '泚', '皉', '𫚖'],
    wèi: [
        '位',
        '卫',
        '味',
        '喂',
        '墛',
        '媦',
        '慰',
        '懀',
        '未',
        '渭',
        '煟',
        '熭',
        '犚',
        '猬',
        '畏',
        '緭',
        '罻',
        '胃',
        '苿',
        '菋',
        '藯',
        '蘶',
        '蝟',
        '螱',
        '衛',
        '衞',
        '褽',
        '謂',
        '讆',
        '讏',
        '谓',
        '躗',
        '躛',
        '軎',
        '轊',
        '鏏',
        '霨',
        '餧',
        '餵',
        '饖',
        '魏',
        '鮇',
        '鳚',
    ],
    zuǒ: ['佐', '左', '繓'],
    yǎng: [
        '佒',
        '傟',
        '养',
        '坱',
        '岟',
        '慃',
        '懩',
        '攁',
        '氧',
        '氱',
        '炴',
        '痒',
        '癢',
        '礢',
        '紻',
        '蝆',
        '軮',
        '養',
        '駚',
    ],
    'tǐ tī': ['体', '體'],
    zhàn: [
        '佔',
        '偡',
        '嶘',
        '战',
        '戦',
        '戰',
        '栈',
        '桟',
        '棧',
        '湛',
        '站',
        '綻',
        '绽',
        '菚',
        '蘸',
        '虥',
        '虦',
        '譧',
        '轏',
        '驏',
    ],
    'hé hē hè': ['何'],
    bì: [
        '佖',
        '咇',
        '哔',
        '嗶',
        '坒',
        '堛',
        '壁',
        '奰',
        '妼',
        '婢',
        '嬖',
        '币',
        '幣',
        '幤',
        '庇',
        '庳',
        '廦',
        '弊',
        '弻',
        '弼',
        '彃',
        '必',
        '怭',
        '愊',
        '愎',
        '敝',
        '斃',
        '梐',
        '毕',
        '毖',
        '毙',
        '湢',
        '滗',
        '滭',
        '潷',
        '煏',
        '熚',
        '狴',
        '獘',
        '獙',
        '珌',
        '璧',
        '畀',
        '畢',
        '疪',
        '痹',
        '痺',
        '皕',
        '睤',
        '碧',
        '筚',
        '箅',
        '箆',
        '篦',
        '篳',
        '粊',
        '綼',
        '縪',
        '繴',
        '罼',
        '腷',
        '苾',
        '荜',
        '萆',
        '萞',
        '蓖',
        '蓽',
        '蔽',
        '薜',
        '蜌',
        '袐',
        '襅',
        '襞',
        '襣',
        '觱',
        '詖',
        '诐',
        '貱',
        '贔',
        '赑',
        '跸',
        '蹕',
        '躃',
        '躄',
        '避',
        '邲',
        '鄨',
        '鄪',
        '鉍',
        '鏎',
        '鐴',
        '铋',
        '閇',
        '閉',
        '閟',
        '闭',
        '陛',
        '韠',
        '飶',
        '饆',
        '馝',
        '駜',
        '驆',
        '髀',
        '魓',
        '鮅',
        '鷝',
        '鷩',
        '鼊',
    ],
    tuó: [
        '佗',
        '坨',
        '堶',
        '岮',
        '槖',
        '橐',
        '沱',
        '砣',
        '砤',
        '碢',
        '紽',
        '詑',
        '跎',
        '酡',
        '阤',
        '陀',
        '陁',
        '駝',
        '駞',
        '騨',
        '驒',
        '驝',
        '驼',
        '鮀',
        '鴕',
        '鸵',
        '鼉',
        '鼍',
        '鼧',
        '𬶍',
    ],
    shé: ['佘', '舌', '虵', '蛥'],
    'yì dié': ['佚', '昳', '泆', '軼'],
    'fó fú bì bó': ['佛'],
    'zuò zuō': ['作'],
    gōu: [
        '佝',
        '沟',
        '溝',
        '痀',
        '篝',
        '簼',
        '緱',
        '缑',
        '袧',
        '褠',
        '鈎',
        '鉤',
        '钩',
        '鞲',
        '韝',
    ],
    nìng: ['佞', '侫', '倿', '寕', '泞', '澝', '濘'],
    qú: [
        '佢',
        '劬',
        '戵',
        '斪',
        '欋',
        '欔',
        '氍',
        '淭',
        '灈',
        '爠',
        '璖',
        '璩',
        '癯',
        '磲',
        '籧',
        '絇',
        '胊',
        '臞',
        '菃',
        '葋',
        '蕖',
        '蘧',
        '蟝',
        '蠷',
        '蠼',
        '衐',
        '衢',
        '躣',
        '軥',
        '鑺',
        '鴝',
        '鸜',
        '鸲',
        '鼩',
    ],
    'yōng yòng': ['佣'],
    wǎ: ['佤', '咓', '砙', '邷'],
    kǎ: ['佧', '垰', '胩', '裃', '鉲'],
    bāo: [
        '佨',
        '勹',
        '包',
        '孢',
        '煲',
        '笣',
        '胞',
        '苞',
        '蕔',
        '裦',
        '褒',
        '襃',
        '闁',
        '齙',
        '龅',
    ],
    'huái huí': ['佪'],
    'gé hè': ['佫'],
    lǎo: [
        '佬',
        '咾',
        '恅',
        '栳',
        '狫',
        '珯',
        '硓',
        '老',
        '耂',
        '荖',
        '蛯',
        '轑',
        '銠',
        '铑',
        '鮱',
    ],
    xiáng: ['佭', '庠', '栙', '祥', '絴', '翔', '詳', '跭'],
    gé: [
        '佮',
        '匌',
        '呄',
        '嗝',
        '塥',
        '愅',
        '挌',
        '搿',
        '槅',
        '櫊',
        '滆',
        '膈',
        '臵',
        '茖',
        '觡',
        '諽',
        '輵',
        '轕',
        '閣',
        '阁',
        '隔',
        '鞷',
        '韐',
        '韚',
        '騔',
        '骼',
        '鮯',
    ],
    yáng: [
        '佯',
        '劷',
        '垟',
        '崸',
        '徉',
        '扬',
        '揚',
        '敭',
        '旸',
        '昜',
        '暘',
        '杨',
        '楊',
        '洋',
        '炀',
        '珜',
        '疡',
        '瘍',
        '眻',
        '蛘',
        '諹',
        '輰',
        '鍚',
        '钖',
        '阦',
        '阳',
        '陽',
        '霷',
        '颺',
        '飏',
        '鰑',
        '鴹',
        '鸉',
    ],
    bǎi: ['佰', '捭', '摆', '擺', '栢', '百', '竡', '粨', '襬'],
    fǎ: ['佱', '峜', '法', '灋', '砝', '鍅'],
    mǐng: ['佲', '凕', '姳', '慏', '酩'],
    'èr nài': ['佴'],
    hěn: ['佷', '很', '狠', '詪', '𬣳'],
    huó: ['佸', '活'],
    guǐ: [
        '佹',
        '匦',
        '匭',
        '厬',
        '垝',
        '姽',
        '宄',
        '庋',
        '庪',
        '恑',
        '晷',
        '湀',
        '癸',
        '祪',
        '簋',
        '蛫',
        '蟡',
        '觤',
        '詭',
        '诡',
        '軌',
        '轨',
        '陒',
        '鬼',
    ],
    quán: [
        '佺',
        '全',
        '啳',
        '埢',
        '姾',
        '峑',
        '巏',
        '拳',
        '搼',
        '权',
        '楾',
        '権',
        '權',
        '泉',
        '洤',
        '湶',
        '牷',
        '犈',
        '瑔',
        '痊',
        '硂',
        '筌',
        '縓',
        '荃',
        '葲',
        '蜷',
        '蠸',
        '觠',
        '詮',
        '诠',
        '跧',
        '踡',
        '輇',
        '辁',
        '醛',
        '銓',
        '铨',
        '闎',
        '顴',
        '颧',
        '駩',
        '騡',
        '鬈',
        '鰁',
        '鳈',
        '齤',
    ],
    tiāo: ['佻', '庣', '旫', '祧', '聎'],
    jiǎo: [
        '佼',
        '儌',
        '孂',
        '挢',
        '搅',
        '撟',
        '撹',
        '攪',
        '敫',
        '敽',
        '敿',
        '晈',
        '暞',
        '曒',
        '灚',
        '燞',
        '狡',
        '璬',
        '皎',
        '皦',
        '絞',
        '纐',
        '绞',
        '腳',
        '臫',
        '蟜',
        '譑',
        '賋',
        '踋',
        '鉸',
        '铰',
        '餃',
        '饺',
        '鱎',
        '龣',
    ],
    cì: [
        '佽',
        '刾',
        '庛',
        '朿',
        '栨',
        '次',
        '絘',
        '茦',
        '莿',
        '蛓',
        '螆',
        '賜',
        '赐',
    ],
    xíng: [
        '侀',
        '刑',
        '哘',
        '型',
        '娙',
        '形',
        '洐',
        '硎',
        '蛵',
        '邢',
        '郉',
        '鈃',
        '鉶',
        '銒',
        '钘',
        '铏',
        '陉',
        '陘',
        '餳',
        '𫰛',
    ],
    tuō: [
        '侂',
        '咃',
        '咜',
        '圫',
        '托',
        '拕',
        '拖',
        '汑',
        '脫',
        '脱',
        '莌',
        '袥',
        '託',
        '讬',
        '飥',
        '饦',
        '魠',
        '鮵',
    ],
    kǎn: ['侃', '偘', '冚', '坎', '惂', '砍', '莰', '輡', '轗', '顑'],
    zhí: [
        '侄',
        '値',
        '值',
        '埴',
        '執',
        '姪',
        '嬂',
        '戠',
        '执',
        '摭',
        '植',
        '樴',
        '淔',
        '漐',
        '直',
        '禃',
        '絷',
        '縶',
        '聀',
        '职',
        '職',
        '膱',
        '蟙',
        '跖',
        '踯',
        '蹠',
        '躑',
        '軄',
        '釞',
        '馽',
    ],
    gāi: [
        '侅',
        '垓',
        '姟',
        '峐',
        '晐',
        '畡',
        '祴',
        '荄',
        '該',
        '该',
        '豥',
        '賅',
        '賌',
        '赅',
        '陔',
    ],
    lái: [
        '來',
        '俫',
        '倈',
        '崃',
        '崍',
        '庲',
        '来',
        '梾',
        '棶',
        '涞',
        '淶',
        '猍',
        '琜',
        '筙',
        '箂',
        '莱',
        '萊',
        '逨',
        '郲',
        '錸',
        '铼',
        '騋',
        '鯠',
        '鶆',
        '麳',
    ],
    kuǎ: ['侉', '咵', '垮', '銙'],
    gōng: [
        '侊',
        '公',
        '功',
        '匑',
        '匔',
        '塨',
        '宫',
        '宮',
        '工',
        '幊',
        '弓',
        '恭',
        '攻',
        '杛',
        '碽',
        '糼',
        '糿',
        '肱',
        '觥',
        '觵',
        '躬',
        '躳',
        '髸',
        '龔',
        '龚',
        '䢼',
    ],
    lì: [
        '例',
        '俐',
        '俪',
        '傈',
        '儮',
        '儷',
        '凓',
        '利',
        '力',
        '励',
        '勵',
        '历',
        '厉',
        '厤',
        '厯',
        '厲',
        '叓',
        '吏',
        '呖',
        '唎',
        '唳',
        '嚦',
        '囇',
        '坜',
        '塛',
        '壢',
        '娳',
        '婯',
        '屴',
        '岦',
        '悧',
        '悷',
        '慄',
        '戾',
        '搮',
        '暦',
        '曆',
        '曞',
        '朸',
        '枥',
        '栃',
        '栗',
        '栛',
        '檪',
        '櫔',
        '櫪',
        '欐',
        '歴',
        '歷',
        '沥',
        '沴',
        '涖',
        '溧',
        '濿',
        '瀝',
        '爏',
        '犡',
        '猁',
        '珕',
        '瑮',
        '瓅',
        '瓑',
        '瓥',
        '疬',
        '痢',
        '癧',
        '盭',
        '睙',
        '砅',
        '砺',
        '砾',
        '磿',
        '礪',
        '礫',
        '礰',
        '禲',
        '秝',
        '立',
        '笠',
        '篥',
        '粒',
        '粝',
        '糲',
        '脷',
        '苈',
        '茘',
        '荔',
        '莅',
        '莉',
        '蒚',
        '蒞',
        '藶',
        '蚸',
        '蛎',
        '蛠',
        '蜧',
        '蝷',
        '蠇',
        '蠣',
        '詈',
        '讈',
        '赲',
        '轢',
        '轣',
        '轹',
        '酈',
        '鉝',
        '隶',
        '隷',
        '雳',
        '靂',
        '靋',
        '鬁',
        '鳨',
        '鴗',
        '鷅',
        '麜',
        '𫵷',
        '𬍛',
    ],
    yīn: [
        '侌',
        '凐',
        '喑',
        '噾',
        '囙',
        '因',
        '垔',
        '堙',
        '姻',
        '婣',
        '愔',
        '慇',
        '栶',
        '氤',
        '洇',
        '溵',
        '濦',
        '瘖',
        '禋',
        '秵',
        '筃',
        '絪',
        '緸',
        '茵',
        '蒑',
        '蔭',
        '裀',
        '諲',
        '銦',
        '铟',
        '闉',
        '阥',
        '阴',
        '陰',
        '陻',
        '隂',
        '霒',
        '霠',
        '鞇',
        '音',
        '韾',
        '駰',
        '骃',
        '齗',
        '𬘡',
        '𬤇',
        '𬮱',
    ],
    mǐ: [
        '侎',
        '孊',
        '弭',
        '敉',
        '洣',
        '渳',
        '灖',
        '米',
        '粎',
        '羋',
        '脒',
        '芈',
        '葞',
        '蔝',
        '銤',
    ],
    zhū: [
        '侏',
        '株',
        '槠',
        '橥',
        '櫧',
        '櫫',
        '洙',
        '潴',
        '瀦',
        '猪',
        '珠',
        '硃',
        '秼',
        '絑',
        '茱',
        '蕏',
        '蛛',
        '蝫',
        '蠩',
        '袾',
        '誅',
        '諸',
        '诛',
        '诸',
        '豬',
        '跦',
        '邾',
        '銖',
        '铢',
        '駯',
        '鮢',
        '鯺',
        '鴸',
        '鼄',
    ],
    ān: [
        '侒',
        '偣',
        '媕',
        '安',
        '峖',
        '庵',
        '桉',
        '氨',
        '盦',
        '盫',
        '腤',
        '菴',
        '萻',
        '葊',
        '蓭',
        '誝',
        '諳',
        '谙',
        '鞌',
        '鞍',
        '韽',
        '馣',
        '鮟',
        '鵪',
        '鶕',
        '鹌',
        '𩽾',
    ],
    lù: [
        '侓',
        '僇',
        '勎',
        '勠',
        '圥',
        '坴',
        '塶',
        '娽',
        '峍',
        '廘',
        '彔',
        '录',
        '戮',
        '摝',
        '椂',
        '樚',
        '淕',
        '淥',
        '渌',
        '漉',
        '潞',
        '琭',
        '璐',
        '甪',
        '盝',
        '睩',
        '硉',
        '祿',
        '禄',
        '稑',
        '穋',
        '箓',
        '簏',
        '簬',
        '簵',
        '簶',
        '籙',
        '粶',
        '蔍',
        '蕗',
        '虂',
        '螰',
        '賂',
        '赂',
        '趢',
        '路',
        '踛',
        '蹗',
        '輅',
        '轆',
        '辂',
        '辘',
        '逯',
        '醁',
        '錄',
        '録',
        '錴',
        '鏴',
        '陸',
        '騄',
        '騼',
        '鯥',
        '鴼',
        '鵦',
        '鵱',
        '鷺',
        '鹭',
        '鹿',
        '麓',
        '𫘧',
    ],
    móu: ['侔', '劺', '恈', '眸', '蛑', '謀', '谋', '踎', '鍪', '鴾', '麰'],
    ér: [
        '侕',
        '儿',
        '児',
        '兒',
        '峏',
        '栭',
        '洏',
        '粫',
        '而',
        '胹',
        '荋',
        '袻',
        '輀',
        '轜',
        '陑',
        '隭',
        '髵',
        '鮞',
        '鲕',
        '鴯',
        '鸸',
    ],
    'dòng tǒng tóng': ['侗'],
    chà: ['侘', '奼', '姹', '岔', '汊', '詫', '诧'],
    chì: [
        '侙',
        '傺',
        '勅',
        '勑',
        '叱',
        '啻',
        '彳',
        '恜',
        '慗',
        '憏',
        '懘',
        '抶',
        '敕',
        '斥',
        '杘',
        '湁',
        '灻',
        '炽',
        '烾',
        '熾',
        '痓',
        '痸',
        '瘛',
        '翄',
        '翅',
        '翤',
        '翨',
        '腟',
        '赤',
        '趩',
        '遫',
        '鉓',
        '雴',
        '飭',
        '饬',
        '鶒',
        '鷘',
    ],
    'gòng gōng': ['供', '共'],
    zhōu: [
        '侜',
        '周',
        '喌',
        '州',
        '徟',
        '洲',
        '淍',
        '炿',
        '烐',
        '珘',
        '矪',
        '舟',
        '謅',
        '譸',
        '诌',
        '賙',
        '赒',
        '輈',
        '輖',
        '辀',
        '週',
        '郮',
        '銂',
        '霌',
        '駲',
        '騆',
        '鵃',
        '鸼',
    ],
    rú: [
        '侞',
        '儒',
        '嚅',
        '如',
        '嬬',
        '孺',
        '帤',
        '曘',
        '桇',
        '渪',
        '濡',
        '筎',
        '茹',
        '蕠',
        '薷',
        '蝡',
        '蠕',
        '袽',
        '襦',
        '邚',
        '醹',
        '銣',
        '铷',
        '顬',
        '颥',
        '鱬',
        '鴑',
        '鴽',
    ],
    'jiàn cún': ['侟'],
    xiá: [
        '侠',
        '俠',
        '匣',
        '峡',
        '峽',
        '敮',
        '暇',
        '柙',
        '炠',
        '烚',
        '狎',
        '狭',
        '狹',
        '珨',
        '瑕',
        '硖',
        '硤',
        '碬',
        '祫',
        '筪',
        '縖',
        '翈',
        '舝',
        '舺',
        '蕸',
        '赮',
        '轄',
        '辖',
        '遐',
        '鍜',
        '鎋',
        '陜',
        '陿',
        '霞',
        '騢',
        '魻',
        '鶷',
        '黠',
    ],
    lǚ: [
        '侣',
        '侶',
        '儢',
        '吕',
        '呂',
        '屡',
        '屢',
        '履',
        '挔',
        '捛',
        '旅',
        '梠',
        '焒',
        '祣',
        '稆',
        '穭',
        '絽',
        '縷',
        '缕',
        '膂',
        '膐',
        '褛',
        '褸',
        '郘',
        '鋁',
        '铝',
    ],
    ta: ['侤'],
    'jiǎo yáo': ['侥', '僥', '徺'],
    zhēn: [
        '侦',
        '偵',
        '寊',
        '帧',
        '帪',
        '幀',
        '搸',
        '斟',
        '桢',
        '楨',
        '榛',
        '樼',
        '殝',
        '浈',
        '湞',
        '潧',
        '澵',
        '獉',
        '珍',
        '珎',
        '瑧',
        '甄',
        '眞',
        '真',
        '砧',
        '碪',
        '祯',
        '禎',
        '禛',
        '箴',
        '胗',
        '臻',
        '葴',
        '蒖',
        '蓁',
        '薽',
        '貞',
        '贞',
        '轃',
        '遉',
        '酙',
        '針',
        '鉁',
        '錱',
        '鍼',
        '针',
        '鱵',
    ],
    'cè zè zhāi': ['侧', '側'],
    kuài: [
        '侩',
        '儈',
        '凷',
        '哙',
        '噲',
        '圦',
        '块',
        '塊',
        '巜',
        '廥',
        '快',
        '旝',
        '欳',
        '狯',
        '獪',
        '筷',
        '糩',
        '脍',
        '膾',
        '郐',
        '鄶',
        '鱠',
        '鲙',
    ],
    chái: ['侪', '儕', '喍', '柴', '犲', '祡', '豺'],
    nóng: [
        '侬',
        '儂',
        '农',
        '哝',
        '噥',
        '檂',
        '欁',
        '浓',
        '濃',
        '燶',
        '禯',
        '秾',
        '穠',
        '脓',
        '膿',
        '蕽',
        '襛',
        '譨',
        '農',
        '辳',
        '醲',
        '鬞',
        '𬪩',
    ],
    jǐn: [
        '侭',
        '儘',
        '卺',
        '厪',
        '巹',
        '槿',
        '漌',
        '瑾',
        '紧',
        '緊',
        '菫',
        '蓳',
        '謹',
        '谨',
        '錦',
        '锦',
        '饉',
        '馑',
    ],
    'hóu hòu': ['侯', '矦'],
    jiǒng: [
        '侰',
        '僒',
        '冏',
        '囧',
        '泂',
        '澃',
        '炯',
        '烱',
        '煚',
        '煛',
        '熲',
        '燛',
        '窘',
        '綗',
        '褧',
        '迥',
        '逈',
        '顈',
        '颎',
        '䌹',
    ],
    'chěng tǐng': ['侱'],
    'zhèn zhēn': ['侲', '揕'],
    zuò: [
        '侳',
        '做',
        '唑',
        '坐',
        '岝',
        '岞',
        '座',
        '祚',
        '糳',
        '胙',
        '葃',
        '葄',
        '蓙',
        '袏',
        '阼',
    ],
    qīn: [
        '侵',
        '兓',
        '媇',
        '嵚',
        '嶔',
        '欽',
        '衾',
        '誛',
        '钦',
        '顉',
        '駸',
        '骎',
        '鮼',
    ],
    jú: [
        '侷',
        '啹',
        '婅',
        '局',
        '巈',
        '椈',
        '橘',
        '泦',
        '淗',
        '湨',
        '焗',
        '犑',
        '狊',
        '粷',
        '菊',
        '蘜',
        '趜',
        '跼',
        '蹫',
        '輂',
        '郹',
        '閰',
        '駶',
        '驧',
        '鵙',
        '鵴',
        '鶪',
        '鼰',
        '鼳',
        '䴗',
    ],
    'shù dōu': ['侸'],
    tǐng: [
        '侹',
        '圢',
        '娗',
        '挺',
        '涏',
        '烶',
        '珽',
        '脡',
        '艇',
        '誔',
        '頲',
        '颋',
    ],
    shèn: [
        '侺',
        '愼',
        '慎',
        '昚',
        '涁',
        '渗',
        '滲',
        '瘆',
        '瘮',
        '眘',
        '祳',
        '肾',
        '胂',
        '脤',
        '腎',
        '蜃',
        '蜄',
        '鋠',
    ],
    'tuì tuó': ['侻'],
    nán: [
        '侽',
        '喃',
        '娚',
        '抩',
        '暔',
        '枏',
        '柟',
        '楠',
        '男',
        '畘',
        '莮',
        '萳',
        '遖',
    ],
    xiāo: [
        '侾',
        '哓',
        '嘵',
        '嚻',
        '囂',
        '婋',
        '宯',
        '宵',
        '庨',
        '彇',
        '揱',
        '枭',
        '枵',
        '梟',
        '櫹',
        '歊',
        '毊',
        '消',
        '潇',
        '瀟',
        '灱',
        '灲',
        '烋',
        '焇',
        '猇',
        '獢',
        '痚',
        '痟',
        '硝',
        '硣',
        '窙',
        '箫',
        '簘',
        '簫',
        '綃',
        '绡',
        '翛',
        '膮',
        '萧',
        '蕭',
        '虈',
        '虓',
        '蟂',
        '蟏',
        '蟰',
        '蠨',
        '踃',
        '逍',
        '銷',
        '销',
        '霄',
        '颵',
        '驍',
        '骁',
        '髇',
        '髐',
        '魈',
        '鴞',
        '鴵',
        '鷍',
        '鸮',
    ],
    'biàn pián': ['便', '緶', '缏'],
    tuǐ: ['俀', '腿', '蹆', '骽'],
    xì: [
        '係',
        '匸',
        '卌',
        '呬',
        '墍',
        '屃',
        '屓',
        '屭',
        '忥',
        '怬',
        '恄',
        '椞',
        '潝',
        '潟',
        '澙',
        '熂',
        '犔',
        '磶',
        '禊',
        '細',
        '綌',
        '縘',
        '细',
        '绤',
        '舃',
        '舄',
        '蕮',
        '虩',
        '衋',
        '覤',
        '赩',
        '趇',
        '郤',
        '釳',
        '阋',
        '隙',
        '隟',
        '霼',
        '餼',
        '饩',
        '鬩',
        '黖',
    ],
    cù: [
        '促',
        '媨',
        '憱',
        '猝',
        '瘄',
        '瘯',
        '簇',
        '縬',
        '脨',
        '蔟',
        '誎',
        '趗',
        '踧',
        '踿',
        '蹙',
        '蹴',
        '蹵',
        '醋',
        '顣',
        '鼀',
    ],
    é: [
        '俄',
        '囮',
        '娥',
        '峉',
        '峨',
        '峩',
        '涐',
        '珴',
        '皒',
        '睋',
        '磀',
        '莪',
        '訛',
        '誐',
        '譌',
        '讹',
        '迗',
        '鈋',
        '鋨',
        '锇',
        '頟',
        '額',
        '额',
        '魤',
        '鵝',
        '鵞',
        '鹅',
    ],
    qiú: [
        '俅',
        '叴',
        '唒',
        '囚',
        '崷',
        '巯',
        '巰',
        '扏',
        '梂',
        '殏',
        '毬',
        '求',
        '汓',
        '泅',
        '浗',
        '湭',
        '煪',
        '犰',
        '玌',
        '球',
        '璆',
        '皳',
        '盚',
        '紌',
        '絿',
        '肍',
        '芁',
        '莍',
        '虬',
        '虯',
        '蛷',
        '裘',
        '觓',
        '觩',
        '訄',
        '訅',
        '賕',
        '赇',
        '逎',
        '逑',
        '遒',
        '酋',
        '釚',
        '釻',
        '銶',
        '頄',
        '鮂',
        '鯄',
        '鰽',
        '鼽',
        '𨱇',
    ],
    xú: ['俆', '徐', '禑'],
    'guàng kuāng': ['俇'],
    kù: [
        '俈',
        '喾',
        '嚳',
        '库',
        '庫',
        '廤',
        '瘔',
        '絝',
        '绔',
        '袴',
        '裤',
        '褲',
        '酷',
    ],
    wù: [
        '俉',
        '务',
        '務',
        '勿',
        '卼',
        '坞',
        '塢',
        '奦',
        '婺',
        '寤',
        '屼',
        '岉',
        '嵨',
        '忢',
        '悞',
        '悟',
        '悮',
        '戊',
        '扤',
        '晤',
        '杌',
        '溩',
        '焐',
        '熃',
        '物',
        '痦',
        '矹',
        '窹',
        '粅',
        '蘁',
        '誤',
        '误',
        '鋈',
        '阢',
        '隖',
        '雾',
        '霚',
        '霧',
        '靰',
        '騖',
        '骛',
        '鶩',
        '鹜',
        '鼿',
        '齀',
    ],
    jùn: [
        '俊',
        '儁',
        '呁',
        '埈',
        '寯',
        '峻',
        '懏',
        '捃',
        '攟',
        '晙',
        '棞',
        '燇',
        '珺',
        '畯',
        '竣',
        '箟',
        '蜠',
        '賐',
        '郡',
        '陖',
        '餕',
        '馂',
        '駿',
        '骏',
        '鵔',
        '鵕',
        '鵘',
        '䐃',
    ],
    liáng: [
        '俍',
        '墚',
        '梁',
        '椋',
        '樑',
        '粮',
        '粱',
        '糧',
        '良',
        '輬',
        '辌',
        '𫟅',
    ],
    zǔ: ['俎', '唨', '爼', '祖', '組', '组', '詛', '诅', '鎺', '阻', '靻'],
    'qiào xiào': ['俏'],
    yǒng: [
        '俑',
        '勇',
        '勈',
        '咏',
        '埇',
        '塎',
        '嵱',
        '彮',
        '怺',
        '恿',
        '悀',
        '惥',
        '愑',
        '愹',
        '慂',
        '柡',
        '栐',
        '永',
        '泳',
        '湧',
        '甬',
        '蛹',
        '詠',
        '踊',
        '踴',
        '鯒',
        '鲬',
    ],
    hùn: ['俒', '倱', '圂', '尡', '慁', '掍', '溷', '焝', '睴', '觨', '諢', '诨'],
    jìng: [
        '俓',
        '傹',
        '境',
        '妌',
        '婙',
        '婧',
        '弪',
        '弳',
        '径',
        '徑',
        '敬',
        '曔',
        '桱',
        '梷',
        '浄',
        '瀞',
        '獍',
        '痉',
        '痙',
        '竞',
        '竟',
        '竫',
        '競',
        '竸',
        '胫',
        '脛',
        '莖',
        '誩',
        '踁',
        '迳',
        '逕',
        '鏡',
        '镜',
        '靖',
        '静',
        '靜',
        '鵛',
    ],
    sàn: ['俕', '閐'],
    pěi: ['俖'],
    sú: ['俗'],
    xī: [
        '俙',
        '僖',
        '兮',
        '凞',
        '卥',
        '厀',
        '吸',
        '唏',
        '唽',
        '嘻',
        '噏',
        '嚱',
        '夕',
        '奚',
        '嬆',
        '嬉',
        '屖',
        '嵠',
        '巇',
        '希',
        '徆',
        '徯',
        '息',
        '悉',
        '悕',
        '惁',
        '惜',
        '昔',
        '晞',
        '晰',
        '晳',
        '曦',
        '析',
        '桸',
        '榽',
        '樨',
        '橀',
        '欷',
        '氥',
        '汐',
        '浠',
        '淅',
        '渓',
        '溪',
        '烯',
        '焁',
        '焈',
        '焟',
        '熄',
        '熈',
        '熙',
        '熹',
        '熺',
        '熻',
        '燨',
        '爔',
        '牺',
        '犀',
        '犠',
        '犧',
        '琋',
        '瘜',
        '皙',
        '睎',
        '瞦',
        '矽',
        '硒',
        '磎',
        '礂',
        '稀',
        '穸',
        '窸',
        '粞',
        '糦',
        '緆',
        '繥',
        '羲',
        '翕',
        '翖',
        '肸',
        '肹',
        '膝',
        '舾',
        '莃',
        '菥',
        '蒠',
        '蜥',
        '螅',
        '蟋',
        '蠵',
        '西',
        '觹',
        '觽',
        '觿',
        '譆',
        '谿',
        '豀',
        '豨',
        '豯',
        '貕',
        '赥',
        '邜',
        '鄎',
        '酅',
        '醯',
        '釸',
        '錫',
        '鏭',
        '鐊',
        '鑴',
        '锡',
        '隵',
        '餏',
        '饎',
        '饻',
        '鯑',
        '鵗',
        '鸂',
        '鼷',
    ],
    lǐ: [
        '俚',
        '娌',
        '峢',
        '峲',
        '李',
        '欚',
        '浬',
        '澧',
        '理',
        '礼',
        '禮',
        '粴',
        '裏',
        '裡',
        '豊',
        '逦',
        '邐',
        '醴',
        '鋰',
        '锂',
        '鯉',
        '鱧',
        '鱱',
        '鲤',
        '鳢',
    ],
    bǎo: [
        '保',
        '堢',
        '媬',
        '宝',
        '寚',
        '寳',
        '寶',
        '珤',
        '緥',
        '葆',
        '藵',
        '褓',
        '賲',
        '靌',
        '飹',
        '飽',
        '饱',
        '駂',
        '鳵',
        '鴇',
        '鸨',
    ],
    'yú shù yù': ['俞'],
    'sì qí': ['俟'],
    'xìn shēn': ['信'],
    xiū: [
        '俢',
        '修',
        '咻',
        '庥',
        '樇',
        '烌',
        '羞',
        '脙',
        '脩',
        '臹',
        '貅',
        '銝',
        '鎀',
        '飍',
        '饈',
        '馐',
        '髤',
        '髹',
        '鮴',
        '鱃',
        '鵂',
        '鸺',
        '䗛',
    ],
    dì: [
        '俤',
        '偙',
        '僀',
        '埊',
        '墑',
        '墬',
        '娣',
        '帝',
        '怟',
        '旳',
        '梊',
        '焍',
        '玓',
        '甋',
        '眱',
        '睇',
        '碲',
        '祶',
        '禘',
        '第',
        '締',
        '缔',
        '腣',
        '菂',
        '蒂',
        '蔕',
        '蝃',
        '蝭',
        '螮',
        '諦',
        '谛',
        '踶',
        '递',
        '逓',
        '遞',
        '遰',
        '鉪',
        '𤧛',
        '䗖',
    ],
    chóu: [
        '俦',
        '儔',
        '嬦',
        '惆',
        '愁',
        '懤',
        '栦',
        '燽',
        '畴',
        '疇',
        '皗',
        '稠',
        '筹',
        '籌',
        '絒',
        '綢',
        '绸',
        '菗',
        '詶',
        '讎',
        '讐',
        '踌',
        '躊',
        '酧',
        '酬',
        '醻',
        '雔',
        '雠',
        '雦',
    ],
    zhì: [
        '俧',
        '偫',
        '儨',
        '制',
        '劕',
        '垁',
        '娡',
        '寘',
        '帙',
        '帜',
        '幟',
        '庢',
        '庤',
        '廌',
        '彘',
        '徏',
        '徝',
        '志',
        '忮',
        '懥',
        '懫',
        '挃',
        '挚',
        '掷',
        '摯',
        '擲',
        '旘',
        '晊',
        '智',
        '栉',
        '桎',
        '梽',
        '櫍',
        '櫛',
        '治',
        '洷',
        '滍',
        '滞',
        '滯',
        '潌',
        '瀄',
        '炙',
        '熫',
        '狾',
        '猘',
        '璏',
        '瓆',
        '痔',
        '痣',
        '礩',
        '祑',
        '秩',
        '秷',
        '稚',
        '稺',
        '穉',
        '窒',
        '紩',
        '緻',
        '置',
        '翐',
        '膣',
        '至',
        '致',
        '芖',
        '蛭',
        '袟',
        '袠',
        '製',
        '覟',
        '觗',
        '觯',
        '觶',
        '誌',
        '豑',
        '豒',
        '貭',
        '質',
        '贄',
        '质',
        '贽',
        '跱',
        '踬',
        '躓',
        '輊',
        '轾',
        '郅',
        '銍',
        '鋕',
        '鑕',
        '铚',
        '锧',
        '陟',
        '隲',
        '雉',
        '駤',
        '騭',
        '騺',
        '驇',
        '骘',
        '鯯',
        '鴙',
        '鷙',
        '鸷',
        '𬃊',
    ],
    'liǎ liǎng': ['俩'],
    jiǎn: [
        '俭',
        '倹',
        '儉',
        '减',
        '剪',
        '堿',
        '弿',
        '彅',
        '戩',
        '戬',
        '拣',
        '挸',
        '捡',
        '揀',
        '撿',
        '枧',
        '柬',
        '梘',
        '检',
        '検',
        '檢',
        '減',
        '湕',
        '瀽',
        '瑐',
        '睑',
        '瞼',
        '硷',
        '碱',
        '礆',
        '笕',
        '筧',
        '简',
        '簡',
        '絸',
        '繭',
        '翦',
        '茧',
        '藆',
        '蠒',
        '裥',
        '襇',
        '襉',
        '襺',
        '詃',
        '謇',
        '謭',
        '譾',
        '谫',
        '趼',
        '蹇',
        '鐗',
        '鬋',
        '鰎',
        '鹸',
        '鹻',
        '鹼',
    ],
    huò: [
        '俰',
        '咟',
        '嚯',
        '嚿',
        '奯',
        '彠',
        '惑',
        '或',
        '擭',
        '旤',
        '曤',
        '檴',
        '沎',
        '湱',
        '瀖',
        '獲',
        '癨',
        '眓',
        '矐',
        '祸',
        '禍',
        '穫',
        '窢',
        '耯',
        '臛',
        '艧',
        '获',
        '蒦',
        '藿',
        '蠖',
        '謋',
        '貨',
        '货',
        '鍃',
        '鑊',
        '镬',
        '雘',
        '霍',
        '靃',
        '韄',
        '㸌',
    ],
    'jù jū': ['俱', '据', '鋸', '锯'],
    xiào: [
        '俲',
        '傚',
        '効',
        '咲',
        '哮',
        '啸',
        '嘋',
        '嘨',
        '嘯',
        '孝',
        '效',
        '斅',
        '斆',
        '歗',
        '涍',
        '熽',
        '笑',
        '詨',
        '誟',
    ],
    pái: ['俳', '徘', '牌', '犤', '猅', '簰', '簲', '輫'],
    biào: ['俵', '鰾', '鳔'],
    'chù tì': ['俶'],
    fèi: [
        '俷',
        '剕',
        '厞',
        '吠',
        '屝',
        '废',
        '廃',
        '廢',
        '昲',
        '曊',
        '櫠',
        '沸',
        '濷',
        '狒',
        '癈',
        '肺',
        '萉',
        '費',
        '费',
        '鐨',
        '镄',
        '陫',
        '靅',
        '鼣',
    ],
    fèng: ['俸', '凤', '奉', '湗', '焨', '煈', '賵', '赗', '鳯', '鳳', '鴌'],
    ǎn: ['俺', '唵', '埯', '揞', '罯', '銨', '铵'],
    bèi: [
        '俻',
        '倍',
        '偝',
        '偹',
        '備',
        '僃',
        '备',
        '悖',
        '惫',
        '愂',
        '憊',
        '昁',
        '梖',
        '焙',
        '牬',
        '犕',
        '狈',
        '狽',
        '珼',
        '琲',
        '碚',
        '禙',
        '糒',
        '苝',
        '蓓',
        '蛽',
        '褙',
        '貝',
        '贝',
        '軰',
        '輩',
        '辈',
        '邶',
        '郥',
        '鄁',
        '鋇',
        '鐾',
        '钡',
        '鞁',
        '鞴',
        '𬇙',
    ],
    yù: [
        '俼',
        '儥',
        '喅',
        '喩',
        '喻',
        '域',
        '堉',
        '妪',
        '嫗',
        '寓',
        '峪',
        '嶎',
        '庽',
        '彧',
        '御',
        '愈',
        '慾',
        '戫',
        '昱',
        '棛',
        '棜',
        '棫',
        '櫲',
        '欎',
        '欝',
        '欲',
        '毓',
        '浴',
        '淯',
        '滪',
        '潏',
        '澦',
        '灪',
        '焴',
        '煜',
        '燏',
        '燠',
        '爩',
        '狱',
        '獄',
        '玉',
        '琙',
        '瘉',
        '癒',
        '砡',
        '硢',
        '硲',
        '礇',
        '礖',
        '礜',
        '禦',
        '秗',
        '稢',
        '稶',
        '篽',
        '籞',
        '籲',
        '粖',
        '緎',
        '罭',
        '聿',
        '肀',
        '艈',
        '芋',
        '芌',
        '茟',
        '蒮',
        '蓣',
        '蓹',
        '蕷',
        '蘌',
        '蜟',
        '蜮',
        '袬',
        '裕',
        '誉',
        '諭',
        '譽',
        '谕',
        '豫',
        '軉',
        '輍',
        '逳',
        '遇',
        '遹',
        '郁',
        '醧',
        '鈺',
        '鋊',
        '錥',
        '鐭',
        '钰',
        '閾',
        '阈',
        '雤',
        '霱',
        '預',
        '预',
        '飫',
        '饇',
        '饫',
        '馭',
        '驈',
        '驭',
        '鬰',
        '鬱',
        '鬻',
        '魊',
        '鱊',
        '鳿',
        '鴥',
        '鴧',
        '鴪',
        '鵒',
        '鷸',
        '鸒',
        '鹆',
        '鹬',
    ],
    xīn: [
        '俽',
        '噺',
        '妡',
        '嬜',
        '廞',
        '心',
        '忄',
        '忻',
        '惞',
        '新',
        '昕',
        '杺',
        '欣',
        '歆',
        '炘',
        '盺',
        '薪',
        '訢',
        '辛',
        '邤',
        '鈊',
        '鋅',
        '鑫',
        '锌',
        '馨',
        '馫',
        '䜣',
        '𫷷',
    ],
    'hǔ chí': ['俿'],
    jiù: [
        '倃',
        '僦',
        '匓',
        '匛',
        '匶',
        '厩',
        '咎',
        '就',
        '廄',
        '廏',
        '廐',
        '慦',
        '捄',
        '救',
        '旧',
        '柩',
        '柾',
        '桕',
        '欍',
        '殧',
        '疚',
        '臼',
        '舅',
        '舊',
        '鯦',
        '鷲',
        '鹫',
        '麔',
        '齨',
        '㠇',
    ],
    yáo: [
        '倄',
        '傜',
        '嗂',
        '垚',
        '堯',
        '姚',
        '媱',
        '尧',
        '尭',
        '峣',
        '嶢',
        '嶤',
        '徭',
        '揺',
        '搖',
        '摇',
        '摿',
        '暚',
        '榣',
        '烑',
        '爻',
        '猺',
        '珧',
        '瑤',
        '瑶',
        '磘',
        '窑',
        '窯',
        '窰',
        '肴',
        '蘨',
        '謠',
        '謡',
        '谣',
        '軺',
        '轺',
        '遙',
        '遥',
        '邎',
        '顤',
        '颻',
        '飖',
        '餆',
        '餚',
        '鰩',
        '鱙',
        '鳐',
    ],
    'cuì zú': ['倅'],
    'liǎng liǎ': ['倆'],
    wǎn: [
        '倇',
        '唍',
        '婉',
        '惋',
        '挽',
        '晚',
        '晥',
        '晩',
        '晼',
        '梚',
        '椀',
        '琬',
        '畹',
        '皖',
        '盌',
        '碗',
        '綩',
        '綰',
        '绾',
        '脘',
        '萖',
        '踠',
        '輓',
        '鋔',
    ],
    zǒng: [
        '倊',
        '偬',
        '傯',
        '嵸',
        '总',
        '惣',
        '捴',
        '搃',
        '摠',
        '燪',
        '総',
        '緫',
        '縂',
        '總',
        '蓗',
    ],
    guān: [
        '倌',
        '关',
        '官',
        '棺',
        '瘝',
        '癏',
        '窤',
        '蒄',
        '関',
        '闗',
        '關',
        '鰥',
        '鱞',
        '鳏',
    ],
    tiǎn: [
        '倎',
        '唺',
        '忝',
        '悿',
        '晪',
        '殄',
        '淟',
        '睓',
        '腆',
        '舔',
        '覥',
        '觍',
        '賟',
        '錪',
        '餂',
    ],
    mén: ['們', '扪', '捫', '璊', '菛', '虋', '鍆', '钔', '門', '閅', '门', '𫞩'],
    'dǎo dào': ['倒'],
    'tán tàn': ['倓', '埮'],
    'juè jué': ['倔'],
    chuí: [
        '倕',
        '垂',
        '埀',
        '捶',
        '搥',
        '桘',
        '棰',
        '槌',
        '箠',
        '腄',
        '菙',
        '錘',
        '鎚',
        '锤',
        '陲',
        '顀',
    ],
    xìng: [
        '倖',
        '姓',
        '婞',
        '嬹',
        '幸',
        '性',
        '悻',
        '杏',
        '涬',
        '緈',
        '臖',
        '荇',
        '莕',
        '葕',
    ],
    péng: [
        '倗',
        '傰',
        '塜',
        '塳',
        '弸',
        '憉',
        '捀',
        '朋',
        '棚',
        '椖',
        '樥',
        '硼',
        '稝',
        '竼',
        '篷',
        '纄',
        '膨',
        '芃',
        '蓬',
        '蘕',
        '蟚',
        '蟛',
        '袶',
        '輣',
        '錋',
        '鑝',
        '韸',
        '韼',
        '騯',
        '髼',
        '鬅',
        '鬔',
        '鵬',
        '鹏',
    ],
    'tǎng cháng': ['倘'],
    hòu: [
        '候',
        '厚',
        '后',
        '垕',
        '堠',
        '後',
        '洉',
        '茩',
        '豞',
        '逅',
        '郈',
        '鮜',
        '鱟',
        '鲎',
        '鲘',
    ],
    tì: [
        '倜',
        '剃',
        '嚏',
        '嚔',
        '屉',
        '屜',
        '悌',
        '悐',
        '惕',
        '惖',
        '戻',
        '掦',
        '替',
        '朑',
        '歒',
        '殢',
        '涕',
        '瓋',
        '笹',
        '籊',
        '薙',
        '褅',
        '逖',
        '逷',
        '髰',
        '鬀',
        '鬄',
    ],
    gàn: [
        '倝',
        '凎',
        '幹',
        '榦',
        '檊',
        '淦',
        '灨',
        '盰',
        '紺',
        '绀',
        '詌',
        '贑',
        '赣',
        '骭',
        '㽏',
    ],
    'liàng jìng': ['倞', '靓'],
    suī: [
        '倠',
        '哸',
        '夊',
        '滖',
        '濉',
        '眭',
        '睢',
        '芕',
        '荽',
        '荾',
        '虽',
        '雖',
        '鞖',
    ],
    'chàng chāng': ['倡'],
    jié: [
        '倢',
        '偼',
        '傑',
        '刦',
        '刧',
        '刼',
        '劫',
        '劼',
        '卩',
        '卪',
        '婕',
        '媫',
        '孑',
        '岊',
        '崨',
        '嵥',
        '嶻',
        '巀',
        '幯',
        '截',
        '捷',
        '掶',
        '擮',
        '昅',
        '杢',
        '杰',
        '桀',
        '桝',
        '楬',
        '楶',
        '榤',
        '洁',
        '滐',
        '潔',
        '狤',
        '睫',
        '礍',
        '竭',
        '節',
        '羯',
        '莭',
        '蓵',
        '蛣',
        '蜐',
        '蠘',
        '蠞',
        '蠽',
        '衱',
        '袺',
        '訐',
        '詰',
        '誱',
        '讦',
        '踕',
        '迼',
        '鉣',
        '鍻',
        '镼',
        '頡',
        '鮚',
        '鲒',
        '㛃',
    ],
    'kǒng kōng': ['倥'],
    juàn: [
        '倦',
        '劵',
        '奆',
        '慻',
        '桊',
        '淃',
        '狷',
        '獧',
        '眷',
        '睊',
        '睠',
        '絭',
        '絹',
        '绢',
        '罥',
        '羂',
        '腃',
        '蔨',
        '鄄',
        '餋',
    ],
    zōng: [
        '倧',
        '堫',
        '宗',
        '嵏',
        '嵕',
        '惾',
        '朡',
        '棕',
        '椶',
        '熧',
        '猣',
        '磫',
        '緃',
        '翪',
        '腙',
        '葼',
        '蝬',
        '豵',
        '踨',
        '踪',
        '蹤',
        '鍐',
        '鑁',
        '騌',
        '騣',
        '骔',
        '鬃',
        '鬉',
        '鬷',
        '鯮',
        '鯼',
    ],
    ní: [
        '倪',
        '坭',
        '埿',
        '尼',
        '屔',
        '怩',
        '淣',
        '猊',
        '籾',
        '聣',
        '蚭',
        '蜺',
        '觬',
        '貎',
        '跜',
        '輗',
        '郳',
        '鈮',
        '铌',
        '霓',
        '馜',
        '鯢',
        '鲵',
        '麑',
        '齯',
        '𫐐',
        '𫠜',
    ],
    zhuō: [
        '倬',
        '拙',
        '捉',
        '桌',
        '梲',
        '棁',
        '棳',
        '槕',
        '涿',
        '窧',
        '鐯',
        '䦃',
    ],
    'wō wēi': ['倭'],
    luǒ: ['倮', '剆', '曪', '瘰', '癳', '臝', '蓏', '蠃', '裸', '躶'],
    sōng: [
        '倯',
        '凇',
        '娀',
        '崧',
        '嵩',
        '庺',
        '憽',
        '松',
        '枀',
        '枩',
        '柗',
        '梥',
        '檧',
        '淞',
        '濍',
        '硹',
        '菘',
        '鬆',
    ],
    lèng: ['倰', '堎', '愣', '睖', '踜'],
    zì: [
        '倳',
        '剚',
        '字',
        '恣',
        '渍',
        '漬',
        '牸',
        '眥',
        '眦',
        '胔',
        '胾',
        '自',
        '茡',
        '荢',
    ],
    bèn: ['倴', '坌', '捹', '撪', '渀', '笨', '逩'],
    cǎi: ['倸', '啋', '婇', '彩', '採', '棌', '毝', '睬', '綵', '跴', '踩'],
    zhài: ['债', '債', '寨', '瘵', '砦'],
    yē: ['倻', '吔', '噎', '擨', '暍', '椰', '歋', '潱', '蠮'],
    shà: ['倽', '唼', '喢', '歃', '箑', '翜', '翣', '萐', '閯', '霎'],
    qīng: [
        '倾',
        '傾',
        '卿',
        '圊',
        '寈',
        '氢',
        '氫',
        '淸',
        '清',
        '蜻',
        '軽',
        '輕',
        '轻',
        '郬',
        '錆',
        '鑋',
        '靑',
        '青',
        '鯖',
    ],
    yīng: [
        '偀',
        '嘤',
        '噟',
        '嚶',
        '婴',
        '媖',
        '嫈',
        '嬰',
        '孆',
        '孾',
        '愥',
        '撄',
        '攖',
        '朠',
        '桜',
        '樱',
        '櫻',
        '渶',
        '煐',
        '珱',
        '瑛',
        '璎',
        '瓔',
        '甇',
        '甖',
        '碤',
        '礯',
        '緓',
        '纓',
        '绬',
        '缨',
        '罂',
        '罃',
        '罌',
        '膺',
        '英',
        '莺',
        '蘡',
        '蝧',
        '蠳',
        '褮',
        '譻',
        '賏',
        '軈',
        '鑍',
        '锳',
        '霙',
        '韺',
        '鴬',
        '鶑',
        '鶧',
        '鶯',
        '鷪',
        '鷹',
        '鸎',
        '鸚',
        '鹦',
        '鹰',
        '䓨',
    ],
    'chēng chèn': ['偁', '爯'],
    ruǎn: ['偄', '朊', '瑌', '瓀', '碝', '礝', '腝', '軟', '輭', '软', '阮'],
    'zhòng tóng': ['偅'],
    chǔn: ['偆', '惷', '睶', '萶', '蠢', '賰'],
    'jiǎ jià': ['假'],
    'jì jié': ['偈'],
    'bǐng bìng': ['偋'],
    ruò: [
        '偌',
        '叒',
        '嵶',
        '弱',
        '楉',
        '焫',
        '爇',
        '箬',
        '篛',
        '蒻',
        '鄀',
        '鰙',
        '鰯',
        '鶸',
    ],
    tí: [
        '偍',
        '厗',
        '啼',
        '嗁',
        '崹',
        '漽',
        '瑅',
        '睼',
        '禵',
        '稊',
        '緹',
        '缇',
        '罤',
        '蕛',
        '褆',
        '謕',
        '趧',
        '蹄',
        '蹏',
        '醍',
        '鍗',
        '題',
        '题',
        '騠',
        '鮷',
        '鯷',
        '鳀',
        '鵜',
        '鷤',
        '鹈',
        '𫘨',
    ],
    wēi: [
        '偎',
        '危',
        '喴',
        '威',
        '媙',
        '嶶',
        '巍',
        '微',
        '愄',
        '揋',
        '揻',
        '椳',
        '楲',
        '溦',
        '烓',
        '煨',
        '燰',
        '癓',
        '縅',
        '葨',
        '葳',
        '薇',
        '蜲',
        '蝛',
        '覣',
        '詴',
        '逶',
        '隇',
        '隈',
        '霺',
        '鰃',
        '鰄',
        '鳂',
    ],
    piān: ['偏', '囨', '媥', '楄', '犏', '篇', '翩', '鍂'],
    yàn: [
        '偐',
        '厌',
        '厭',
        '唁',
        '喭',
        '嚈',
        '嚥',
        '堰',
        '妟',
        '姲',
        '嬊',
        '嬿',
        '宴',
        '彥',
        '彦',
        '敥',
        '晏',
        '暥',
        '曕',
        '曣',
        '滟',
        '灎',
        '灔',
        '灧',
        '灩',
        '焔',
        '焰',
        '焱',
        '熖',
        '燄',
        '牪',
        '猒',
        '砚',
        '硯',
        '艳',
        '艶',
        '艷',
        '覎',
        '觃',
        '觾',
        '諺',
        '讌',
        '讞',
        '谚',
        '谳',
        '豓',
        '豔',
        '贋',
        '贗',
        '赝',
        '軅',
        '酀',
        '酽',
        '醼',
        '釅',
        '雁',
        '餍',
        '饜',
        '騐',
        '験',
        '騴',
        '驗',
        '驠',
        '验',
        '鬳',
        '鳫',
        '鴈',
        '鴳',
        '鷃',
        '鷰',
        '齞',
    ],
    'tǎng dàng': ['偒'],
    è: [
        '偔',
        '匎',
        '卾',
        '厄',
        '呝',
        '咢',
        '噩',
        '垩',
        '堊',
        '堮',
        '岋',
        '崿',
        '廅',
        '悪',
        '愕',
        '戹',
        '扼',
        '搤',
        '搹',
        '擜',
        '櫮',
        '歞',
        '歺',
        '湂',
        '琧',
        '砈',
        '砐',
        '硆',
        '腭',
        '苊',
        '萼',
        '蕚',
        '蚅',
        '蝁',
        '覨',
        '諤',
        '讍',
        '谔',
        '豟',
        '軛',
        '軶',
        '轭',
        '遌',
        '遏',
        '遻',
        '鄂',
        '鈪',
        '鍔',
        '鑩',
        '锷',
        '阨',
        '阸',
        '頞',
        '顎',
        '颚',
        '餓',
        '餩',
        '饿',
        '鰐',
        '鰪',
        '鱷',
        '鳄',
        '鶚',
        '鹗',
        '齃',
        '齶',
        '𫫇',
        '𥔲',
    ],
    xié: [
        '偕',
        '勰',
        '协',
        '協',
        '嗋',
        '垥',
        '奊',
        '恊',
        '愶',
        '拹',
        '携',
        '撷',
        '擕',
        '擷',
        '攜',
        '斜',
        '旪',
        '熁',
        '燲',
        '綊',
        '緳',
        '縀',
        '缬',
        '翓',
        '胁',
        '脅',
        '脇',
        '脋',
        '膎',
        '蝢',
        '衺',
        '襭',
        '諧',
        '讗',
        '谐',
        '鞋',
        '鞵',
        '龤',
        '㙦',
    ],
    chě: ['偖', '扯', '撦'],
    shěng: ['偗', '渻', '眚'],
    chā: [
        '偛',
        '嗏',
        '扠',
        '挿',
        '插',
        '揷',
        '疀',
        '臿',
        '艖',
        '銟',
        '鍤',
        '锸',
        '餷',
    ],
    huáng: [
        '偟',
        '凰',
        '喤',
        '堭',
        '墴',
        '媓',
        '崲',
        '徨',
        '惶',
        '楻',
        '湟',
        '煌',
        '獚',
        '瑝',
        '璜',
        '癀',
        '皇',
        '磺',
        '穔',
        '篁',
        '簧',
        '艎',
        '葟',
        '蝗',
        '蟥',
        '諻',
        '趪',
        '遑',
        '鍠',
        '鐄',
        '锽',
        '隍',
        '韹',
        '餭',
        '騜',
        '鰉',
        '鱑',
        '鳇',
        '鷬',
        '黃',
        '黄',
        '𨱑',
    ],
    yǎo: [
        '偠',
        '咬',
        '婹',
        '宎',
        '岆',
        '杳',
        '柼',
        '榚',
        '溔',
        '狕',
        '窅',
        '窈',
        '舀',
        '苭',
        '闄',
        '騕',
        '鷕',
        '齩',
    ],
    'chǒu qiào': ['偢'],
    yóu: [
        '偤',
        '尤',
        '庮',
        '怣',
        '沋',
        '油',
        '浟',
        '游',
        '犹',
        '猶',
        '猷',
        '由',
        '疣',
        '秞',
        '肬',
        '莜',
        '莸',
        '蕕',
        '蚰',
        '蝣',
        '訧',
        '輏',
        '輶',
        '逰',
        '遊',
        '邮',
        '郵',
        '鈾',
        '铀',
        '駀',
        '魷',
        '鮋',
        '鱿',
        '鲉',
        '𬨎',
    ],
    xū: [
        '偦',
        '墟',
        '媭',
        '嬃',
        '楈',
        '欨',
        '歔',
        '燸',
        '疞',
        '盱',
        '綇',
        '縃',
        '繻',
        '胥',
        '蕦',
        '虗',
        '虚',
        '虛',
        '蝑',
        '裇',
        '訏',
        '許',
        '諝',
        '譃',
        '谞',
        '鑐',
        '需',
        '須',
        '须',
        '顼',
        '驉',
        '鬚',
        '魆',
        '魖',
        '𬣙',
        '𦈡',
    ],
    zhā: [
        '偧',
        '哳',
        '抯',
        '挓',
        '揸',
        '摣',
        '樝',
        '渣',
        '皶',
        '觰',
        '譇',
        '齄',
        '齇',
    ],
    cī: ['偨', '疵', '蠀', '趀', '骴', '髊', '齹'],
    bī: ['偪', '屄', '楅', '毴', '豍', '逼', '鰏', '鲾', '鵖'],
    xún: [
        '偱',
        '噚',
        '寻',
        '尋',
        '峋',
        '巡',
        '廵',
        '循',
        '恂',
        '揗',
        '攳',
        '旬',
        '杊',
        '栒',
        '桪',
        '樳',
        '洵',
        '浔',
        '潯',
        '燅',
        '燖',
        '珣',
        '璕',
        '畃',
        '紃',
        '荀',
        '蟳',
        '詢',
        '询',
        '鄩',
        '鱏',
        '鱘',
        '鲟',
        '𬘓',
        '𬩽',
        '𬍤',
        '𬊈',
    ],
    'cāi sī': ['偲'],
    duān: ['偳', '媏', '端', '褍', '鍴'],
    ǒu: ['偶', '吘', '嘔', '耦', '腢', '蕅', '藕', '𬉼', '𠙶'],
    tōu: ['偷', '偸', '鍮'],
    'zán zá zǎ': ['偺'],
    'lǚ lóu': ['偻', '僂'],
    fèn: [
        '偾',
        '僨',
        '奋',
        '奮',
        '弅',
        '忿',
        '愤',
        '憤',
        '瀵',
        '瞓',
        '秎',
        '粪',
        '糞',
        '膹',
        '鱝',
        '鲼',
    ],
    'kuǐ guī': ['傀'],
    sǒu: ['傁', '叜', '叟', '嗾', '櫢', '瞍', '薮', '藪'],
    'zhì sī tí': ['傂'],
    sù: [
        '傃',
        '僳',
        '嗉',
        '塐',
        '塑',
        '夙',
        '嫊',
        '愫',
        '憟',
        '榡',
        '樎',
        '樕',
        '殐',
        '泝',
        '涑',
        '溯',
        '溸',
        '潚',
        '潥',
        '玊',
        '珟',
        '璛',
        '簌',
        '粛',
        '粟',
        '素',
        '縤',
        '肃',
        '肅',
        '膆',
        '蔌',
        '藗',
        '觫',
        '訴',
        '謖',
        '诉',
        '谡',
        '趚',
        '蹜',
        '速',
        '遡',
        '遬',
        '鋉',
        '餗',
        '驌',
        '骕',
        '鱐',
        '鷫',
        '鹔',
        '𫗧',
    ],
    xiā: ['傄', '煆', '瞎', '虲', '谺', '颬', '鰕'],
    'yuàn yuán': ['傆', '媛'],
    rǒng: ['傇', '冗', '宂', '氄', '軵'],
    nù: ['傉', '怒'],
    yùn: [
        '傊',
        '孕',
        '恽',
        '惲',
        '愠',
        '慍',
        '枟',
        '腪',
        '蕴',
        '薀',
        '藴',
        '蘊',
        '褞',
        '貟',
        '运',
        '運',
        '郓',
        '鄆',
        '酝',
        '醖',
        '醞',
        '韗',
        '韞',
        '韵',
        '韻',
        '餫',
    ],
    'gòu jiǎng': ['傋'],
    mà: ['傌', '嘜', '榪', '睰', '祃', '禡', '罵', '閁', '駡', '骂', '鬕'],
    bàng: [
        '傍',
        '塝',
        '棒',
        '玤',
        '稖',
        '艕',
        '蒡',
        '蜯',
        '謗',
        '谤',
        '鎊',
        '镑',
    ],
    diān: [
        '傎',
        '厧',
        '嵮',
        '巅',
        '巓',
        '巔',
        '掂',
        '攧',
        '敁',
        '槇',
        '滇',
        '癫',
        '癲',
        '蹎',
        '顚',
        '顛',
        '颠',
        '齻',
    ],
    táng: [
        '傏',
        '唐',
        '啺',
        '坣',
        '堂',
        '塘',
        '搪',
        '棠',
        '榶',
        '溏',
        '漟',
        '煻',
        '瑭',
        '磄',
        '禟',
        '篖',
        '糃',
        '糖',
        '糛',
        '膅',
        '膛',
        '蓎',
        '螗',
        '螳',
        '赯',
        '踼',
        '鄌',
        '醣',
        '鎕',
        '隚',
        '餹',
        '饄',
        '鶶',
        '䣘',
    ],
    hào: [
        '傐',
        '哠',
        '恏',
        '昊',
        '昦',
        '晧',
        '暠',
        '暤',
        '暭',
        '曍',
        '浩',
        '淏',
        '澔',
        '灏',
        '灝',
        '皓',
        '皜',
        '皞',
        '皡',
        '皥',
        '耗',
        '聕',
        '薃',
        '號',
        '鄗',
        '顥',
        '颢',
        '鰝',
    ],
    'xī xì': ['傒'],
    shān: [
        '傓',
        '删',
        '刪',
        '剼',
        '圸',
        '山',
        '挻',
        '搧',
        '柵',
        '檆',
        '潸',
        '澘',
        '煽',
        '狦',
        '珊',
        '笘',
        '縿',
        '羴',
        '羶',
        '脠',
        '舢',
        '芟',
        '衫',
        '跚',
        '軕',
        '邖',
        '閊',
        '鯅',
    ],
    'qiàn jiān': ['傔'],
    'què jué': ['傕', '埆'],
    'cāng chen': ['傖'],
    róng: [
        '傛',
        '媶',
        '嫆',
        '嬫',
        '容',
        '峵',
        '嵘',
        '嶸',
        '戎',
        '搈',
        '曧',
        '栄',
        '榕',
        '榮',
        '榵',
        '毧',
        '溶',
        '瀜',
        '烿',
        '熔',
        '狨',
        '瑢',
        '穁',
        '絨',
        '绒',
        '羢',
        '肜',
        '茙',
        '茸',
        '荣',
        '蓉',
        '蝾',
        '融',
        '螎',
        '蠑',
        '褣',
        '鎔',
        '镕',
        '駥',
    ],
    'tà tàn': ['傝'],
    suō: [
        '傞',
        '唆',
        '嗍',
        '嗦',
        '娑',
        '摍',
        '桫',
        '梭',
        '睃',
        '簑',
        '簔',
        '羧',
        '莏',
        '蓑',
        '趖',
        '鮻',
    ],
    dǎi: ['傣', '歹'],
    zài: ['傤', '儎', '再', '在', '扗', '洅', '載', '酨'],
    gǔ: [
        '傦',
        '古',
        '啒',
        '尳',
        '愲',
        '榖',
        '榾',
        '汩',
        '淈',
        '濲',
        '瀔',
        '牯',
        '皷',
        '皼',
        '盬',
        '瞽',
        '穀',
        '罟',
        '羖',
        '股',
        '脵',
        '臌',
        '薣',
        '蛊',
        '蠱',
        '詁',
        '诂',
        '轂',
        '逧',
        '鈷',
        '钴',
        '餶',
        '馉',
        '鼓',
        '鼔',
        '𦙶',
    ],
    bīn: [
        '傧',
        '宾',
        '彬',
        '斌',
        '椕',
        '滨',
        '濒',
        '濱',
        '濵',
        '瀕',
        '繽',
        '缤',
        '虨',
        '豩',
        '豳',
        '賓',
        '賔',
        '邠',
        '鑌',
        '镔',
        '霦',
        '顮',
    ],
    chǔ: [
        '储',
        '儲',
        '杵',
        '椘',
        '楚',
        '楮',
        '檚',
        '濋',
        '璴',
        '础',
        '礎',
        '禇',
        '處',
        '齭',
        '齼',
        '𬺓',
    ],
    nuó: ['傩', '儺', '挪', '梛', '橠'],
    'cān càn': ['傪'],
    lěi: [
        '傫',
        '儡',
        '厽',
        '垒',
        '塁',
        '壘',
        '壨',
        '櫐',
        '灅',
        '癗',
        '矋',
        '磊',
        '礨',
        '耒',
        '蕌',
        '蕾',
        '藟',
        '蘽',
        '蠝',
        '誄',
        '讄',
        '诔',
        '鑸',
        '鸓',
    ],
    cuī: ['催', '凗', '墔', '崔', '嵟', '慛', '摧', '榱', '獕', '磪', '鏙'],
    yōng: [
        '傭',
        '嗈',
        '墉',
        '壅',
        '嫞',
        '庸',
        '廱',
        '慵',
        '拥',
        '擁',
        '滽',
        '灉',
        '牅',
        '痈',
        '癕',
        '癰',
        '臃',
        '邕',
        '郺',
        '鄘',
        '鏞',
        '镛',
        '雍',
        '雝',
        '饔',
        '鱅',
        '鳙',
        '鷛',
    ],
    'zāo cáo': ['傮'],
    sǒng: ['傱', '嵷', '怂', '悚', '愯', '慫', '竦', '耸', '聳', '駷', '㧐'],
    ào: [
        '傲',
        '坳',
        '垇',
        '墺',
        '奡',
        '嫯',
        '岙',
        '岰',
        '嶴',
        '懊',
        '擙',
        '澳',
        '鏊',
        '驁',
        '骜',
    ],
    'qī còu': ['傶'],
    chuǎng: ['傸', '磢', '闖', '闯'],
    shǎ: ['傻', '儍'],
    hàn: [
        '傼',
        '垾',
        '悍',
        '憾',
        '扞',
        '捍',
        '撖',
        '撼',
        '旱',
        '晘',
        '暵',
        '汉',
        '涆',
        '漢',
        '瀚',
        '焊',
        '猂',
        '皔',
        '睅',
        '翰',
        '莟',
        '菡',
        '蛿',
        '蜭',
        '螒',
        '譀',
        '輚',
        '釬',
        '銲',
        '鋎',
        '雗',
        '頷',
        '顄',
        '颔',
        '駻',
        '鶾',
    ],
    zhāng: [
        '傽',
        '嫜',
        '张',
        '張',
        '彰',
        '慞',
        '暲',
        '樟',
        '漳',
        '獐',
        '璋',
        '章',
        '粻',
        '蔁',
        '蟑',
        '遧',
        '鄣',
        '鏱',
        '餦',
        '騿',
        '鱆',
        '麞',
    ],
    'yān yàn': ['傿', '墕', '嬮'],
    'piào biāo': ['僄', '骠'],
    liàn: [
        '僆',
        '堜',
        '媡',
        '恋',
        '戀',
        '楝',
        '殓',
        '殮',
        '湅',
        '潋',
        '澰',
        '瀲',
        '炼',
        '煉',
        '瑓',
        '練',
        '纞',
        '练',
        '萰',
        '錬',
        '鍊',
        '鏈',
        '链',
        '鰊',
        '𬶠',
    ],
    màn: [
        '㵘',
        '僈',
        '墁',
        '幔',
        '慢',
        '曼',
        '漫',
        '澷',
        '熳',
        '獌',
        '縵',
        '缦',
        '蔄',
        '蘰',
        '鄤',
        '鏝',
        '镘',
        '𬜬',
    ],
    'tàn tǎn': ['僋'],
    yíng: [
        '僌',
        '営',
        '塋',
        '嬴',
        '攍',
        '楹',
        '櫿',
        '溁',
        '溋',
        '滢',
        '潆',
        '濙',
        '濚',
        '濴',
        '瀅',
        '瀛',
        '瀠',
        '瀯',
        '灐',
        '灜',
        '熒',
        '營',
        '瑩',
        '盁',
        '盈',
        '禜',
        '籝',
        '籯',
        '縈',
        '茔',
        '荧',
        '莹',
        '萤',
        '营',
        '萦',
        '萾',
        '蓥',
        '藀',
        '蛍',
        '蝇',
        '蝿',
        '螢',
        '蠅',
        '謍',
        '贏',
        '赢',
        '迎',
        '鎣',
    ],
    dòng: [
        '働',
        '冻',
        '凍',
        '动',
        '動',
        '姛',
        '戙',
        '挏',
        '栋',
        '棟',
        '湩',
        '硐',
        '胨',
        '胴',
        '腖',
        '迵',
        '霘',
        '駧',
    ],
    zhuàn: [
        '僎',
        '啭',
        '囀',
        '堟',
        '撰',
        '灷',
        '瑑',
        '篆',
        '腞',
        '蒃',
        '襈',
        '譔',
        '饌',
        '馔',
    ],
    xiàng: [
        '像',
        '勨',
        '向',
        '嚮',
        '姠',
        '嶑',
        '曏',
        '橡',
        '珦',
        '缿',
        '蟓',
        '衖',
        '襐',
        '象',
        '鐌',
        '項',
        '项',
        '鱌',
    ],
    shàn: [
        '僐',
        '善',
        '墠',
        '墡',
        '嬗',
        '擅',
        '敾',
        '椫',
        '樿',
        '歚',
        '汕',
        '灗',
        '疝',
        '磰',
        '繕',
        '缮',
        '膳',
        '蟮',
        '蟺',
        '訕',
        '謆',
        '譱',
        '讪',
        '贍',
        '赡',
        '赸',
        '鄯',
        '鐥',
        '饍',
        '騸',
        '骟',
        '鱓',
        '鱔',
        '鳝',
        '𫮃',
    ],
    'tuí tuǐ': ['僓'],
    zǔn: ['僔', '噂', '撙', '譐'],
    pú: [
        '僕',
        '匍',
        '圤',
        '墣',
        '濮',
        '獛',
        '璞',
        '瞨',
        '穙',
        '莆',
        '菐',
        '菩',
        '葡',
        '蒱',
        '蒲',
        '贌',
        '酺',
        '鏷',
        '镤',
    ],
    láo: [
        '僗',
        '劳',
        '労',
        '勞',
        '哰',
        '崂',
        '嶗',
        '憥',
        '朥',
        '浶',
        '牢',
        '痨',
        '癆',
        '窂',
        '簩',
        '醪',
        '鐒',
        '铹',
        '顟',
        '髝',
        '𫭼',
    ],
    chǎng: ['僘', '厰', '廠', '敞', '昶', '氅', '鋹', '𬬮'],
    guāng: [
        '僙',
        '光',
        '咣',
        '垙',
        '姯',
        '洸',
        '灮',
        '炗',
        '炚',
        '炛',
        '烡',
        '珖',
        '胱',
        '茪',
        '輄',
        '銧',
        '黆',
        '𨐈',
    ],
    liáo: [
        '僚',
        '嘹',
        '嫽',
        '寥',
        '寮',
        '尞',
        '屪',
        '嵺',
        '嶚',
        '嶛',
        '廫',
        '憀',
        '敹',
        '暸',
        '橑',
        '獠',
        '璙',
        '疗',
        '療',
        '竂',
        '簝',
        '繚',
        '缭',
        '聊',
        '膋',
        '膫',
        '藔',
        '蟟',
        '豂',
        '賿',
        '蹘',
        '辽',
        '遼',
        '飉',
        '髎',
        '鷯',
        '鹩',
    ],
    dèng: ['僜', '凳', '墱', '嶝', '櫈', '瞪', '磴', '覴', '邓', '鄧', '隥'],
    'chán zhàn zhuàn': ['僝'],
    bō: [
        '僠',
        '嶓',
        '拨',
        '撥',
        '播',
        '波',
        '溊',
        '玻',
        '癶',
        '盋',
        '砵',
        '碆',
        '礡',
        '缽',
        '菠',
        '袰',
        '蹳',
        '鉢',
        '钵',
        '餑',
        '饽',
        '驋',
        '鱍',
        '𬭛',
    ],
    huì: [
        '僡',
        '匯',
        '卉',
        '喙',
        '嘒',
        '嚖',
        '圚',
        '嬒',
        '寭',
        '屶',
        '屷',
        '彗',
        '彙',
        '彚',
        '徻',
        '恚',
        '恵',
        '惠',
        '慧',
        '憓',
        '懳',
        '晦',
        '暳',
        '槥',
        '橞',
        '檅',
        '櫘',
        '汇',
        '泋',
        '滙',
        '潓',
        '烩',
        '燴',
        '獩',
        '璤',
        '瞺',
        '硊',
        '秽',
        '穢',
        '篲',
        '絵',
        '繪',
        '绘',
        '翙',
        '翽',
        '荟',
        '蔧',
        '蕙',
        '薈',
        '薉',
        '蟪',
        '詯',
        '誨',
        '諱',
        '譓',
        '譿',
        '讳',
        '诲',
        '賄',
        '贿',
        '鐬',
        '闠',
        '阓',
        '靧',
        '頮',
        '顪',
        '颒',
        '餯',
        '𬤝',
        '𬭬',
    ],
    chuǎn: ['僢', '喘', '舛', '荈', '踳'],
    'tiě jiàn': ['僣'],
    sēng: ['僧', '鬙'],
    xiàn: [
        '僩',
        '僴',
        '哯',
        '垷',
        '塪',
        '姭',
        '娊',
        '宪',
        '岘',
        '峴',
        '憲',
        '撊',
        '晛',
        '橌',
        '橺',
        '涀',
        '瀗',
        '献',
        '獻',
        '现',
        '現',
        '県',
        '睍',
        '粯',
        '糮',
        '絤',
        '綫',
        '線',
        '线',
        '缐',
        '羡',
        '羨',
        '腺',
        '臔',
        '臽',
        '苋',
        '莧',
        '誢',
        '豏',
        '鋧',
        '錎',
        '限',
        '陥',
        '陷',
        '霰',
        '餡',
        '馅',
        '麲',
        '鼸',
        '𬀪',
        '𪾢',
    ],
    'yù jú': ['僪'],
    'è wū': ['僫'],
    'tóng zhuàng': ['僮'],
    lǐn: [
        '僯',
        '凛',
        '凜',
        '廩',
        '廪',
        '懍',
        '懔',
        '撛',
        '檁',
        '檩',
        '澟',
        '癛',
        '癝',
    ],
    gù: [
        '僱',
        '凅',
        '固',
        '堌',
        '崓',
        '崮',
        '故',
        '梏',
        '棝',
        '牿',
        '痼',
        '祻',
        '錮',
        '锢',
        '雇',
        '顧',
        '顾',
        '鯝',
        '鲴',
    ],
    jiāng: [
        '僵',
        '壃',
        '姜',
        '橿',
        '殭',
        '江',
        '畕',
        '疅',
        '礓',
        '繮',
        '缰',
        '翞',
        '茳',
        '葁',
        '薑',
        '螀',
        '螿',
        '豇',
        '韁',
        '鱂',
        '鳉',
    ],
    mǐn: [
        '僶',
        '冺',
        '刡',
        '勄',
        '悯',
        '惽',
        '愍',
        '慜',
        '憫',
        '抿',
        '敃',
        '敏',
        '敯',
        '泯',
        '潣',
        '皿',
        '笢',
        '笽',
        '簢',
        '蠠',
        '閔',
        '閩',
        '闵',
        '闽',
        '鰵',
        '鳘',
        '黽',
    ],
    jìn: [
        '僸',
        '凚',
        '噤',
        '嚍',
        '墐',
        '壗',
        '妗',
        '嬧',
        '搢',
        '晉',
        '晋',
        '枃',
        '殣',
        '浕',
        '浸',
        '溍',
        '濅',
        '濜',
        '烬',
        '煡',
        '燼',
        '琎',
        '瑨',
        '璶',
        '盡',
        '祲',
        '縉',
        '缙',
        '荩',
        '藎',
        '覲',
        '觐',
        '賮',
        '贐',
        '赆',
        '近',
        '进',
        '進',
        '靳',
        '齽',
    ],
    'jià jie': ['價'],
    qiào: [
        '僺',
        '峭',
        '帩',
        '撬',
        '殻',
        '窍',
        '竅',
        '誚',
        '诮',
        '躈',
        '陗',
        '鞩',
        '韒',
        '髚',
    ],
    pì: ['僻', '媲', '嫓', '屁', '澼', '甓', '疈', '譬', '闢', '鷿', '鸊', '䴙'],
    sài: ['僿', '簺', '賽', '赛'],
    'chán tǎn shàn': ['儃'],
    'dāng dàng': ['儅', '当', '闣'],
    xuān: [
        '儇',
        '喧',
        '塇',
        '媗',
        '宣',
        '愃',
        '愋',
        '揎',
        '昍',
        '暄',
        '煊',
        '煖',
        '瑄',
        '睻',
        '矎',
        '禤',
        '箮',
        '翧',
        '翾',
        '萱',
        '萲',
        '蓒',
        '蕿',
        '藼',
        '蘐',
        '蝖',
        '蠉',
        '諠',
        '諼',
        '譞',
        '谖',
        '軒',
        '轩',
        '鍹',
        '駽',
        '鰚',
        '𫓶',
        '𫍽',
    ],
    'dān dàn': ['儋', '擔', '瘅'],
    càn: ['儏', '澯', '灿', '燦', '璨', '粲', '薒', '謲'],
    'bīn bìn': ['儐'],
    'án àn': ['儑'],
    tái: [
        '儓',
        '坮',
        '嬯',
        '抬',
        '擡',
        '檯',
        '炱',
        '炲',
        '籉',
        '臺',
        '薹',
        '跆',
        '邰',
        '颱',
        '鮐',
        '鲐',
    ],
    lán: [
        '儖',
        '兰',
        '囒',
        '婪',
        '岚',
        '嵐',
        '幱',
        '拦',
        '攔',
        '斓',
        '斕',
        '栏',
        '欄',
        '欗',
        '澜',
        '瀾',
        '灆',
        '灡',
        '燣',
        '燷',
        '璼',
        '篮',
        '籃',
        '籣',
        '繿',
        '葻',
        '蓝',
        '藍',
        '蘫',
        '蘭',
        '褴',
        '襕',
        '襤',
        '襴',
        '襽',
        '譋',
        '讕',
        '谰',
        '躝',
        '鑭',
        '镧',
        '闌',
        '阑',
        '韊',
        '𬒗',
    ],
    'nǐ yì ài yí': ['儗'],
    méng: [
        '儚',
        '幪',
        '曚',
        '朦',
        '橗',
        '檬',
        '氋',
        '溕',
        '濛',
        '甍',
        '甿',
        '盟',
        '礞',
        '艨',
        '莔',
        '萌',
        '蕄',
        '虻',
        '蝱',
        '鄳',
        '鄸',
        '霿',
        '靀',
        '顭',
        '饛',
        '鯍',
        '鸏',
        '鹲',
        '𫑡',
        '㠓',
    ],
    níng: [
        '儜',
        '凝',
        '咛',
        '嚀',
        '嬣',
        '柠',
        '橣',
        '檸',
        '狞',
        '獰',
        '聍',
        '聹',
        '薴',
        '鑏',
        '鬡',
        '鸋',
    ],
    qióng: [
        '儝',
        '卭',
        '宆',
        '惸',
        '憌',
        '桏',
        '橩',
        '焪',
        '焭',
        '煢',
        '熍',
        '琼',
        '瓊',
        '睘',
        '穷',
        '穹',
        '窮',
        '竆',
        '笻',
        '筇',
        '舼',
        '茕',
        '藑',
        '藭',
        '蛩',
        '蛬',
        '赹',
        '跫',
        '邛',
        '銎',
        '䓖',
    ],
    liè: [
        '儠',
        '冽',
        '列',
        '劣',
        '劽',
        '埒',
        '埓',
        '姴',
        '峛',
        '巤',
        '挒',
        '捩',
        '栵',
        '洌',
        '浖',
        '烈',
        '烮',
        '煭',
        '犣',
        '猎',
        '猟',
        '獵',
        '聗',
        '脟',
        '茢',
        '蛚',
        '趔',
        '躐',
        '迾',
        '颲',
        '鬛',
        '鬣',
        '鮤',
        '鱲',
        '鴷',
        '䴕',
        '𫚭',
    ],
    kuǎng: ['儣', '夼', '懭'],
    bào: [
        '儤',
        '勽',
        '報',
        '忁',
        '报',
        '抱',
        '曓',
        '爆',
        '犦',
        '菢',
        '虣',
        '蚫',
        '豹',
        '鉋',
        '鑤',
        '铇',
        '骲',
        '髱',
        '鮑',
        '鲍',
    ],
    biāo: [
        '儦',
        '墂',
        '幖',
        '彪',
        '标',
        '標',
        '滮',
        '瀌',
        '熛',
        '爂',
        '猋',
        '瘭',
        '磦',
        '膘',
        '臕',
        '謤',
        '贆',
        '鏢',
        '鑣',
        '镖',
        '镳',
        '颮',
        '颷',
        '飆',
        '飇',
        '飈',
        '飊',
        '飑',
        '飙',
        '飚',
        '驫',
        '骉',
        '髟',
    ],
    zǎn: ['儧', '儹', '噆', '攅', '昝', '趱', '趲'],
    háo: [
        '儫',
        '嗥',
        '嘷',
        '噑',
        '嚎',
        '壕',
        '椃',
        '毜',
        '毫',
        '濠',
        '獆',
        '獔',
        '竓',
        '籇',
        '蚝',
        '蠔',
        '譹',
        '豪',
    ],
    qìng: ['儬', '凊', '庆', '慶', '櫦', '濪', '碃', '磬', '罄', '靘'],
    chèn: [
        '儭',
        '嚫',
        '榇',
        '櫬',
        '疢',
        '衬',
        '襯',
        '讖',
        '谶',
        '趁',
        '趂',
        '齓',
        '齔',
        '龀',
    ],
    téng: [
        '儯',
        '幐',
        '滕',
        '漛',
        '疼',
        '籐',
        '籘',
        '縢',
        '腾',
        '藤',
        '虅',
        '螣',
        '誊',
        '謄',
        '邆',
        '駦',
        '騰',
        '驣',
        '鰧',
        '䲢',
    ],
    'lǒng lóng lòng': ['儱'],
    'chán chàn': ['儳'],
    'ráng xiāng': ['儴', '勷'],
    'huì xié': ['儶'],
    luó: [
        '儸',
        '攞',
        '椤',
        '欏',
        '猡',
        '玀',
        '箩',
        '籮',
        '罗',
        '羅',
        '脶',
        '腡',
        '萝',
        '蘿',
        '螺',
        '覼',
        '逻',
        '邏',
        '鏍',
        '鑼',
        '锣',
        '镙',
        '饠',
        '騾',
        '驘',
        '骡',
        '鸁',
    ],
    léi: [
        '儽',
        '嫘',
        '檑',
        '欙',
        '瓃',
        '畾',
        '縲',
        '纍',
        '纝',
        '缧',
        '罍',
        '羸',
        '蔂',
        '蘲',
        '虆',
        '轠',
        '鐳',
        '鑘',
        '镭',
        '雷',
        '靁',
        '鱩',
        '鼺',
    ],
    'nàng nāng': ['儾'],
    'wù wū': ['兀'],
    yǔn: [
        '允',
        '喗',
        '夽',
        '抎',
        '殒',
        '殞',
        '狁',
        '磒',
        '荺',
        '賱',
        '鈗',
        '阭',
        '陨',
        '隕',
        '霣',
        '馻',
        '齫',
        '齳',
    ],
    zān: ['兂', '橵', '簪', '簮', '糌', '鐕', '鐟', '鵤'],
    yuán: [
        '元',
        '円',
        '原',
        '厡',
        '厵',
        '园',
        '圆',
        '圎',
        '園',
        '圓',
        '垣',
        '塬',
        '媴',
        '嫄',
        '援',
        '榞',
        '榬',
        '橼',
        '櫞',
        '沅',
        '湲',
        '源',
        '溒',
        '爰',
        '猨',
        '猿',
        '笎',
        '緣',
        '縁',
        '缘',
        '羱',
        '茒',
        '薗',
        '蝝',
        '蝯',
        '螈',
        '袁',
        '褤',
        '謜',
        '轅',
        '辕',
        '邍',
        '邧',
        '酛',
        '鈨',
        '鎱',
        '騵',
        '魭',
        '鶢',
        '鶰',
        '黿',
        '鼋',
        '𫘪',
    ],
    xiōng: [
        '兄',
        '兇',
        '凶',
        '匂',
        '匈',
        '哅',
        '忷',
        '恟',
        '汹',
        '洶',
        '胷',
        '胸',
        '芎',
        '訩',
        '詾',
        '讻',
    ],
    chōng: [
        '充',
        '嘃',
        '忡',
        '憃',
        '憧',
        '摏',
        '沖',
        '浺',
        '珫',
        '罿',
        '翀',
        '舂',
        '艟',
        '茺',
        '衝',
        '蹖',
        '㳘',
    ],
    zhào: [
        '兆',
        '垗',
        '旐',
        '曌',
        '枛',
        '櫂',
        '照',
        '燳',
        '狣',
        '瞾',
        '笊',
        '罀',
        '罩',
        '羄',
        '肁',
        '肇',
        '肈',
        '詔',
        '诏',
        '赵',
        '趙',
        '鮡',
        '𬶐',
    ],
    'duì ruì yuè': ['兊', '兌', '兑'],
    kè: [
        '克',
        '刻',
        '勀',
        '勊',
        '堁',
        '娔',
        '客',
        '恪',
        '愙',
        '氪',
        '溘',
        '碦',
        '緙',
        '缂',
        '艐',
        '衉',
        '課',
        '课',
        '錁',
        '锞',
        '騍',
        '骒',
    ],
    tù: ['兎', '兔', '堍', '迌', '鵵'],
    dǎng: ['党', '攩', '欓', '譡', '讜', '谠', '黨', '𣗋'],
    dōu: ['兜', '兠', '唗', '橷', '篼', '蔸'],
    huǎng: [
        '兤',
        '奛',
        '幌',
        '怳',
        '恍',
        '晄',
        '炾',
        '熀',
        '縨',
        '詤',
        '謊',
        '谎',
    ],
    rù: ['入', '嗕', '媷', '扖', '杁', '洳', '溽', '縟', '缛', '蓐', '褥', '鳰'],
    nèi: ['內', '氝', '氞', '錗'],
    'yú shù': ['兪'],
    'liù lù': ['六'],
    han: ['兯', '爳'],
    tiān: ['兲', '天', '婖', '添', '酟', '靔', '靝', '黇'],
    'xīng xìng': ['兴'],
    diǎn: [
        '典',
        '嚸',
        '奌',
        '婰',
        '敟',
        '椣',
        '点',
        '碘',
        '蒧',
        '蕇',
        '踮',
        '點',
    ],
    'zī cí': ['兹'],
    jiān: [
        '兼',
        '冿',
        '囏',
        '坚',
        '堅',
        '奸',
        '姦',
        '姧',
        '尖',
        '幵',
        '惤',
        '戋',
        '戔',
        '搛',
        '椾',
        '樫',
        '櫼',
        '歼',
        '殱',
        '殲',
        '湔',
        '瀐',
        '瀸',
        '煎',
        '熞',
        '熸',
        '牋',
        '瑊',
        '睷',
        '礛',
        '礷',
        '笺',
        '箋',
        '緘',
        '縑',
        '缄',
        '缣',
        '肩',
        '艰',
        '艱',
        '菅',
        '菺',
        '葌',
        '蒹',
        '蔪',
        '蕑',
        '蕳',
        '虃',
        '譼',
        '豜',
        '鑯',
        '雃',
        '鞯',
        '韀',
        '韉',
        '餰',
        '馢',
        '鰔',
        '鰜',
        '鰹',
        '鲣',
        '鳒',
        '鵑',
        '鵳',
        '鶼',
        '鹣',
        '麉',
    ],
    shòu: [
        '兽',
        '受',
        '售',
        '壽',
        '夀',
        '寿',
        '授',
        '狩',
        '獣',
        '獸',
        '痩',
        '瘦',
        '綬',
        '绶',
        '膄',
    ],
    jì: [
        '兾',
        '冀',
        '剂',
        '剤',
        '劑',
        '勣',
        '坖',
        '垍',
        '塈',
        '妓',
        '季',
        '寂',
        '寄',
        '廭',
        '彑',
        '徛',
        '忌',
        '悸',
        '惎',
        '懻',
        '技',
        '旡',
        '既',
        '旣',
        '暨',
        '暩',
        '曁',
        '梞',
        '檕',
        '檵',
        '洎',
        '漃',
        '漈',
        '瀱',
        '痵',
        '癠',
        '禝',
        '稩',
        '稷',
        '穄',
        '穊',
        '穧',
        '紀',
        '継',
        '績',
        '繋',
        '繼',
        '继',
        '绩',
        '罽',
        '臮',
        '芰',
        '茍',
        '茤',
        '葪',
        '蓟',
        '蔇',
        '薊',
        '蘎',
        '蘮',
        '蘻',
        '裚',
        '襀',
        '覬',
        '觊',
        '計',
        '記',
        '誋',
        '计',
        '记',
        '跡',
        '跽',
        '蹟',
        '迹',
        '际',
        '際',
        '霁',
        '霽',
        '驥',
        '骥',
        '髻',
        '鬾',
        '魝',
        '魥',
        '鯚',
        '鯽',
        '鰶',
        '鰿',
        '鱀',
        '鱭',
        '鲚',
        '鲫',
        '鵋',
        '鷑',
        '齌',
        '𪟝',
        '𬶨',
        '𬶭',
    ],
    jiōng: ['冂', '冋', '坰', '埛', '扃', '蘏', '蘔', '駉', '駫', '𬳶'],
    mào: [
        '冃',
        '冐',
        '媢',
        '帽',
        '愗',
        '懋',
        '暓',
        '柕',
        '楙',
        '毷',
        '瑁',
        '皃',
        '眊',
        '瞀',
        '耄',
        '茂',
        '萺',
        '蝐',
        '袤',
        '覒',
        '貌',
        '貿',
        '贸',
        '鄚',
        '鄮',
    ],
    rǎn: ['冄', '冉', '姌', '媣', '染', '珃', '苒', '蒅', '䎃'],
    'nèi nà': ['内'],
    gāng: [
        '冈',
        '冮',
        '刚',
        '剛',
        '堈',
        '堽',
        '岡',
        '掆',
        '摃',
        '棡',
        '牨',
        '犅',
        '疘',
        '綱',
        '纲',
        '缸',
        '罁',
        '罡',
        '肛',
        '釭',
        '鎠',
        '㭎',
    ],
    cè: [
        '冊',
        '册',
        '厕',
        '厠',
        '夨',
        '廁',
        '恻',
        '惻',
        '憡',
        '敇',
        '测',
        '測',
        '笧',
        '策',
        '筞',
        '筴',
        '箣',
        '荝',
        '萗',
        '萴',
        '蓛',
    ],
    guǎ: ['冎', '剐', '剮', '叧', '寡'],
    'mào mò': ['冒'],
    gòu: [
        '冓',
        '啂',
        '坸',
        '垢',
        '够',
        '夠',
        '媾',
        '彀',
        '搆',
        '撀',
        '构',
        '構',
        '煹',
        '覯',
        '觏',
        '訽',
        '詬',
        '诟',
        '購',
        '购',
        '遘',
        '雊',
    ],
    xǔ: ['冔', '喣', '暊', '栩', '珝', '盨', '糈', '詡', '諿', '诩', '鄦', '醑'],
    mì: [
        '冖',
        '冪',
        '嘧',
        '塓',
        '宻',
        '密',
        '峚',
        '幂',
        '幎',
        '幦',
        '怽',
        '榓',
        '樒',
        '櫁',
        '汨',
        '淧',
        '滵',
        '漞',
        '濗',
        '熐',
        '羃',
        '蔤',
        '蜜',
        '覓',
        '覔',
        '覛',
        '觅',
        '謐',
        '谧',
        '鼏',
    ],
    'yóu yín': ['冘'],
    xiě: ['写', '冩', '藛'],
    jūn: [
        '军',
        '君',
        '均',
        '桾',
        '汮',
        '皲',
        '皸',
        '皹',
        '碅',
        '莙',
        '蚐',
        '袀',
        '覠',
        '軍',
        '鈞',
        '銁',
        '銞',
        '鍕',
        '钧',
        '頵',
        '鮶',
        '鲪',
        '麏',
    ],
    mí: [
        '冞',
        '擟',
        '瀰',
        '爢',
        '猕',
        '獼',
        '祢',
        '禰',
        '縻',
        '蒾',
        '藌',
        '蘪',
        '蘼',
        '袮',
        '詸',
        '謎',
        '迷',
        '醚',
        '醾',
        '醿',
        '釄',
        '镾',
        '鸍',
        '麊',
        '麋',
        '麛',
    ],
    'guān guàn': ['冠', '覌', '観', '觀', '观'],
    měng: [
        '冡',
        '勐',
        '懵',
        '掹',
        '猛',
        '獴',
        '艋',
        '蜢',
        '蠓',
        '錳',
        '锰',
        '鯭',
        '鼆',
    ],
    zhǒng: ['冢', '塚', '尰', '歱', '煄', '瘇', '肿', '腫', '踵'],
    zuì: [
        '冣',
        '嶵',
        '晬',
        '最',
        '栬',
        '槜',
        '檇',
        '檌',
        '祽',
        '絊',
        '罪',
        '蕞',
        '辠',
        '酔',
        '酻',
        '醉',
        '錊',
    ],
    yuān: [
        '冤',
        '剈',
        '囦',
        '嬽',
        '寃',
        '棩',
        '淵',
        '渁',
        '渆',
        '渊',
        '渕',
        '灁',
        '眢',
        '肙',
        '葾',
        '蒬',
        '蜎',
        '蜵',
        '駌',
        '鳶',
        '鴛',
        '鵷',
        '鸢',
        '鸳',
        '鹓',
        '鼘',
        '鼝',
    ],
    míng: [
        '冥',
        '名',
        '明',
        '暝',
        '朙',
        '榠',
        '洺',
        '溟',
        '猽',
        '眀',
        '眳',
        '瞑',
        '茗',
        '螟',
        '覭',
        '詺',
        '鄍',
        '銘',
        '铭',
        '鳴',
        '鸣',
    ],
    kòu: [
        '冦',
        '叩',
        '宼',
        '寇',
        '扣',
        '敂',
        '滱',
        '窛',
        '筘',
        '簆',
        '蔲',
        '蔻',
        '釦',
        '鷇',
    ],
    tài: [
        '冭',
        '太',
        '夳',
        '忲',
        '态',
        '態',
        '汰',
        '汱',
        '泰',
        '溙',
        '肽',
        '舦',
        '酞',
        '鈦',
        '钛',
    ],
    'féng píng': ['冯', '馮'],
    'chōng chòng': ['冲'],
    kuàng: [
        '况',
        '圹',
        '壙',
        '岲',
        '懬',
        '旷',
        '昿',
        '曠',
        '框',
        '況',
        '爌',
        '眖',
        '眶',
        '矿',
        '砿',
        '礦',
        '穬',
        '絋',
        '絖',
        '纊',
        '纩',
        '貺',
        '贶',
        '軦',
        '邝',
        '鄺',
        '鉱',
        '鋛',
        '鑛',
        '黋',
    ],
    lěng: ['冷'],
    pàn: [
        '冸',
        '判',
        '叛',
        '沜',
        '泮',
        '溿',
        '炍',
        '牉',
        '畔',
        '盼',
        '聁',
        '袢',
        '襻',
        '詊',
        '鋬',
        '鑻',
        '頖',
        '鵥',
    ],
    fā: ['冹', '彂', '沷', '発', '發'],
    xiǎn: [
        '冼',
        '尟',
        '尠',
        '崄',
        '嶮',
        '幰',
        '攇',
        '显',
        '櫶',
        '毨',
        '灦',
        '烍',
        '燹',
        '狝',
        '猃',
        '獫',
        '獮',
        '玁',
        '禒',
        '筅',
        '箲',
        '藓',
        '蘚',
        '蚬',
        '蜆',
        '譣',
        '赻',
        '跣',
        '鍌',
        '险',
        '険',
        '險',
        '韅',
        '顕',
        '顯',
        '㬎',
    ],
    qià: ['冾', '圶', '帢', '恰', '殎', '洽', '硈', '胢', '髂'],
    'jìng chēng': ['净', '凈', '淨'],
    sōu: [
        '凁',
        '嗖',
        '廀',
        '廋',
        '捜',
        '搜',
        '摉',
        '溲',
        '獀',
        '艘',
        '蒐',
        '螋',
        '鄋',
        '醙',
        '鎪',
        '锼',
        '颼',
        '飕',
        '餿',
        '馊',
        '騪',
    ],
    měi: [
        '凂',
        '媄',
        '媺',
        '嬍',
        '嵄',
        '挴',
        '毎',
        '每',
        '浼',
        '渼',
        '燘',
        '美',
        '躾',
        '鎂',
        '镁',
        '黣',
    ],
    tú: [
        '凃',
        '図',
        '图',
        '圖',
        '圗',
        '塗',
        '屠',
        '峹',
        '嵞',
        '庩',
        '廜',
        '徒',
        '悇',
        '揬',
        '涂',
        '瘏',
        '筡',
        '腯',
        '荼',
        '蒤',
        '跿',
        '途',
        '酴',
        '鈯',
        '鍎',
        '馟',
        '駼',
        '鵌',
        '鶟',
        '鷋',
        '鷵',
        '𬳿',
    ],
    zhǔn: ['准', '凖', '埻', '準', '𬘯'],
    'liáng liàng': ['凉', '涼', '量'],
    diāo: [
        '凋',
        '刁',
        '刟',
        '叼',
        '奝',
        '弴',
        '彫',
        '汈',
        '琱',
        '碉',
        '簓',
        '虭',
        '蛁',
        '貂',
        '錭',
        '雕',
        '鮉',
        '鯛',
        '鲷',
        '鵰',
        '鼦',
    ],
    còu: ['凑', '湊', '腠', '輳', '辏'],
    ái: ['凒', '啀', '嘊', '捱', '溰', '癌', '皑', '皚'],
    duó: ['凙', '剫', '夺', '奪', '痥', '踱', '鈬', '鐸', '铎'],
    dú: [
        '凟',
        '匵',
        '嬻',
        '椟',
        '櫝',
        '殰',
        '涜',
        '牍',
        '牘',
        '犊',
        '犢',
        '独',
        '獨',
        '瓄',
        '皾',
        '裻',
        '読',
        '讀',
        '讟',
        '豄',
        '贕',
        '錖',
        '鑟',
        '韇',
        '韣',
        '韥',
        '騳',
        '髑',
        '黩',
        '黷',
    ],
    'jǐ jī': ['几'],
    fán: [
        '凡',
        '凢',
        '凣',
        '匥',
        '墦',
        '杋',
        '柉',
        '棥',
        '樊',
        '瀿',
        '烦',
        '煩',
        '燔',
        '璠',
        '矾',
        '礬',
        '笲',
        '籵',
        '緐',
        '羳',
        '舤',
        '舧',
        '薠',
        '蘩',
        '蠜',
        '襎',
        '蹯',
        '釩',
        '鐇',
        '鐢',
        '钒',
        '鷭',
        '𫔍',
        '𬸪',
    ],
    jū: [
        '凥',
        '匊',
        '娵',
        '婮',
        '居',
        '崌',
        '抅',
        '挶',
        '掬',
        '梮',
        '椐',
        '檋',
        '毩',
        '毱',
        '泃',
        '涺',
        '狙',
        '琚',
        '疽',
        '砠',
        '罝',
        '腒',
        '艍',
        '蜛',
        '裾',
        '諊',
        '跔',
        '踘',
        '躹',
        '陱',
        '雎',
        '鞠',
        '鞫',
        '駒',
        '驹',
        '鮈',
        '鴡',
        '鶋',
        '𬶋',
    ],
    'chù chǔ': ['処', '处'],
    zhǐ: [
        '凪',
        '劧',
        '咫',
        '址',
        '坧',
        '帋',
        '恉',
        '扺',
        '指',
        '旨',
        '枳',
        '止',
        '汦',
        '沚',
        '洔',
        '淽',
        '疻',
        '砋',
        '祉',
        '秖',
        '紙',
        '纸',
        '芷',
        '藢',
        '衹',
        '襧',
        '訨',
        '趾',
        '軹',
        '轵',
        '酯',
        '阯',
        '黹',
    ],
    píng: [
        '凭',
        '凴',
        '呯',
        '坪',
        '塀',
        '岼',
        '帡',
        '帲',
        '幈',
        '平',
        '慿',
        '憑',
        '枰',
        '洴',
        '焩',
        '玶',
        '瓶',
        '甁',
        '竮',
        '箳',
        '簈',
        '缾',
        '荓',
        '萍',
        '蓱',
        '蚲',
        '蛢',
        '評',
        '评',
        '軿',
        '輧',
        '郱',
        '鮃',
        '鲆',
    ],
    kǎi: [
        '凯',
        '凱',
        '剀',
        '剴',
        '垲',
        '塏',
        '恺',
        '愷',
        '慨',
        '暟',
        '蒈',
        '輆',
        '鍇',
        '鎧',
        '铠',
        '锴',
        '闓',
        '闿',
        '颽',
    ],
    gān: [
        '凲',
        '坩',
        '尲',
        '尴',
        '尶',
        '尷',
        '柑',
        '泔',
        '漧',
        '玕',
        '甘',
        '疳',
        '矸',
        '竿',
        '筸',
        '粓',
        '肝',
        '苷',
        '迀',
        '酐',
        '魐',
    ],
    'kǎn qiǎn': ['凵'],
    tū: [
        '凸',
        '堗',
        '嶀',
        '捸',
        '涋',
        '湥',
        '痜',
        '禿',
        '秃',
        '突',
        '葖',
        '鋵',
        '鵚',
        '鼵',
        '㻬',
    ],
    'āo wā': ['凹'],
    chū: ['出', '初', '岀', '摴', '榋', '樗', '貙', '齣', '䢺', '䝙'],
    dàng: [
        '凼',
        '圵',
        '垱',
        '壋',
        '档',
        '檔',
        '氹',
        '璗',
        '瓽',
        '盪',
        '瞊',
        '砀',
        '碭',
        '礑',
        '簜',
        '荡',
        '菪',
        '蕩',
        '蘯',
        '趤',
        '逿',
        '雼',
        '𬍡',
    ],
    hán: [
        '函',
        '凾',
        '含',
        '圅',
        '娢',
        '寒',
        '崡',
        '晗',
        '梒',
        '浛',
        '涵',
        '澏',
        '焓',
        '琀',
        '甝',
        '筨',
        '蜬',
        '邗',
        '邯',
        '鋡',
        '韓',
        '韩',
    ],
    záo: ['凿', '鑿'],
    dāo: ['刀', '刂', '忉', '氘', '舠', '螩', '釖', '魛', '鱽'],
    chuāng: ['刅', '摐', '牎', '牕', '疮', '瘡', '窓', '窗', '窻'],
    'fēn fèn': ['分'],
    'qiè qiē': ['切'],
    kān: ['刊', '勘', '堪', '戡', '栞', '龕', '龛'],
    cǔn: ['刌', '忖'],
    chú: [
        '刍',
        '厨',
        '幮',
        '廚',
        '橱',
        '櫉',
        '櫥',
        '滁',
        '犓',
        '篨',
        '耡',
        '芻',
        '蒢',
        '蒭',
        '蜍',
        '蟵',
        '豠',
        '趎',
        '蹰',
        '躇',
        '躕',
        '鉏',
        '鋤',
        '锄',
        '除',
        '雏',
        '雛',
        '鶵',
    ],
    'huà huá': ['划'],
    lí: [
        '刕',
        '剓',
        '剺',
        '劙',
        '厘',
        '喱',
        '嚟',
        '囄',
        '嫠',
        '孷',
        '廲',
        '悡',
        '梨',
        '梸',
        '棃',
        '漓',
        '灕',
        '犁',
        '犂',
        '狸',
        '琍',
        '璃',
        '瓈',
        '盠',
        '睝',
        '离',
        '穲',
        '竰',
        '筣',
        '篱',
        '籬',
        '糎',
        '縭',
        '缡',
        '罹',
        '艃',
        '荲',
        '菞',
        '蓠',
        '蔾',
        '藜',
        '蘺',
        '蜊',
        '蟍',
        '蟸',
        '蠫',
        '褵',
        '謧',
        '貍',
        '醨',
        '鋫',
        '錅',
        '鏫',
        '鑗',
        '離',
        '驪',
        '骊',
        '鯏',
        '鯬',
        '鱺',
        '鲡',
        '鵹',
        '鸝',
        '鹂',
        '黎',
        '黧',
        '㰀',
    ],
    yuè: [
        '刖',
        '嬳',
        '岄',
        '岳',
        '嶽',
        '恱',
        '悅',
        '悦',
        '戉',
        '抈',
        '捳',
        '月',
        '樾',
        '瀹',
        '爚',
        '玥',
        '礿',
        '禴',
        '篗',
        '籆',
        '籥',
        '籰',
        '粤',
        '粵',
        '蘥',
        '蚎',
        '蚏',
        '説',
        '越',
        '跀',
        '跃',
        '躍',
        '軏',
        '鈅',
        '鉞',
        '鑰',
        '钺',
        '閱',
        '閲',
        '阅',
        '鸑',
        '鸙',
        '黦',
        '龠',
        '𫐄',
        '𬸚',
    ],
    liú: [
        '刘',
        '劉',
        '嚠',
        '媹',
        '嵧',
        '旈',
        '旒',
        '榴',
        '橊',
        '流',
        '浏',
        '瀏',
        '琉',
        '瑠',
        '瑬',
        '璢',
        '畄',
        '留',
        '畱',
        '疁',
        '瘤',
        '癅',
        '硫',
        '蒥',
        '蓅',
        '蟉',
        '裗',
        '鎏',
        '鏐',
        '鐂',
        '镠',
        '飀',
        '飅',
        '飗',
        '駠',
        '駵',
        '騮',
        '驑',
        '骝',
        '鰡',
        '鶹',
        '鹠',
        '麍',
    ],
    zé: [
        '则',
        '則',
        '啧',
        '嘖',
        '嫧',
        '帻',
        '幘',
        '択',
        '樍',
        '歵',
        '沢',
        '泎',
        '溭',
        '皟',
        '瞔',
        '矠',
        '礋',
        '箦',
        '簀',
        '舴',
        '蔶',
        '蠌',
        '襗',
        '謮',
        '賾',
        '赜',
        '迮',
        '鸅',
        '齚',
        '齰',
    ],
    'chuàng chuāng': ['创', '創'],
    qù: ['刞', '厺', '去', '閴', '闃', '阒', '麮', '鼁'],
    'bié biè': ['別', '别'],
    'páo bào': ['刨'],
    'chǎn chàn': ['刬', '剗', '幝'],
    guā: [
        '刮',
        '劀',
        '桰',
        '歄',
        '煱',
        '瓜',
        '胍',
        '踻',
        '颪',
        '颳',
        '騧',
        '鴰',
        '鸹',
    ],
    gēng: [
        '刯',
        '庚',
        '椩',
        '浭',
        '焿',
        '畊',
        '絚',
        '羮',
        '羹',
        '耕',
        '菮',
        '賡',
        '赓',
        '鶊',
        '鹒',
    ],
    dào: [
        '到',
        '噵',
        '悼',
        '椡',
        '檤',
        '燾',
        '瓙',
        '盗',
        '盜',
        '稲',
        '稻',
        '纛',
        '翿',
        '艔',
        '菿',
        '衜',
        '衟',
        '軇',
        '道',
    ],
    chuàng: ['刱', '剏', '剙', '怆', '愴'],
    kū: ['刳', '哭', '圐', '堀', '枯', '桍', '矻', '窟', '跍', '郀', '骷', '鮬'],
    duò: [
        '刴',
        '剁',
        '墯',
        '尮',
        '惰',
        '憜',
        '挅',
        '桗',
        '舵',
        '跥',
        '跺',
        '陊',
        '陏',
        '飿',
        '饳',
        '鵽',
    ],
    'shuā shuà': ['刷'],
    'quàn xuàn': ['券'],
    'chà shā': ['刹', '剎'],
    'cì cī': ['刺'],
    guì: [
        '刽',
        '刿',
        '劊',
        '劌',
        '撌',
        '攰',
        '昋',
        '桂',
        '椢',
        '槶',
        '樻',
        '櫃',
        '猤',
        '禬',
        '筀',
        '蓕',
        '襘',
        '貴',
        '贵',
        '跪',
        '鐀',
        '鑎',
        '鞼',
        '鱖',
        '鱥',
    ],
    lóu: [
        '剅',
        '娄',
        '婁',
        '廔',
        '楼',
        '樓',
        '溇',
        '漊',
        '熡',
        '耧',
        '耬',
        '艛',
        '蒌',
        '蔞',
        '蝼',
        '螻',
        '謱',
        '軁',
        '遱',
        '鞻',
        '髅',
        '髏',
        '𪣻',
    ],
    cuò: [
        '剉',
        '剒',
        '厝',
        '夎',
        '挫',
        '措',
        '棤',
        '莝',
        '莡',
        '蓌',
        '逪',
        '銼',
        '錯',
        '锉',
        '错',
    ],
    'xiāo xuē': ['削'],
    'kēi kè': ['剋', '尅'],
    'là lá': ['剌'],
    tī: ['剔', '梯', '踢', '銻', '锑', '鷈', '鷉', '䏲', '䴘'],
    pōu: ['剖'],
    wān: ['剜', '塆', '壪', '帵', '弯', '彎', '湾', '潫', '灣', '睕', '蜿', '豌'],
    'bāo bō': ['剝', '剥'],
    duō: ['剟', '咄', '哆', '嚉', '多', '夛', '掇', '毲', '畓', '裰', '㙍'],
    qíng: [
        '剠',
        '勍',
        '夝',
        '情',
        '擎',
        '晴',
        '暒',
        '棾',
        '樈',
        '檠',
        '氰',
        '甠',
        '硘',
        '葝',
        '黥',
    ],
    'yǎn shàn': ['剡'],
    'dū zhuó': ['剢'],
    yān: [
        '剦',
        '嫣',
        '崦',
        '嶖',
        '恹',
        '懕',
        '懨',
        '樮',
        '淊',
        '淹',
        '漹',
        '烟',
        '焉',
        '焑',
        '煙',
        '珚',
        '篶',
        '胭',
        '臙',
        '菸',
        '鄢',
        '醃',
        '閹',
        '阉',
        '黫',
    ],
    huō: ['剨', '劐', '吙', '攉', '秴', '耠', '锪', '騞', '𬴃'],
    shèng: [
        '剩',
        '剰',
        '勝',
        '圣',
        '墭',
        '嵊',
        '晠',
        '榺',
        '橳',
        '琞',
        '聖',
        '蕂',
        '貹',
        '賸',
    ],
    'duān zhì': ['剬'],
    wū: [
        '剭',
        '呜',
        '嗚',
        '圬',
        '屋',
        '巫',
        '弙',
        '杇',
        '歍',
        '汙',
        '汚',
        '污',
        '洿',
        '烏',
        '窏',
        '箼',
        '螐',
        '誈',
        '誣',
        '诬',
        '邬',
        '鄔',
        '鎢',
        '钨',
        '鰞',
        '鴮',
    ],
    gē: [
        '割',
        '哥',
        '圪',
        '彁',
        '戈',
        '戓',
        '戨',
        '歌',
        '滒',
        '犵',
        '肐',
        '袼',
        '謌',
        '鎶',
        '鴚',
        '鴿',
        '鸽',
    ],
    'dá zhá': ['剳'],
    chuán: ['剶', '暷', '椽', '篅', '舡', '舩', '船', '輲', '遄'],
    'tuán zhuān': ['剸', '漙', '篿'],
    'lù jiū': ['剹'],
    pēng: ['剻', '匉', '嘭', '怦', '恲', '抨', '梈', '烹', '砰', '軯', '駍'],
    piāo: ['剽', '勡', '慓', '旚', '犥', '翲', '螵', '飃', '飄', '飘', '魒'],
    kōu: ['剾', '彄', '抠', '摳', '眍', '瞘', '芤', '𫸩'],
    'jiǎo chāo': ['剿', '劋', '勦', '摷'],
    qiāo: [
        '劁',
        '勪',
        '墝',
        '幧',
        '敲',
        '橇',
        '毃',
        '燆',
        '硗',
        '磽',
        '繑',
        '趬',
        '跷',
        '踍',
        '蹺',
        '蹻',
        '郻',
        '鄡',
        '鄥',
        '鍫',
        '鍬',
        '鐰',
        '锹',
        '頝',
    ],
    'huá huà': ['劃'],
    'zhā zhá': ['劄'],
    'pī pǐ': ['劈', '悂'],
    tāng: ['劏', '嘡', '羰', '薚', '蝪', '蹚', '鞺', '鼞'],
    chán: [
        '劖',
        '嚵',
        '壥',
        '婵',
        '嬋',
        '巉',
        '廛',
        '棎',
        '毚',
        '湹',
        '潹',
        '潺',
        '澶',
        '瀍',
        '瀺',
        '煘',
        '獑',
        '磛',
        '緾',
        '纏',
        '纒',
        '缠',
        '艬',
        '蝉',
        '蟐',
        '蟬',
        '蟾',
        '誗',
        '讒',
        '谗',
        '躔',
        '鄽',
        '酁',
        '鋋',
        '鑱',
        '镵',
        '饞',
        '馋',
    ],
    zuān: ['劗', '躜', '躦', '鉆', '鑚'],
    mó: [
        '劘',
        '嫫',
        '嬤',
        '嬷',
        '尛',
        '摹',
        '擵',
        '橅',
        '糢',
        '膜',
        '藦',
        '蘑',
        '謨',
        '謩',
        '谟',
        '饃',
        '饝',
        '馍',
        '髍',
        '魔',
        '魹',
    ],
    zhú: [
        '劚',
        '斸',
        '曯',
        '欘',
        '灟',
        '炢',
        '烛',
        '燭',
        '爥',
        '瘃',
        '竹',
        '笁',
        '笜',
        '舳',
        '茿',
        '蓫',
        '蠋',
        '蠾',
        '躅',
        '逐',
        '逫',
        '钃',
        '鱁',
    ],
    quàn: ['劝', '勧', '勸', '牶', '韏'],
    'jìn jìng': ['劤', '劲', '勁'],
    kēng: ['劥', '坑', '牼', '硁', '硜', '誙', '銵', '鍞', '鏗', '铿', '阬'],
    'xié liè': ['劦'],
    'zhù chú': ['助'],
    nǔ: ['努', '弩', '砮', '胬'],
    shào: ['劭', '卲', '哨', '潲', '紹', '綤', '绍', '袑', '邵'],
    miǎo: ['劰', '杪', '淼', '渺', '眇', '秒', '篎', '緲', '缈', '藐', '邈'],
    kǒu: ['劶', '口'],
    wā: [
        '劸',
        '娲',
        '媧',
        '屲',
        '挖',
        '攨',
        '洼',
        '溛',
        '漥',
        '瓾',
        '畖',
        '穵',
        '窊',
        '窪',
        '蛙',
        '韈',
        '鼃',
    ],
    kuāng: [
        '劻',
        '匡',
        '匩',
        '哐',
        '恇',
        '洭',
        '筐',
        '筺',
        '誆',
        '诓',
        '軭',
        '邼',
    ],
    hé: [
        '劾',
        '咊',
        '啝',
        '姀',
        '峆',
        '敆',
        '曷',
        '柇',
        '楁',
        '毼',
        '河',
        '涸',
        '渮',
        '澕',
        '熆',
        '皬',
        '盇',
        '盉',
        '盍',
        '盒',
        '禾',
        '篕',
        '籺',
        '粭',
        '翮',
        '菏',
        '萂',
        '覈',
        '訸',
        '詥',
        '郃',
        '釛',
        '鉌',
        '鑉',
        '閡',
        '闔',
        '阂',
        '阖',
        '鞨',
        '頜',
        '餄',
        '饸',
        '魺',
        '鹖',
        '麧',
        '齕',
        '龁',
        '龢',
        '𬌗',
    ],
    gào: [
        '勂',
        '吿',
        '告',
        '峼',
        '祮',
        '祰',
        '禞',
        '筶',
        '誥',
        '诰',
        '郜',
        '鋯',
        '锆',
    ],
    'bó bèi': ['勃'],
    láng: [
        '勆',
        '嫏',
        '廊',
        '斏',
        '桹',
        '榔',
        '樃',
        '欴',
        '狼',
        '琅',
        '瑯',
        '硠',
        '稂',
        '艆',
        '蓈',
        '蜋',
        '螂',
        '躴',
        '郒',
        '郞',
        '鋃',
        '鎯',
        '锒',
    ],
    xūn: [
        '勋',
        '勛',
        '勲',
        '勳',
        '嚑',
        '坃',
        '埙',
        '塤',
        '壎',
        '壦',
        '曛',
        '燻',
        '獯',
        '矄',
        '纁',
        '臐',
        '薫',
        '薰',
        '蘍',
        '醺',
        '𫄸',
    ],
    'juàn juān': ['勌', '瓹'],
    'lè lēi': ['勒'],
    kài: ['勓', '炌', '烗', '鎎'],
    'wěng yǎng': ['勜'],
    qín: [
        '勤',
        '嗪',
        '噙',
        '嶜',
        '庈',
        '懃',
        '懄',
        '捦',
        '擒',
        '斳',
        '檎',
        '澿',
        '珡',
        '琴',
        '琹',
        '瘽',
        '禽',
        '秦',
        '耹',
        '芩',
        '芹',
        '菦',
        '螓',
        '蠄',
        '鈙',
        '鈫',
        '雂',
        '靲',
        '鳹',
        '鵭',
    ],
    jiàng: [
        '勥',
        '匞',
        '匠',
        '嵹',
        '弜',
        '弶',
        '摾',
        '櫤',
        '洚',
        '滰',
        '犟',
        '糡',
        '糨',
        '絳',
        '绛',
        '謽',
        '酱',
        '醤',
        '醬',
    ],
    fān: [
        '勫',
        '嬏',
        '帆',
        '幡',
        '忛',
        '憣',
        '旙',
        '旛',
        '繙',
        '翻',
        '藩',
        '轓',
        '颿',
        '飜',
        '鱕',
    ],
    juān: ['勬', '姢', '娟', '捐', '涓', '蠲', '裐', '鎸', '鐫', '镌', '鹃'],
    'tóng dòng': ['勭', '烔', '燑', '狪'],
    lǜ: [
        '勴',
        '垏',
        '嵂',
        '律',
        '慮',
        '氯',
        '滤',
        '濾',
        '爈',
        '箻',
        '綠',
        '繂',
        '膟',
        '葎',
        '虑',
        '鑢',
    ],
    chè: [
        '勶',
        '坼',
        '彻',
        '徹',
        '掣',
        '撤',
        '澈',
        '烢',
        '爡',
        '瞮',
        '硩',
        '聅',
        '迠',
        '頙',
        '㬚',
    ],
    sháo: ['勺', '玿', '韶'],
    'gōu gòu': ['勾'],
    cōng: [
        '匆',
        '囪',
        '囱',
        '忩',
        '怱',
        '悤',
        '暰',
        '樬',
        '漗',
        '瑽',
        '璁',
        '瞛',
        '篵',
        '繱',
        '聡',
        '聦',
        '聪',
        '聰',
        '苁',
        '茐',
        '葱',
        '蓯',
        '蔥',
        '蟌',
        '鍯',
        '鏓',
        '鏦',
        '騘',
        '驄',
        '骢',
    ],
    'táo yáo': ['匋', '陶'],
    páo: ['匏', '咆', '垉', '庖', '爮', '狍', '袍', '褜', '軳', '鞄', '麅'],
    dá: [
        '匒',
        '妲',
        '怛',
        '炟',
        '燵',
        '畣',
        '笪',
        '羍',
        '荙',
        '薘',
        '蟽',
        '詚',
        '达',
        '迏',
        '迖',
        '迚',
        '逹',
        '達',
        '鐽',
        '靼',
        '鞑',
        '韃',
        '龖',
        '龘',
        '𫟼',
    ],
    'huà huā': ['化'],
    'běi bèi': ['北'],
    nǎo: ['匘', '垴', '堖', '嫐', '恼', '悩', '惱', '瑙', '碯', '脑', '脳', '腦'],
    'chí shi': ['匙'],
    fāng: ['匚', '堏', '方', '淓', '牥', '芳', '邡', '鈁', '錺', '钫', '鴋'],
    zā: ['匝', '咂', '帀', '沞', '臜', '臢', '迊', '鉔', '魳'],
    qiè: [
        '匧',
        '厒',
        '妾',
        '怯',
        '悏',
        '惬',
        '愜',
        '挈',
        '穕',
        '窃',
        '竊',
        '笡',
        '箧',
        '篋',
        '籡',
        '踥',
        '鍥',
        '锲',
        '鯜',
    ],
    'zāng cáng': ['匨'],
    fěi: ['匪', '奜', '悱', '棐', '榧', '篚', '翡', '蕜', '誹', '诽'],
    'kuì guì': ['匮', '匱'],
    suǎn: ['匴'],
    pǐ: ['匹', '噽', '嚭', '圮', '庀', '痞', '癖', '脴', '苉', '銢', '鴄'],
    'qū ōu': ['区', '區'],
    'kē qià': ['匼'],
    'yǎn yàn': ['匽', '棪'],
    biǎn: ['匾', '惼', '揙', '碥', '稨', '窆', '藊', '褊', '貶', '贬', '鴘'],
    nì: [
        '匿',
        '堄',
        '嫟',
        '嬺',
        '惄',
        '愵',
        '昵',
        '暱',
        '氼',
        '眤',
        '睨',
        '縌',
        '胒',
        '腻',
        '膩',
        '逆',
        '𨺙',
    ],
    niàn: ['卄', '唸', '埝', '廿', '念', '惗', '艌'],
    sà: ['卅', '櫒', '脎', '萨', '蕯', '薩', '鈒', '隡', '颯', '飒', '馺'],
    zú: ['卆', '哫', '崪', '族', '箤', '足', '踤', '镞'],
    shēng: [
        '升',
        '呏',
        '声',
        '斘',
        '昇',
        '曻',
        '枡',
        '殅',
        '泩',
        '湦',
        '焺',
        '牲',
        '珄',
        '生',
        '甥',
        '竔',
        '笙',
        '聲',
        '鉎',
        '鍟',
        '阩',
        '陞',
        '陹',
        '鵿',
        '鼪',
    ],
    wàn: [
        '卍',
        '卐',
        '忨',
        '杤',
        '瞣',
        '脕',
        '腕',
        '萬',
        '蟃',
        '贎',
        '輐',
        '錽',
        '𬇕',
    ],
    'huá huà huā': ['华', '華'],
    bēi: ['卑', '悲', '揹', '杯', '桮', '盃', '碑', '藣', '鵯', '鹎'],
    'zú cù': ['卒'],
    'dān shàn chán': ['单', '單'],
    'nán nā': ['南'],
    'shuài lǜ': ['卛'],
    'bǔ bo pú': ['卜'],
    'kuàng guàn': ['卝'],
    biàn: [
        '卞',
        '变',
        '変',
        '峅',
        '弁',
        '徧',
        '忭',
        '抃',
        '昪',
        '汳',
        '汴',
        '玣',
        '艑',
        '苄',
        '覍',
        '諚',
        '變',
        '辡',
        '辧',
        '辨',
        '辩',
        '辫',
        '辮',
        '辯',
        '遍',
        '釆',
        '𨚕',
    ],
    bǔ: ['卟', '哺', '捕', '补', '補', '鸔', '𬷕'],
    'zhàn zhān': ['占', '覱'],
    'kǎ qiǎ': ['卡'],
    lú: [
        '卢',
        '嚧',
        '垆',
        '壚',
        '庐',
        '廬',
        '曥',
        '枦',
        '栌',
        '櫨',
        '泸',
        '瀘',
        '炉',
        '爐',
        '獹',
        '玈',
        '瓐',
        '盧',
        '矑',
        '籚',
        '纑',
        '罏',
        '胪',
        '臚',
        '舮',
        '舻',
        '艫',
        '芦',
        '蘆',
        '蠦',
        '轤',
        '轳',
        '鈩',
        '鑪',
        '顱',
        '颅',
        '馿',
        '髗',
        '魲',
        '鱸',
        '鲈',
        '鸕',
        '鸬',
        '黸',
        '𬬻',
    ],
    lǔ: [
        '卤',
        '塷',
        '掳',
        '擄',
        '樐',
        '橹',
        '櫓',
        '氌',
        '滷',
        '澛',
        '瀂',
        '硵',
        '磠',
        '穞',
        '艣',
        '艪',
        '蓾',
        '虏',
        '虜',
        '鏀',
        '鐪',
        '鑥',
        '镥',
        '魯',
        '鲁',
        '鹵',
    ],
    guà: ['卦', '啩', '挂', '掛', '罣', '褂', '詿', '诖'],
    'áng yǎng': ['卬'],
    yìn: [
        '印',
        '垽',
        '堷',
        '廕',
        '慭',
        '憖',
        '憗',
        '懚',
        '洕',
        '湚',
        '猌',
        '癊',
        '胤',
        '茚',
        '酳',
        '鮣',
        '䲟',
    ],
    què: [
        '却',
        '卻',
        '塙',
        '崅',
        '悫',
        '愨',
        '慤',
        '搉',
        '榷',
        '燩',
        '琷',
        '皵',
        '确',
        '確',
        '礭',
        '闋',
        '阕',
        '鵲',
        '鹊',
        '𬒈',
    ],
    luǎn: ['卵'],
    'juàn juǎn': ['卷', '巻'],
    'chǎng ān hàn': ['厂'],
    'wěi yán': ['厃'],
    tīng: [
        '厅',
        '厛',
        '听',
        '庁',
        '廰',
        '廳',
        '汀',
        '烃',
        '烴',
        '綎',
        '耓',
        '聴',
        '聼',
        '聽',
        '鞓',
        '𬘩',
    ],
    'zhé zhái': ['厇'],
    'hàn àn': ['厈', '屽'],
    yǎ: ['厊', '唖', '庌', '痖', '瘂', '蕥'],
    shè: [
        '厍',
        '厙',
        '弽',
        '慑',
        '慴',
        '懾',
        '摂',
        '欇',
        '涉',
        '涻',
        '渉',
        '滠',
        '灄',
        '社',
        '舎',
        '蔎',
        '蠂',
        '設',
        '设',
        '赦',
        '騇',
        '麝',
    ],
    dǐ: [
        '厎',
        '呧',
        '坘',
        '弤',
        '抵',
        '拞',
        '掋',
        '牴',
        '砥',
        '菧',
        '觝',
        '詆',
        '诋',
        '軧',
        '邸',
        '阺',
        '骶',
        '鯳',
    ],
    'zhǎ zhǎi': ['厏'],
    páng: ['厐', '嫎', '庞', '徬', '舽', '螃', '逄', '鰟', '鳑', '龎', '龐'],
    'zhì shī': ['厔'],
    máng: [
        '厖',
        '吂',
        '哤',
        '娏',
        '忙',
        '恾',
        '杗',
        '杧',
        '汒',
        '浝',
        '牻',
        '痝',
        '盲',
        '硭',
        '笀',
        '芒',
        '茫',
        '蘉',
        '邙',
        '釯',
        '鋩',
        '铓',
        '駹',
    ],
    zuī: ['厜', '樶', '纗', '蟕'],
    'shà xià': ['厦', '廈'],
    áo: [
        '厫',
        '嗷',
        '嗸',
        '廒',
        '敖',
        '滶',
        '獒',
        '獓',
        '璈',
        '翱',
        '翶',
        '翺',
        '聱',
        '蔜',
        '螯',
        '謷',
        '謸',
        '遨',
        '鏖',
        '隞',
        '鰲',
        '鳌',
        '鷔',
        '鼇',
    ],
    'lán qiān': ['厱'],
    'sī mǒu': ['厶'],
    'gōng hóng': ['厷'],
    'lín miǎo': ['厸'],
    'qiú róu': ['厹'],
    dū: ['厾', '嘟', '督', '醏'],
    'xiàn xuán': ['县', '縣'],
    'cān shēn cēn sān': ['参', '參', '叄', '叅'],
    'ài yǐ': ['叆'],
    'chā chà chǎ chá': ['叉'],
    shuāng: [
        '双',
        '孀',
        '孇',
        '欆',
        '礵',
        '艭',
        '雙',
        '霜',
        '騻',
        '驦',
        '骦',
        '鷞',
        '鸘',
        '鹴',
    ],
    shōu: ['収', '收'],
    guái: ['叏'],
    bá: [
        '叐',
        '妭',
        '抜',
        '拔',
        '炦',
        '癹',
        '胈',
        '茇',
        '菝',
        '詙',
        '跋',
        '軷',
        '魃',
        '鼥',
    ],
    'fā fà': ['发'],
    'zhuó yǐ lì jué': ['叕'],
    qǔ: ['取', '娶', '竬', '蝺', '詓', '齲', '龋'],
    'jiǎ xiá': ['叚', '徦'],
    'wèi yù': ['叞', '尉', '蔚'],
    dié: [
        '叠',
        '垤',
        '堞',
        '峌',
        '幉',
        '恎',
        '惵',
        '戜',
        '曡',
        '殜',
        '氎',
        '牃',
        '牒',
        '瓞',
        '畳',
        '疂',
        '疉',
        '疊',
        '碟',
        '絰',
        '绖',
        '耊',
        '耋',
        '胅',
        '艓',
        '苵',
        '蜨',
        '蝶',
        '褋',
        '詄',
        '諜',
        '谍',
        '跮',
        '蹀',
        '迭',
        '镻',
        '鰈',
        '鲽',
        '鴩',
        '𫶇',
    ],
    ruì: ['叡', '枘', '汭', '瑞', '睿', '芮', '蚋', '蜹', '銳', '鋭', '锐'],
    'jù gōu': ['句'],
    lìng: ['另', '呤', '炩', '蘦'],
    'dāo dáo tāo': ['叨'],
    'zhī zhǐ': ['只'],
    jiào: [
        '叫',
        '呌',
        '嘂',
        '嘦',
        '噍',
        '嬓',
        '斍',
        '斠',
        '滘',
        '漖',
        '獥',
        '珓',
        '皭',
        '窖',
        '藠',
        '訆',
        '譥',
        '趭',
        '較',
        '轎',
        '轿',
        '较',
        '酵',
        '醮',
        '釂',
    ],
    'zhào shào': ['召'],
    'kě kè': ['可'],
    'tái tāi': ['台', '苔'],
    pǒ: ['叵', '尀', '笸', '箥', '鉕', '钷', '駊'],
    'yè xié': ['叶'],
    'hào háo': ['号'],
    tàn: ['叹', '嘆', '探', '歎', '湠', '炭', '碳', '舕'],
    'hōng hóng': ['叿'],
    miē: ['吀', '咩', '哶', '孭'],
    'xū yū yù': ['吁'],
    chī: [
        '吃',
        '哧',
        '喫',
        '嗤',
        '噄',
        '妛',
        '媸',
        '彨',
        '彲',
        '摛',
        '攡',
        '殦',
        '瓻',
        '痴',
        '癡',
        '眵',
        '瞝',
        '笞',
        '粚',
        '胵',
        '蚩',
        '螭',
        '訵',
        '魑',
        '鴟',
        '鵄',
        '鸱',
        '黐',
        '齝',
        '𫄨',
    ],
    'xuān sòng': ['吅'],
    yāo: [
        '吆',
        '喓',
        '夭',
        '妖',
        '幺',
        '楆',
        '殀',
        '祅',
        '腰',
        '葽',
        '訞',
        '邀',
        '鴁',
        '鴢',
        '㙘',
    ],
    zǐ: [
        '吇',
        '姉',
        '姊',
        '子',
        '杍',
        '梓',
        '榟',
        '橴',
        '滓',
        '矷',
        '秭',
        '笫',
        '籽',
        '紫',
        '耔',
        '虸',
        '訿',
        '釨',
    ],
    'hé gě': ['合', '鲄'],
    'cùn dòu': ['吋'],
    'tóng tòng': ['同'],
    'tǔ tù': ['吐', '唋'],
    'zhà zhā': ['吒', '奓'],
    'xià hè': ['吓'],
    'ā yā': ['吖'],
    'ma má mǎ': ['吗'],
    lìn: [
        '吝',
        '恡',
        '悋',
        '橉',
        '焛',
        '甐',
        '膦',
        '蔺',
        '藺',
        '賃',
        '赁',
        '蹸',
        '躏',
        '躙',
        '躪',
        '轥',
        '閵',
    ],
    tūn: ['吞', '暾', '朜', '焞'],
    'bǐ pǐ': ['吡'],
    qìn: ['吢', '吣', '唚', '抋', '揿', '搇', '撳', '沁', '瀙', '菣', '藽'],
    'jiè gè': ['吤'],
    'fǒu pǐ': ['否'],
    'ba bā': ['吧'],
    dūn: [
        '吨',
        '噸',
        '墩',
        '墪',
        '惇',
        '撉',
        '撴',
        '犜',
        '獤',
        '礅',
        '蜳',
        '蹾',
        '驐',
    ],
    fēn: [
        '吩',
        '帉',
        '昐',
        '朆',
        '梤',
        '棻',
        '氛',
        '竕',
        '紛',
        '纷',
        '翂',
        '芬',
        '衯',
        '訜',
        '躮',
        '酚',
        '鈖',
        '雰',
        '餴',
        '饙',
        '馚',
    ],
    'é huā': ['吪'],
    'kēng háng': ['吭', '妔'],
    shǔn: ['吮'],
    'zhī zī': ['吱'],
    'yǐn shěn': ['吲'],
    wú: [
        '吳',
        '吴',
        '呉',
        '墲',
        '峿',
        '梧',
        '橆',
        '毋',
        '洖',
        '浯',
        '無',
        '珸',
        '璑',
        '祦',
        '芜',
        '茣',
        '莁',
        '蕪',
        '蜈',
        '蟱',
        '譕',
        '郚',
        '鋙',
        '铻',
        '鯃',
        '鵐',
        '鷡',
        '鹀',
        '鼯',
    ],
    'chǎo chāo': ['吵'],
    'nà nè': ['吶'],
    'xuè chuò jué': ['吷'],
    chuī: ['吹', '炊', '龡'],
    'dōu rú': ['吺'],
    hǒu: ['吼', '犼'],
    'hōng hǒu ōu': ['吽'],
    'wú yù': ['吾'],
    'ya yā': ['呀'],
    'è e': ['呃'],
    dāi: ['呆', '懛', '獃'],
    'mèn qǐ': ['呇'],
    hōng: [
        '呍',
        '嚝',
        '揈',
        '灴',
        '烘',
        '焢',
        '硡',
        '薨',
        '訇',
        '谾',
        '軣',
        '輷',
        '轟',
        '轰',
        '鍧',
    ],
    nà: [
        '呐',
        '捺',
        '笝',
        '納',
        '纳',
        '肭',
        '蒳',
        '衲',
        '豽',
        '貀',
        '軜',
        '郍',
        '鈉',
        '钠',
        '靹',
        '魶',
    ],
    'tūn tiān': ['呑'],
    'fǔ ḿ': ['呒', '嘸'],
    'dāi tǎi': ['呔'],
    'ǒu ōu òu': ['呕'],
    'bài bei': ['呗'],
    'yuán yún yùn': ['员', '員'],
    guō: [
        '呙',
        '啯',
        '嘓',
        '埚',
        '堝',
        '墎',
        '崞',
        '彉',
        '彍',
        '懖',
        '猓',
        '瘑',
        '聒',
        '蝈',
        '蟈',
        '郭',
        '鈛',
        '鍋',
        '锅',
    ],
    'huá qì': ['呚'],
    'qiàng qiāng': ['呛', '跄'],
    shī: [
        '呞',
        '失',
        '尸',
        '屍',
        '师',
        '師',
        '施',
        '浉',
        '湤',
        '湿',
        '溮',
        '溼',
        '濕',
        '狮',
        '獅',
        '瑡',
        '絁',
        '葹',
        '蒒',
        '蓍',
        '虱',
        '蝨',
        '褷',
        '襹',
        '詩',
        '诗',
        '邿',
        '釃',
        '鉇',
        '鍦',
        '鯴',
        '鰤',
        '鲺',
        '鳲',
        '鳾',
        '鶳',
        '鸤',
        '䴓',
        '𫚕',
    ],
    juǎn: ['呟', '埍', '臇', '菤', '錈', '锩'],
    pěn: ['呠', '翸'],
    'wěn mǐn': ['呡'],
    'ne ní': ['呢'],
    'ḿ m̀ móu': ['呣'],
    rán: [
        '呥',
        '嘫',
        '然',
        '燃',
        '繎',
        '肰',
        '蚦',
        '蚺',
        '衻',
        '袇',
        '袡',
        '髥',
        '髯',
    ],
    'tiè chè': ['呫'],
    'qì zhī': ['呮'],
    'zǐ cī': ['呰'],
    'guā gū guǎ': ['呱'],
    'cī zī': ['呲'],
    'hǒu xǔ gòu': ['呴'],
    'hē ā á ǎ à a': ['呵'],
    náo: [
        '呶',
        '夒',
        '峱',
        '嶩',
        '巎',
        '挠',
        '撓',
        '猱',
        '硇',
        '蛲',
        '蟯',
        '詉',
        '譊',
        '鐃',
        '铙',
    ],
    'xiā gā': ['呷'],
    pēi: ['呸', '怌', '肧', '胚', '衃', '醅'],
    'háo xiāo': ['呺'],
    mìng: ['命', '掵'],
    'dá dàn': ['呾'],
    'zuǐ jǔ': ['咀'],
    'xián gān': ['咁'],
    pǒu: ['咅', '哣', '犃'],
    'yǎng yāng': ['咉'],
    'zǎ zé zhā': ['咋'],
    'hé hè huó huò hú': ['和'],
    hāi: ['咍'],
    dā: ['咑', '哒', '噠', '墶', '搭', '撘', '耷', '褡', '鎝', '𨱏'],
    'kǎ kā': ['咔'],
    gū: [
        '咕',
        '唂',
        '唃',
        '姑',
        '嫴',
        '孤',
        '巬',
        '巭',
        '柧',
        '橭',
        '沽',
        '泒',
        '稒',
        '笟',
        '箍',
        '箛',
        '篐',
        '罛',
        '苽',
        '菇',
        '菰',
        '蓇',
        '觚',
        '軱',
        '軲',
        '轱',
        '辜',
        '酤',
        '鈲',
        '鮕',
        '鴣',
        '鸪',
    ],
    'kā gā': ['咖'],
    zuo: ['咗'],
    lóng: [
        '咙',
        '嚨',
        '嶐',
        '巃',
        '巄',
        '昽',
        '曨',
        '朧',
        '栊',
        '槞',
        '櫳',
        '湰',
        '滝',
        '漋',
        '爖',
        '珑',
        '瓏',
        '癃',
        '眬',
        '矓',
        '砻',
        '礱',
        '礲',
        '窿',
        '竜',
        '聋',
        '聾',
        '胧',
        '茏',
        '蘢',
        '蠪',
        '蠬',
        '襱',
        '豅',
        '鏧',
        '鑨',
        '霳',
        '靇',
        '驡',
        '鸗',
        '龍',
        '龒',
        '龙',
    ],
    'xiàn xián': ['咞'],
    qì: [
        '咠',
        '唭',
        '噐',
        '器',
        '夡',
        '弃',
        '憇',
        '憩',
        '暣',
        '棄',
        '欫',
        '气',
        '気',
        '氣',
        '汔',
        '汽',
        '泣',
        '湆',
        '湇',
        '炁',
        '甈',
        '盵',
        '矵',
        '碛',
        '碶',
        '磜',
        '磧',
        '罊',
        '芞',
        '葺',
        '藒',
        '蟿',
        '訖',
        '讫',
        '迄',
        '鐑',
    ],
    'xì dié': ['咥'],
    'liē liě lié lie': ['咧'],
    zī: [
        '咨',
        '嗞',
        '姕',
        '姿',
        '孜',
        '孳',
        '孶',
        '崰',
        '嵫',
        '栥',
        '椔',
        '淄',
        '湽',
        '滋',
        '澬',
        '玆',
        '禌',
        '秶',
        '粢',
        '紎',
        '緇',
        '緕',
        '纃',
        '缁',
        '茊',
        '茲',
        '葘',
        '諮',
        '谘',
        '貲',
        '資',
        '赀',
        '资',
        '赼',
        '趑',
        '趦',
        '輜',
        '輺',
        '辎',
        '鄑',
        '鈭',
        '錙',
        '鍿',
        '鎡',
        '锱',
        '镃',
        '頾',
        '頿',
        '髭',
        '鯔',
        '鰦',
        '鲻',
        '鶅',
        '鼒',
        '齍',
        '齜',
        '龇',
    ],
    mī: ['咪'],
    'jī xī qià': ['咭'],
    'gē luò kǎ lo': ['咯'],
    'shù xún': ['咰'],
    'zán zá zǎ zan': ['咱'],
    'hāi ké': ['咳'],
    huī: [
        '咴',
        '噅',
        '噕',
        '婎',
        '媈',
        '幑',
        '徽',
        '恢',
        '拻',
        '挥',
        '揮',
        '晖',
        '暉',
        '楎',
        '洃',
        '瀈',
        '灰',
        '灳',
        '烣',
        '睳',
        '禈',
        '翚',
        '翬',
        '蘳',
        '袆',
        '褘',
        '詼',
        '诙',
        '豗',
        '輝',
        '辉',
        '鰴',
        '麾',
        '㧑',
    ],
    'huài shì': ['咶'],
    táo: [
        '咷',
        '啕',
        '桃',
        '檮',
        '洮',
        '淘',
        '祹',
        '綯',
        '绹',
        '萄',
        '蜪',
        '裪',
        '迯',
        '逃',
        '醄',
        '鋾',
        '鞀',
        '鞉',
        '饀',
        '駣',
        '騊',
        '鼗',
        '𫘦',
    ],
    xián: [
        '咸',
        '啣',
        '娴',
        '娹',
        '婱',
        '嫌',
        '嫺',
        '嫻',
        '弦',
        '挦',
        '撏',
        '涎',
        '湺',
        '澖',
        '甉',
        '痫',
        '癇',
        '癎',
        '絃',
        '胘',
        '舷',
        '藖',
        '蚿',
        '蛝',
        '衔',
        '衘',
        '誸',
        '諴',
        '賢',
        '贒',
        '贤',
        '輱',
        '醎',
        '銜',
        '鑦',
        '閑',
        '闲',
        '鷳',
        '鷴',
        '鷼',
        '鹇',
        '鹹',
        '麙',
        '𫍯',
    ],
    'è àn': ['咹'],
    'xuān xuǎn': ['咺', '烜'],
    'wāi hé wǒ guǎ guō': ['咼'],
    'yàn yè yān': ['咽'],
    āi: ['哀', '哎', '埃', '溾', '銰', '鎄', '锿'],
    pǐn: ['品', '榀'],
    shěn: [
        '哂',
        '婶',
        '嬸',
        '审',
        '宷',
        '審',
        '弞',
        '曋',
        '渖',
        '瀋',
        '瞫',
        '矤',
        '矧',
        '覾',
        '訠',
        '諗',
        '讅',
        '谂',
        '谉',
        '邥',
        '頣',
        '魫',
    ],
    'hǒng hōng hòng': ['哄'],
    'wā wa': ['哇'],
    'hā hǎ hà': ['哈'],
    zāi: ['哉', '栽', '渽', '溨', '災', '灾', '烖', '睵', '賳'],
    'dì diè': ['哋'],
    pài: ['哌', '沠', '派', '渒', '湃', '蒎', '鎃'],
    'gén hěn': ['哏'],
    'yǎ yā': ['哑', '雅'],
    'yuě huì': ['哕', '噦'],
    nián: ['哖', '年', '秊', '秥', '鮎', '鯰', '鲇', '鲶', '鵇', '黏'],
    'huá huā': ['哗', '嘩'],
    'jì jiē zhāi': ['哜', '嚌'],
    mōu: ['哞'],
    'yō yo': ['哟', '喲'],
    lòng: ['哢', '梇', '贚'],
    'ò ó é': ['哦'],
    'lī lǐ li': ['哩'],
    'nǎ na nǎi né něi': ['哪'],
    hè: [
        '哬',
        '垎',
        '壑',
        '寉',
        '惒',
        '焃',
        '煂',
        '燺',
        '爀',
        '癋',
        '碋',
        '翯',
        '褐',
        '謞',
        '賀',
        '贺',
        '赫',
        '靍',
        '靎',
        '靏',
        '鶴',
        '鸖',
        '鹤',
    ],
    'bō pò bā': ['哱'],
    zhé: [
        '哲',
        '啠',
        '喆',
        '嚞',
        '埑',
        '悊',
        '摺',
        '晢',
        '晣',
        '歽',
        '矺',
        '砓',
        '磔',
        '籷',
        '粍',
        '虴',
        '蛰',
        '蟄',
        '袩',
        '詟',
        '謫',
        '謺',
        '讁',
        '讋',
        '谪',
        '輒',
        '輙',
        '轍',
        '辄',
        '辙',
        '鮿',
    ],
    'liàng láng': ['哴'],
    'liè lǜ': ['哷'],
    hān: ['哻', '憨', '蚶', '谽', '酣', '頇', '顸', '馠', '魽', '鼾'],
    'hēng hng': ['哼'],
    gěng: [
        '哽',
        '埂',
        '峺',
        '挭',
        '梗',
        '綆',
        '绠',
        '耿',
        '莄',
        '郠',
        '骾',
        '鯁',
        '鲠',
        '𬒔',
    ],
    'chuò yuè': ['哾'],
    'gě jiā': ['哿'],
    'bei bài': ['唄'],
    'hán hàn': ['唅'],
    chún: [
        '唇',
        '浱',
        '湻',
        '滣',
        '漘',
        '犉',
        '純',
        '纯',
        '脣',
        '莼',
        '蒓',
        '蓴',
        '醇',
        '醕',
        '錞',
        '陙',
        '鯙',
        '鶉',
        '鹑',
        '𬭚',
    ],
    'ài āi': ['唉'],
    'jiá qiǎn': ['唊'],
    'yán dàn xián': ['唌'],
    chē: ['唓', '砗', '硨', '莗', '蛼'],
    'wú ńg ń': ['唔'],
    zào: [
        '唕',
        '唣',
        '噪',
        '慥',
        '梍',
        '灶',
        '煰',
        '燥',
        '皁',
        '皂',
        '竃',
        '竈',
        '簉',
        '艁',
        '譟',
        '趮',
        '躁',
        '造',
        '𥖨',
    ],
    dí: [
        '唙',
        '啇',
        '嘀',
        '嚁',
        '嫡',
        '廸',
        '敌',
        '敵',
        '梑',
        '涤',
        '滌',
        '狄',
        '笛',
        '籴',
        '糴',
        '苖',
        '荻',
        '蔋',
        '蔐',
        '藡',
        '覿',
        '觌',
        '豴',
        '迪',
        '靮',
        '頔',
        '馰',
        '髢',
        '鸐',
        '𬱖',
    ],
    'gòng hǒng gǒng': ['唝', '嗊'],
    dóu: ['唞'],
    'lào láo': ['唠', '嘮', '憦'],
    huàn: [
        '唤',
        '喚',
        '奂',
        '奐',
        '宦',
        '嵈',
        '幻',
        '患',
        '愌',
        '换',
        '換',
        '擐',
        '攌',
        '梙',
        '槵',
        '浣',
        '涣',
        '渙',
        '漶',
        '澣',
        '烉',
        '焕',
        '煥',
        '瑍',
        '痪',
        '瘓',
        '睆',
        '肒',
        '藧',
        '豢',
        '轘',
        '逭',
        '鯇',
        '鯶',
        '鰀',
        '鲩',
    ],
    léng: ['唥', '塄', '楞', '碐', '薐'],
    'wō wěi': ['唩'],
    fěng: ['唪', '覂', '諷', '讽'],
    'yín jìn': ['唫'],
    'hǔ xià': ['唬'],
    wéi: [
        '唯',
        '围',
        '圍',
        '壝',
        '峗',
        '峞',
        '嵬',
        '帏',
        '帷',
        '幃',
        '惟',
        '桅',
        '沩',
        '洈',
        '涠',
        '湋',
        '溈',
        '潍',
        '潙',
        '潿',
        '濰',
        '犩',
        '矀',
        '維',
        '维',
        '蓶',
        '覹',
        '违',
        '違',
        '鄬',
        '醀',
        '鍏',
        '闈',
        '闱',
        '韋',
        '韦',
        '鮠',
        '𣲗',
        '𬶏',
    ],
    shuā: ['唰'],
    chàng: ['唱', '怅', '悵', '暢', '焻', '畅', '畼', '誯', '韔', '鬯'],
    'ér wā': ['唲'],
    qiàng: ['唴', '炝', '熗', '羻'],
    yō: ['唷'],
    yū: ['唹', '淤', '瘀', '盓', '箊', '紆', '纡', '込', '迂', '迃', '陓'],
    lài: [
        '唻',
        '濑',
        '瀨',
        '瀬',
        '癞',
        '癩',
        '睐',
        '睞',
        '籁',
        '籟',
        '藾',
        '賚',
        '賴',
        '赉',
        '赖',
        '頼',
        '顂',
        '鵣',
    ],
    tuò: ['唾', '嶞', '柝', '毤', '毻', '箨', '籜', '萚', '蘀', '跅'],
    'zhōu zhāo tiào': ['啁'],
    kěn: ['啃', '垦', '墾', '恳', '懇', '肎', '肯', '肻', '豤', '錹'],
    'zhuó zhào': ['啅', '濯'],
    'hēng hèng': ['啈', '悙'],
    'lín lán': ['啉'],
    'a ā á ǎ à': ['啊'],
    qiāng: [
        '啌',
        '嗴',
        '嶈',
        '戕',
        '摤',
        '斨',
        '枪',
        '槍',
        '溬',
        '牄',
        '猐',
        '獇',
        '羌',
        '羗',
        '腔',
        '蜣',
        '謒',
        '鏘',
        '锖',
        '锵',
    ],
    'tūn zhūn xiāng duǐ': ['啍'],
    wèn: ['問', '妏', '揾', '搵', '璺', '问', '顐'],
    'cuì qi': ['啐'],
    'dié shà jié tì': ['啑'],
    'yuē wā': ['啘'],
    'zǐ cǐ': ['啙'],
    'bǐ tú': ['啚'],
    'chuò chuài': ['啜'],
    'yǎ yā è': ['啞'],
    fēi: [
        '啡',
        '婓',
        '婔',
        '扉',
        '暃',
        '渄',
        '猆',
        '緋',
        '绯',
        '裶',
        '霏',
        '非',
        '靟',
        '飛',
        '飝',
        '飞',
        '餥',
        '馡',
        '騑',
        '騛',
        '鯡',
        '鲱',
        '𬴂',
    ],
    pí: [
        '啤',
        '壀',
        '枇',
        '毗',
        '毘',
        '焷',
        '琵',
        '疲',
        '皮',
        '篺',
        '罴',
        '羆',
        '脾',
        '腗',
        '膍',
        '蚍',
        '蚽',
        '蜱',
        '螷',
        '蠯',
        '豼',
        '貔',
        '郫',
        '鈹',
        '阰',
        '陴',
        '隦',
        '魮',
        '鮍',
        '鲏',
        '鵧',
        '鼙',
    ],
    shá: ['啥'],
    'lā la': ['啦'],
    'yīng qíng': ['啨'],
    pā: ['啪', '妑', '舥', '葩', '趴'],
    'zhě shì': ['啫'],
    sè: [
        '啬',
        '嗇',
        '懎',
        '擌',
        '栜',
        '歮',
        '涩',
        '渋',
        '澀',
        '澁',
        '濇',
        '濏',
        '瀒',
        '瑟',
        '璱',
        '瘷',
        '穑',
        '穡',
        '穯',
        '繬',
        '譅',
        '轖',
        '銫',
        '鏼',
        '铯',
        '飋',
    ],
    niè: [
        '啮',
        '嗫',
        '噛',
        '嚙',
        '囁',
        '囓',
        '圼',
        '孼',
        '孽',
        '嵲',
        '嶭',
        '巕',
        '帇',
        '敜',
        '枿',
        '槷',
        '櫱',
        '涅',
        '湼',
        '痆',
        '篞',
        '籋',
        '糱',
        '糵',
        '聂',
        '聶',
        '臬',
        '臲',
        '蘖',
        '蠥',
        '讘',
        '踂',
        '踗',
        '踙',
        '蹑',
        '躡',
        '錜',
        '鎳',
        '鑈',
        '鑷',
        '钀',
        '镊',
        '镍',
        '闑',
        '陧',
        '隉',
        '顳',
        '颞',
        '齧',
        '𫔶',
    ],
    'luō luó luo': ['啰', '囉'],
    'tān chǎn tuō': ['啴'],
    bo: ['啵', '蔔'],
    dìng: [
        '啶',
        '定',
        '椗',
        '矴',
        '碇',
        '碠',
        '磸',
        '聢',
        '腚',
        '萣',
        '蝊',
        '訂',
        '订',
        '錠',
        '锭',
        '顁',
        '飣',
        '饤',
    ],
    lāng: ['啷'],
    'án ān': ['啽'],
    kā: ['喀', '擖'],
    'yóng yú': ['喁'],
    'lā lá lǎ': ['喇'],
    jiē: [
        '喈',
        '喼',
        '嗟',
        '堦',
        '媘',
        '接',
        '掲',
        '擑',
        '湝',
        '煯',
        '疖',
        '痎',
        '癤',
        '皆',
        '秸',
        '稭',
        '脻',
        '蝔',
        '街',
        '謯',
        '阶',
        '階',
        '鞂',
        '鶛',
    ],
    hóu: [
        '喉',
        '帿',
        '猴',
        '瘊',
        '睺',
        '篌',
        '糇',
        '翭',
        '葔',
        '鄇',
        '鍭',
        '餱',
        '骺',
        '鯸',
        '𬭤',
    ],
    'dié zhá': ['喋'],
    wāi: ['喎', '歪', '竵'],
    'nuò rě': ['喏'],
    'xù huò guó': ['喐'],
    zán: ['喒'],
    'wō ō': ['喔'],
    hú: [
        '喖',
        '嘝',
        '囫',
        '壶',
        '壷',
        '壺',
        '媩',
        '弧',
        '搰',
        '斛',
        '楜',
        '槲',
        '湖',
        '瀫',
        '焀',
        '煳',
        '狐',
        '猢',
        '瑚',
        '瓳',
        '箶',
        '絗',
        '縠',
        '胡',
        '葫',
        '蔛',
        '蝴',
        '螜',
        '衚',
        '觳',
        '醐',
        '鍸',
        '頶',
        '餬',
        '鬍',
        '魱',
        '鰗',
        '鵠',
        '鶘',
        '鶦',
        '鹕',
    ],
    'huàn yuán xuǎn hé': ['喛'],
    xǐ: [
        '喜',
        '囍',
        '壐',
        '屣',
        '徙',
        '憙',
        '枲',
        '橲',
        '歖',
        '漇',
        '玺',
        '璽',
        '矖',
        '禧',
        '縰',
        '葈',
        '葸',
        '蓰',
        '蟢',
        '謑',
        '蹝',
        '躧',
        '鈢',
        '鉨',
        '鉩',
        '鱚',
        '𬭳',
        '𬶮',
    ],
    'hē hè yè': ['喝'],
    kuì: [
        '喟',
        '嘳',
        '媿',
        '嬇',
        '愦',
        '愧',
        '憒',
        '篑',
        '簣',
        '籄',
        '聩',
        '聭',
        '聵',
        '膭',
        '蕢',
        '謉',
        '餽',
        '饋',
        '馈',
    ],
    'zhǒng chuáng': ['喠'],
    'wéi wèi': ['喡', '為', '爲'],
    'duó zhà': ['喥'],
    'sāng sàng': ['喪'],
    'qiáo jiāo': ['喬'],
    'pèn bēn': ['喯'],
    'cān sūn qī': ['喰'],
    'zhā chā': ['喳'],
    miāo: ['喵'],
    'pēn pèn': ['喷'],
    kuí: [
        '喹',
        '夔',
        '奎',
        '巙',
        '戣',
        '揆',
        '晆',
        '暌',
        '楏',
        '楑',
        '櫆',
        '犪',
        '睽',
        '葵',
        '藈',
        '蘷',
        '虁',
        '蝰',
        '躨',
        '逵',
        '鄈',
        '鍨',
        '鍷',
        '頯',
        '馗',
        '騤',
        '骙',
        '魁',
    ],
    'lou lóu': ['喽'],
    'zào qiāo': ['喿'],
    'hè xiāo xiào hù': ['嗃'],
    'á shà': ['嗄'],
    xiù: [
        '嗅',
        '岫',
        '峀',
        '溴',
        '珛',
        '琇',
        '璓',
        '秀',
        '綉',
        '繍',
        '繡',
        '绣',
        '螑',
        '袖',
        '褎',
        '褏',
        '銹',
        '鏥',
        '鏽',
        '锈',
        '齅',
    ],
    'qiāng qiàng': ['嗆', '戗', '戧', '蹌', '蹡'],
    'ài yì': ['嗌', '艾'],
    'má mǎ ma': ['嗎'],
    'kè kē': ['嗑'],
    'dā tà': ['嗒', '鎉'],
    sǎng: ['嗓', '搡', '磉', '褬', '鎟', '顙', '颡'],
    chēn: ['嗔', '抻', '琛', '瞋', '諃', '謓', '賝', '郴', '𬘭'],
    'wā gǔ': ['嗗'],
    'pǎng bēng': ['嗙'],
    'xián qiǎn qiān': ['嗛'],
    lào: ['嗠', '嫪', '橯', '涝', '澇', '耢', '耮', '躼', '軂', '酪'],
    wēng: ['嗡', '翁', '聬', '螉', '鎓', '鶲', '鹟', '𬭩'],
    wà: ['嗢', '腽', '膃', '袜', '襪', '韤'],
    'hēi hāi': ['嗨'],
    hē: ['嗬', '欱', '蠚', '訶', '诃'],
    zi: ['嗭'],
    sǎi: ['嗮'],
    'ǹg ńg ňg': ['嗯'],
    gě: ['嗰', '舸'],
    ná: ['嗱', '拏', '拿', '鎿', '镎'],
    diǎ: ['嗲'],
    'ài ǎi āi': ['嗳'],
    tōng: ['嗵', '樋', '炵', '蓪'],
    'zuī suī': ['嗺'],
    'zhē zhè zhù zhe': ['嗻'],
    mò: [
        '嗼',
        '圽',
        '塻',
        '墨',
        '妺',
        '嫼',
        '寞',
        '帞',
        '昩',
        '末',
        '枺',
        '歿',
        '殁',
        '沫',
        '漠',
        '爅',
        '獏',
        '瘼',
        '皌',
        '眽',
        '眿',
        '瞐',
        '瞙',
        '砞',
        '礳',
        '秣',
        '絈',
        '纆',
        '耱',
        '茉',
        '莈',
        '蓦',
        '蛨',
        '蟔',
        '貃',
        '貊',
        '貘',
        '銆',
        '鏌',
        '镆',
        '陌',
        '靺',
        '驀',
        '魩',
        '默',
        '黙',
        '𬙊',
    ],
    sòu: ['嗽', '瘶'],
    tǎn: [
        '嗿',
        '坦',
        '忐',
        '憳',
        '憻',
        '暺',
        '毯',
        '璮',
        '菼',
        '袒',
        '襢',
        '醓',
        '鉭',
        '钽',
    ],
    'jiào dǎo': ['嘄'],
    'kǎi gě': ['嘅'],
    'shān càn': ['嘇'],
    cáo: ['嘈', '嶆', '曹', '曺', '槽', '漕', '艚', '蓸', '螬', '褿', '鏪', '𥕢'],
    piào: ['嘌', '徱', '蔈', '驃'],
    'lóu lou': ['嘍'],
    gǎ: ['尕', '玍'],
    'gǔ jiǎ': ['嘏'],
    'jiāo xiāo': ['嘐'],
    'xū shī': ['嘘', '噓'],
    pó: ['嘙', '嚩', '婆', '櫇', '皤', '鄱'],
    'dē dēi': ['嘚'],
    'ma má': ['嘛'],
    'lē lei': ['嘞'],
    'gā gá gǎ': ['嘠'],
    sāi: ['嘥', '噻', '毢', '腮', '顋', '鰓'],
    'zuō chuài': ['嘬'],
    'cháo zhāo': ['嘲', '朝', '鼂'],
    zuǐ: ['嘴', '噿', '嶊', '璻'],
    'qiáo qiào': ['嘺', '翹', '谯'],
    'chù xù shòu': ['嘼'],
    'tān chǎn': ['嘽'],
    'dàn tán': ['嘾', '弾', '彈', '惔', '澹'],
    'hēi mò': ['嘿'],
    ě: ['噁', '砨', '頋', '騀', '鵈'],
    'fān bo': ['噃'],
    chuáng: ['噇', '床', '牀'],
    'cù zā hé': ['噈'],
    'tūn kuò': ['噋'],
    'cēng chēng': ['噌'],
    dēng: ['噔', '嬁', '灯', '燈', '璒', '登', '竳', '簦', '艠', '豋'],
    pū: ['噗', '扑', '撲', '攴', '攵', '潽', '炇', '陠'],
    juē: ['噘', '屩', '屫', '撧'],
    lū: ['噜', '嚕', '撸', '擼', '謢'],
    zhān: [
        '噡',
        '岾',
        '惉',
        '旃',
        '旜',
        '枬',
        '栴',
        '毡',
        '氈',
        '氊',
        '沾',
        '瞻',
        '薝',
        '蛅',
        '詀',
        '詹',
        '譫',
        '谵',
        '趈',
        '邅',
        '閚',
        '霑',
        '飦',
        '饘',
        '驙',
        '魙',
        '鱣',
        '鸇',
        '鹯',
        '𫗴',
    ],
    ō: ['噢'],
    'zhòu zhuó': ['噣'],
    'jiào qiào chī': ['噭'],
    yuàn: [
        '噮',
        '妴',
        '怨',
        '愿',
        '掾',
        '瑗',
        '禐',
        '苑',
        '衏',
        '裫',
        '褑',
        '院',
        '願',
    ],
    'ǎi ài āi': ['噯'],
    'yōng yǒng': ['噰', '澭'],
    'jué xué': ['噱'],
    'pēn pèn fèn': ['噴'],
    gá: ['噶', '尜', '釓', '錷', '钆'],
    'xīn hěn hèn': ['噷'],
    dāng: ['噹', '澢', '珰', '璫', '筜', '簹', '艡', '蟷', '裆', '襠'],
    làn: ['嚂', '滥', '濫', '烂', '燗', '爁', '爛', '爤', '瓓', '糷', '钄'],
    tà: [
        '嚃',
        '嚺',
        '崉',
        '挞',
        '搨',
        '撻',
        '榻',
        '橽',
        '毾',
        '涾',
        '澾',
        '濌',
        '禢',
        '粏',
        '誻',
        '譶',
        '蹋',
        '蹹',
        '躂',
        '躢',
        '遝',
        '錔',
        '闒',
        '闥',
        '闼',
        '阘',
        '鞜',
        '鞳',
    ],
    'huō huò ǒ': ['嚄'],
    hāo: ['嚆', '茠', '蒿', '薅'],
    'hè xià': ['嚇'],
    'xiù pì': ['嚊'],
    'zhōu chóu': ['嚋', '盩', '诪'],
    mē: ['嚒'],
    'chā cā': ['嚓'],
    'bó pào bào': ['嚗'],
    'me mèi mò': ['嚜'],
    'xié hái': ['嚡'],
    'áo xiāo': ['嚣'],
    mō: ['嚤', '摸'],
    pín: [
        '嚬',
        '娦',
        '嫔',
        '嬪',
        '玭',
        '矉',
        '薲',
        '蠙',
        '貧',
        '贫',
        '顰',
        '颦',
        '𬞟',
    ],
    mè: ['嚰', '濹'],
    'rǎng rāng': ['嚷'],
    lá: ['嚹', '旯'],
    'jiáo jué jiào': ['嚼'],
    chuò: [
        '嚽',
        '娖',
        '擉',
        '歠',
        '涰',
        '磭',
        '踀',
        '輟',
        '辍',
        '辵',
        '辶',
        '酫',
        '鑡',
        '餟',
        '齪',
        '龊',
    ],
    'huān huàn': ['嚾'],
    'zá cà': ['囃'],
    chài: ['囆', '虿', '蠆', '袃', '訍'],
    'náng nāng': ['囊'],
    'zá zàn cān': ['囋'],
    sū: ['囌', '櫯', '甦', '稣', '穌', '窣', '蘇', '蘓', '酥', '鯂'],
    zèng: ['囎', '熷', '甑', '贈', '赠', '鋥', '锃'],
    'zá niè yàn': ['囐'],
    nāng: ['囔'],
    'luó luō luo': ['囖'],
    'wéi guó': ['囗'],
    huí: [
        '囘',
        '回',
        '囬',
        '廻',
        '廽',
        '恛',
        '洄',
        '痐',
        '茴',
        '蚘',
        '蛔',
        '蛕',
        '蜖',
        '迴',
        '逥',
        '鮰',
    ],
    nín: ['囜', '您', '脌'],
    'jiǎn nān': ['囝'],
    nān: ['囡'],
    tuán: ['团', '団', '團', '慱', '抟', '摶', '檲', '糰', '鏄', '鷒', '鷻'],
    'tún dùn': ['囤', '坉'],
    guó: [
        '囯',
        '囶',
        '囻',
        '国',
        '圀',
        '國',
        '帼',
        '幗',
        '慖',
        '摑',
        '漍',
        '聝',
        '腘',
        '膕',
        '蔮',
        '虢',
        '馘',
        '𬇹',
    ],
    kùn: ['困', '涃', '睏'],
    'wéi tōng': ['囲'],
    qūn: ['囷', '夋', '逡'],
    rì: ['囸', '日', '衵', '鈤', '馹', '驲'],
    tāi: ['囼', '孡', '胎'],
    pǔ: [
        '圃',
        '圑',
        '擈',
        '普',
        '暜',
        '樸',
        '檏',
        '氆',
        '浦',
        '溥',
        '烳',
        '諩',
        '譜',
        '谱',
        '蹼',
        '鐠',
        '镨',
    ],
    'quān juàn juān': ['圈', '圏'],
    'chuí chuán': ['圌'],
    tuǎn: ['圕', '畽', '疃'],
    lüè: ['圙', '掠', '略', '畧', '稤', '鋝', '鋢', '锊', '䂮'],
    'huán yuán': ['圜'],
    luán: [
        '圝',
        '圞',
        '奱',
        '娈',
        '孌',
        '孪',
        '孿',
        '峦',
        '巒',
        '挛',
        '攣',
        '曫',
        '栾',
        '欒',
        '滦',
        '灤',
        '癴',
        '癵',
        '羉',
        '脔',
        '臠',
        '虊',
        '銮',
        '鑾',
        '鵉',
        '鸞',
        '鸾',
    ],
    tǔ: ['土', '圡', '釷', '钍'],
    'xū wéi': ['圩'],
    'dì de': ['地', '嶳'],
    'qiān sú': ['圱'],
    zhèn: [
        '圳',
        '塦',
        '挋',
        '振',
        '朕',
        '栚',
        '甽',
        '眹',
        '紖',
        '絼',
        '纼',
        '誫',
        '賑',
        '赈',
        '鋴',
        '鎭',
        '鎮',
        '镇',
        '阵',
        '陣',
        '震',
        '鴆',
        '鸩',
    ],
    'chǎng cháng': ['场', '場', '塲'],
    'qí yín': ['圻'],
    jiá: [
        '圿',
        '忦',
        '恝',
        '戞',
        '扴',
        '脥',
        '荚',
        '莢',
        '蛱',
        '蛺',
        '裌',
        '跲',
        '郏',
        '郟',
        '鋏',
        '铗',
        '頬',
        '頰',
        '颊',
        '鴶',
        '鵊',
    ],
    'zhǐ zhì': ['坁'],
    bǎn: [
        '坂',
        '岅',
        '昄',
        '板',
        '版',
        '瓪',
        '粄',
        '舨',
        '蝂',
        '鈑',
        '钣',
        '阪',
        '魬',
    ],
    qǐn: ['坅', '寑', '寝', '寢', '昑', '梫', '笉', '螼', '赾', '鋟', '锓'],
    'méi fén': ['坆'],
    'rǒng kēng': ['坈'],
    'fāng fáng': ['坊'],
    'fèn bèn': ['坋'],
    tān: ['坍', '怹', '摊', '擹', '攤', '滩', '灘', '瘫', '癱', '舑', '貪', '贪'],
    'huài pēi pī péi': ['坏'],
    'dì làn': ['坔'],
    tán: [
        '坛',
        '墰',
        '墵',
        '壇',
        '壜',
        '婒',
        '憛',
        '昙',
        '曇',
        '榃',
        '檀',
        '潭',
        '燂',
        '痰',
        '磹',
        '罈',
        '罎',
        '藫',
        '談',
        '譚',
        '譠',
        '谈',
        '谭',
        '貚',
        '郯',
        '醰',
        '錟',
        '顃',
    ],
    bà: ['坝', '垻', '壩', '弝', '欛', '灞', '爸', '矲', '覇', '霸', '鮁', '鲅'],
    fén: [
        '坟',
        '墳',
        '妢',
        '岎',
        '幩',
        '枌',
        '棼',
        '汾',
        '焚',
        '燌',
        '燓',
        '羒',
        '羵',
        '蒶',
        '蕡',
        '蚠',
        '蚡',
        '豮',
        '豶',
        '轒',
        '鐼',
        '隫',
        '馩',
        '魵',
        '黂',
        '鼖',
        '鼢',
        '𣸣',
    ],
    zhuì: [
        '坠',
        '墜',
        '惴',
        '甀',
        '畷',
        '礈',
        '綴',
        '縋',
        '缀',
        '缒',
        '腏',
        '膇',
        '諈',
        '贅',
        '赘',
        '醊',
        '錣',
        '鑆',
    ],
    pō: ['坡', '岥', '泼', '溌', '潑', '釙', '鏺', '钋', '頗', '颇', '䥽'],
    'pǎn bàn': ['坢'],
    kūn: [
        '坤',
        '堃',
        '堒',
        '崐',
        '崑',
        '昆',
        '晜',
        '潉',
        '焜',
        '熴',
        '猑',
        '琨',
        '瑻',
        '菎',
        '蜫',
        '裈',
        '裩',
        '褌',
        '醌',
        '錕',
        '锟',
        '騉',
        '髠',
        '髡',
        '髨',
        '鯤',
        '鲲',
        '鵾',
        '鶤',
        '鹍',
    ],
    diàn: [
        '坫',
        '垫',
        '墊',
        '壂',
        '奠',
        '婝',
        '店',
        '惦',
        '扂',
        '橂',
        '殿',
        '淀',
        '澱',
        '玷',
        '琔',
        '电',
        '癜',
        '簟',
        '蜔',
        '鈿',
        '電',
        '靛',
        '驔',
    ],
    'mù mǔ': ['坶'],
    'kē kě': ['坷', '軻'],
    xuè: ['坹', '岤', '桖', '瀥', '狘', '瞲', '謔', '谑', '趐'],
    'dǐ chí': ['坻', '柢'],
    lā: ['垃', '柆', '菈', '邋'],
    lǒng: ['垄', '垅', '壟', '壠', '拢', '攏', '竉', '陇', '隴', '𬕂'],
    mín: [
        '垊',
        '姄',
        '岷',
        '崏',
        '捪',
        '旻',
        '旼',
        '民',
        '珉',
        '琘',
        '琝',
        '瑉',
        '痻',
        '盿',
        '砇',
        '緍',
        '緡',
        '缗',
        '罠',
        '苠',
        '鈱',
        '錉',
        '鍲',
        '鴖',
    ],
    'dòng tóng': ['垌', '峒', '洞'],
    cí: [
        '垐',
        '嬨',
        '慈',
        '柌',
        '濨',
        '珁',
        '瓷',
        '甆',
        '磁',
        '礠',
        '祠',
        '糍',
        '茨',
        '詞',
        '词',
        '辝',
        '辞',
        '辤',
        '辭',
        '雌',
        '飺',
        '餈',
        '鴜',
        '鶿',
        '鷀',
        '鹚',
    ],
    duī: ['垖', '堆', '塠', '痽', '磓', '鐓', '鐜', '鴭'],
    'duò duǒ': ['垛'],
    'duǒ duò': ['垜', '挆'],
    chá: ['垞', '察', '嵖', '搽', '槎', '檫', '猹', '茬', '茶', '詧', '靫', '𥻗'],
    shǎng: ['垧', '晌', '樉', '賞', '贘', '赏', '鋿', '鏛', '鑜'],
    shǒu: ['垨', '守', '手', '扌', '艏', '首'],
    da: ['垯', '繨', '跶'],
    háng: [
        '垳',
        '斻',
        '杭',
        '筕',
        '絎',
        '绗',
        '航',
        '苀',
        '蚢',
        '裄',
        '貥',
        '迒',
        '頏',
        '颃',
        '魧',
    ],
    'ān ǎn': ['垵'],
    xīng: [
        '垶',
        '惺',
        '星',
        '曐',
        '煋',
        '猩',
        '瑆',
        '皨',
        '篂',
        '腥',
        '興',
        '觪',
        '觲',
        '謃',
        '騂',
        '骍',
        '鮏',
        '鯹',
    ],
    'yuàn huán': ['垸'],
    bāng: [
        '垹',
        '帮',
        '幇',
        '幚',
        '幫',
        '捠',
        '梆',
        '浜',
        '邦',
        '邫',
        '鞤',
        '𠳐',
    ],
    'póu fú': ['垺'],
    cén: ['埁', '岑', '涔'],
    'běng fēng': ['埄'],
    'dì fáng': ['埅'],
    'xiá jiā': ['埉'],
    'mái mán': ['埋'],
    làng: ['埌', '崀', '浪', '蒗', '閬', '㫰'],
    'shān yán': ['埏'],
    'qín jīn': ['埐'],
    'pǔ bù': ['埔'],
    huā: ['埖', '婲', '椛', '硴', '糀', '花', '蒊', '蘤', '誮', '錵'],
    'suì sù': ['埣'],
    'pí pì': ['埤'],
    'qīng zhēng': ['埥', '鲭'],
    'wǎn wān': ['埦'],
    lǔn: ['埨', '稐', '𫭢'],
    'zhēng chéng': ['埩'],
    kōng: ['埪', '崆', '箜', '躻', '錓', '鵼'],
    'cǎi cài': ['埰', '寀', '采'],
    'chù tòu': ['埱'],
    běng: ['埲', '琫', '菶', '鞛'],
    'kǎn xiàn': ['埳'],
    'yì shì': ['埶', '醳'],
    péi: ['培', '毰', '裴', '裵', '賠', '赔', '錇', '锫', '阫', '陪'],
    'sào sǎo': ['埽'],
    'jǐn qīn jìn': ['堇'],
    'péng bèng': ['堋'],
    'qiàn zàn jiàn': ['堑'],
    àn: [
        '堓',
        '屵',
        '岸',
        '按',
        '暗',
        '案',
        '胺',
        '荌',
        '豻',
        '貋',
        '錌',
        '闇',
        '隌',
        '黯',
    ],
    'duò huī': ['堕', '墮'],
    huán: [
        '堚',
        '寏',
        '寰',
        '峘',
        '桓',
        '洹',
        '澴',
        '獂',
        '环',
        '環',
        '糫',
        '繯',
        '缳',
        '羦',
        '荁',
        '萈',
        '萑',
        '豲',
        '鍰',
        '鐶',
        '锾',
        '镮',
        '闤',
        '阛',
        '雈',
        '鬟',
        '鹮',
        '𬘫',
        '𤩽',
    ],
    'bǎo bǔ pù': ['堡'],
    'máo móu wǔ': ['堥'],
    ruán: ['堧', '壖', '撋'],
    'ài è yè': ['堨'],
    gèng: ['堩', '暅'],
    méi: [
        '堳',
        '塺',
        '媒',
        '嵋',
        '徾',
        '攗',
        '枚',
        '栂',
        '梅',
        '楣',
        '楳',
        '槑',
        '湄',
        '湈',
        '煤',
        '猸',
        '玫',
        '珻',
        '瑂',
        '眉',
        '睂',
        '禖',
        '脄',
        '脢',
        '腜',
        '苺',
        '莓',
        '葿',
        '郿',
        '酶',
        '鎇',
        '镅',
        '霉',
        '鶥',
        '鹛',
        '黴',
    ],
    dǔ: ['堵', '琽', '睹', '笃', '篤', '覩', '賭', '赌'],
    féng: ['堸', '綘', '艂', '逢'],
    hèng: ['堼'],
    chūn: [
        '堾',
        '媋',
        '旾',
        '春',
        '暙',
        '杶',
        '椿',
        '槆',
        '橁',
        '櫄',
        '瑃',
        '箺',
        '萅',
        '蝽',
        '輴',
        '鰆',
        '鶞',
        '䲠',
    ],
    jiǎng: [
        '塂',
        '奖',
        '奨',
        '奬',
        '桨',
        '槳',
        '獎',
        '耩',
        '膙',
        '蒋',
        '蔣',
        '講',
        '讲',
        '顜',
    ],
    huāng: ['塃', '巟', '慌', '肓', '荒', '衁'],
    duàn: [
        '塅',
        '断',
        '斷',
        '椴',
        '段',
        '毈',
        '煅',
        '瑖',
        '碫',
        '簖',
        '籪',
        '緞',
        '缎',
        '腶',
        '葮',
        '躖',
        '鍛',
        '锻',
    ],
    tǎ: ['塔', '墖', '獭', '獺', '鮙', '鰨', '鳎'],
    wěng: ['塕', '奣', '嵡', '攚', '暡', '瞈', '蓊'],
    'sāi sài sè': ['塞'],
    zàng: ['塟', '弉', '臓', '臟', '葬', '蔵', '銺'],
    tián: [
        '塡',
        '屇',
        '恬',
        '沺',
        '湉',
        '璳',
        '甛',
        '甜',
        '田',
        '畋',
        '畑',
        '碵',
        '磌',
        '胋',
        '闐',
        '阗',
        '鴫',
        '鷆',
        '鷏',
    ],
    zhèng: [
        '塣',
        '幁',
        '政',
        '証',
        '諍',
        '證',
        '证',
        '诤',
        '郑',
        '鄭',
        '靕',
        '鴊',
    ],
    'tián zhèn': ['填'],
    wēn: [
        '塭',
        '昷',
        '榲',
        '殟',
        '温',
        '溫',
        '瑥',
        '瘟',
        '蕰',
        '豱',
        '輼',
        '轀',
        '辒',
        '鎾',
        '饂',
        '鰛',
        '鰮',
        '鳁',
    ],
    liù: ['塯', '廇', '磟', '翏', '雡', '霤', '餾', '鬸', '鷚', '鹨'],
    hǎi: ['塰', '海', '烸', '酼', '醢'],
    lǎng: ['塱', '朖', '朗', '朤', '烺', '蓢', '㮾'],
    bèng: ['塴', '揼', '泵', '甏', '綳', '蹦', '迸', '逬', '鏰', '镚'],
    chén: [
        '塵',
        '宸',
        '尘',
        '忱',
        '敐',
        '敶',
        '晨',
        '曟',
        '栕',
        '樄',
        '沉',
        '煁',
        '瘎',
        '臣',
        '茞',
        '莀',
        '莐',
        '蔯',
        '薼',
        '螴',
        '訦',
        '諶',
        '軙',
        '辰',
        '迧',
        '鈂',
        '陈',
        '陳',
        '霃',
        '鷐',
        '麎',
    ],
    'ōu qiū': ['塸'],
    'qiàn jiàn': ['塹'],
    'zhuān tuán': ['塼'],
    shuǎng: ['塽', '慡', '漺', '爽', '縔', '鏯'],
    shú: ['塾', '婌', '孰', '璹', '秫', '贖', '赎'],
    lǒu: ['塿', '嵝', '嶁', '甊', '篓', '簍'],
    chí: [
        '墀',
        '弛',
        '持',
        '池',
        '漦',
        '竾',
        '筂',
        '箎',
        '篪',
        '茌',
        '荎',
        '蚳',
        '謘',
        '貾',
        '赿',
        '踟',
        '迟',
        '迡',
        '遅',
        '遟',
        '遲',
        '鍉',
        '馳',
        '驰',
    ],
    shù: [
        '墅',
        '庶',
        '庻',
        '怷',
        '恕',
        '戍',
        '束',
        '树',
        '樹',
        '沭',
        '漱',
        '潄',
        '濖',
        '竖',
        '竪',
        '絉',
        '腧',
        '荗',
        '蒁',
        '虪',
        '術',
        '裋',
        '豎',
        '述',
        '鉥',
        '錰',
        '鏣',
        '霔',
        '鶐',
        '𬬸',
    ],
    'dì zhì': ['墆', '疐'],
    kàn: ['墈', '崁', '瞰', '矙', '磡', '衎', '鬫'],
    chěn: ['墋', '夦', '硶', '碜', '磣', '贂', '趻', '踸', '鍖'],
    'zhǐ zhuó': ['墌'],
    qiǎng: ['墏', '繈', '繦', '羥', '襁'],
    zēng: ['増', '增', '憎', '璔', '矰', '磳', '罾', '譄', '鄫', '鱛', '䎖'],
    qiáng: [
        '墙',
        '墻',
        '嫱',
        '嬙',
        '樯',
        '檣',
        '漒',
        '牆',
        '艢',
        '蔃',
        '蔷',
        '蘠',
    ],
    'kuài tuí': ['墤'],
    'tuǎn dǒng': ['墥'],
    'qiáo què': ['墧'],
    'zūn dūn': ['墫'],
    'qiāo áo': ['墽'],
    'yì tú': ['墿'],
    'xué bó jué': ['壆'],
    lǎn: [
        '壈',
        '嬾',
        '孄',
        '孏',
        '懒',
        '懶',
        '揽',
        '擥',
        '攬',
        '榄',
        '欖',
        '浨',
        '漤',
        '灠',
        '纜',
        '缆',
        '罱',
        '覧',
        '覽',
        '览',
        '醂',
        '顲',
    ],
    huài: ['壊', '壞', '蘾'],
    rǎng: ['壌', '壤', '攘', '爙'],
    'làn xiàn': ['壏'],
    dǎo: [
        '壔',
        '导',
        '導',
        '岛',
        '島',
        '嶋',
        '嶌',
        '嶹',
        '捣',
        '搗',
        '擣',
        '槝',
        '祷',
        '禂',
        '禱',
        '蹈',
        '陦',
        '隝',
        '隯',
    ],
    ruǐ: ['壡', '桵', '橤', '繠', '蕊', '蕋', '蘂', '蘃'],
    san: ['壭'],
    zhuàng: ['壮', '壯', '壵', '撞', '焋', '状', '狀'],
    'ké qiào': ['壳', '殼'],
    kǔn: [
        '壸',
        '壼',
        '悃',
        '捆',
        '梱',
        '硱',
        '祵',
        '稇',
        '稛',
        '綑',
        '裍',
        '閫',
        '閸',
        '阃',
    ],
    mǎng: ['壾', '漭', '茻', '莽', '莾', '蠎'],
    cún: ['壿', '存'],
    'zhǐ zhōng': ['夂'],
    'gǔ yíng': ['夃'],
    'jiàng xiáng': ['夅', '降'],
    'páng féng fēng': ['夆'],
    zhāi: ['夈', '捚', '摘', '斋', '斎', '榸', '粂', '齋'],
    'xuàn xiòng': ['夐'],
    wài: ['外', '顡'],
    'wǎn yuàn wān yuān': ['夗'],
    'mǎo wǎn': ['夘'],
    mèng: ['夢', '夣', '孟', '梦', '癦', '霥'],
    'dà dài': ['大'],
    'fū fú': ['夫', '姇', '枎', '粰'],
    guài: ['夬', '怪', '恠'],
    yāng: [
        '央',
        '姎',
        '抰',
        '殃',
        '泱',
        '秧',
        '胦',
        '鉠',
        '鍈',
        '雵',
        '鴦',
        '鸯',
    ],
    'hāng bèn': ['夯'],
    gǎo: [
        '夰',
        '搞',
        '杲',
        '槀',
        '槁',
        '檺',
        '稁',
        '稾',
        '稿',
        '縞',
        '缟',
        '菒',
        '藁',
        '藳',
    ],
    'tāo běn': ['夲'],
    'tóu tou': ['头'],
    'yǎn tāo': ['夵'],
    'kuā kuà': ['夸', '誇'],
    'jiá jiā gā xiá': ['夹'],
    huà: [
        '夻',
        '婳',
        '嫿',
        '嬅',
        '崋',
        '摦',
        '杹',
        '枠',
        '桦',
        '槬',
        '樺',
        '澅',
        '画',
        '畫',
        '畵',
        '繣',
        '舙',
        '話',
        '諙',
        '譮',
        '话',
        '黊',
    ],
    'jiā jiá gā xiá': ['夾'],
    ēn: ['奀', '恩', '蒽'],
    'dī tì': ['奃'],
    'yǎn yān': ['奄', '渰'],
    pào: ['奅', '疱', '皰', '砲', '礟', '礮', '靤', '麭'],
    nài: ['奈', '柰', '渿', '耐', '萘', '褦', '錼', '鼐'],
    'quān juàn': ['奍', '弮', '棬'],
    zòu: ['奏', '揍'],
    'qì qiè xiè': ['契'],
    kāi: ['奒', '开', '揩', '鐦', '锎', '開'],
    'bēn bèn': ['奔', '泍'],
    tào: ['套'],
    'zàng zhuǎng': ['奘'],
    běn: ['奙', '本', '楍', '畚', '翉', '苯'],
    'xùn zhuì': ['奞'],
    shē: ['奢', '檨', '猞', '畭', '畲', '賒', '賖', '赊', '輋', '𪨶'],
    'hǎ pò tǎi': ['奤'],
    'ào yù': ['奥', '奧', '澚'],
    yūn: ['奫', '氲', '氳', '蒀', '蒕', '蝹', '贇', '赟', '𫖳'],
    'duǒ chě': ['奲'],
    'nǚ rǔ': ['女'],
    nú: ['奴', '孥', '笯', '駑', '驽'],
    'dīng dǐng tiǎn': ['奵'],
    'tā jiě': ['她'],
    nuán: ['奻'],
    'hǎo hào': ['好'],
    fàn: [
        '奿',
        '嬎',
        '梵',
        '汎',
        '泛',
        '滼',
        '瀪',
        '犯',
        '畈',
        '盕',
        '笵',
        '範',
        '范',
        '訉',
        '販',
        '贩',
        '軬',
        '輽',
        '飯',
        '飰',
        '饭',
    ],
    shuò: ['妁', '搠', '朔', '槊', '烁', '爍', '矟', '蒴', '鎙', '鑠', '铄'],
    'fēi pèi': ['妃'],
    wàng: ['妄', '忘', '旺', '望', '朢'],
    zhuāng: [
        '妆',
        '妝',
        '娤',
        '庄',
        '庒',
        '桩',
        '梉',
        '樁',
        '粧',
        '糚',
        '荘',
        '莊',
        '装',
        '裝',
    ],
    mā: ['妈', '媽'],
    'fū yōu': ['妋'],
    'hài jiè': ['妎'],
    dù: [
        '妒',
        '妬',
        '杜',
        '殬',
        '渡',
        '秺',
        '芏',
        '荰',
        '螙',
        '蠧',
        '蠹',
        '鍍',
        '镀',
        '靯',
        '𬭊',
    ],
    miào: ['妙', '庙', '庿', '廟', '玅', '竗'],
    'fǒu pēi pī': ['妚'],
    'yuè jué': ['妜'],
    niū: ['妞'],
    'nà nàn': ['妠'],
    tuǒ: ['妥', '嫷', '庹', '椭', '楕', '橢', '鬌', '鰖', '鵎'],
    'wàn yuán': ['妧'],
    fáng: ['妨', '房', '肪', '防', '魴', '鲂'],
    nī: ['妮'],
    zhóu: ['妯', '碡'],
    zhāo: ['妱', '巶', '招', '昭', '釗', '鉊', '鍣', '钊', '駋', '𬬿'],
    'nǎi nǐ': ['妳'],
    tǒu: ['妵', '敨', '紏', '蘣', '黈'],
    'xián xuán xù': ['妶'],
    'zhí yì': ['妷', '秇'],
    ē: ['妸', '妿', '婀', '屙'],
    mèi: [
        '妹',
        '媚',
        '寐',
        '抺',
        '旀',
        '昧',
        '沬',
        '煝',
        '痗',
        '眛',
        '睸',
        '祙',
        '篃',
        '蝞',
        '袂',
        '跊',
        '鬽',
        '魅',
    ],
    'qī qì': ['妻'],
    'xū xǔ': ['姁', '稰'],
    'shān shàn': ['姍', '姗', '苫', '釤', '钐'],
    mán: ['姏', '慲', '樠', '蛮', '蠻', '謾', '饅', '馒', '鬗', '鬘', '鰻', '鳗'],
    jiě: ['姐', '媎', '檞', '毑', '飷'],
    'wěi wēi': ['委'],
    pīn: ['姘', '拼', '礗', '穦', '馪', '驞'],
    'huá huó': ['姡'],
    'jiāo xiáo': ['姣'],
    'gòu dù': ['姤'],
    'lǎo mǔ': ['姥'],
    'nián niàn': ['姩'],
    zhěn: [
        '姫',
        '屒',
        '弫',
        '抮',
        '昣',
        '枕',
        '畛',
        '疹',
        '眕',
        '稹',
        '縝',
        '縥',
        '缜',
        '聄',
        '萙',
        '袗',
        '裖',
        '覙',
        '診',
        '诊',
        '軫',
        '轸',
        '辴',
        '駗',
        '鬒',
    ],
    héng: [
        '姮',
        '恆',
        '恒',
        '烆',
        '珩',
        '胻',
        '蘅',
        '衡',
        '鑅',
        '鴴',
        '鵆',
        '鸻',
    ],
    'jūn xún': ['姰'],
    'kuā hù': ['姱'],
    'è yà': ['姶'],
    'xiān shēn': ['姺'],
    wá: ['娃'],
    'ráo rǎo': ['娆', '嬈'],
    'shào shāo': ['娋'],
    xiē: ['娎', '揳', '楔', '歇', '蝎', '蠍'],
    'wǔ méi mǔ': ['娒'],
    'chuò lài': ['娕'],
    niáng: ['娘', '嬢', '孃'],
    'nà nuó': ['娜', '𦰡'],
    'pōu bǐ': ['娝'],
    'něi suī': ['娞'],
    tuì: ['娧', '煺', '蛻', '蜕', '退', '駾'],
    mǎn: ['娨', '屘', '満', '满', '滿', '螨', '蟎', '襔', '鏋'],
    'wú wù yú': ['娪'],
    'xī āi': ['娭'],
    'zhuì shuì': ['娷'],
    'dōng dòng': ['娻'],
    'ǎi ái è': ['娾'],
    'ē ě': ['娿'],
    mián: [
        '婂',
        '嬵',
        '宀',
        '杣',
        '棉',
        '檰',
        '櫋',
        '眠',
        '矈',
        '矊',
        '矏',
        '綿',
        '緜',
        '绵',
        '芇',
        '蝒',
    ],
    'pǒu péi bù': ['婄'],
    biǎo: ['婊', '脿', '表', '裱', '褾', '諘', '錶'],
    'fù fàn': ['婏'],
    wǒ: ['婐', '婑', '我'],
    'ní nǐ': ['婗', '棿'],
    'quán juàn': ['婘', '惓'],
    hūn: [
        '婚',
        '昏',
        '昬',
        '棔',
        '涽',
        '睧',
        '睯',
        '碈',
        '荤',
        '葷',
        '蔒',
        '轋',
        '閽',
        '阍',
    ],
    'qiān jǐn': ['婜'],
    'wān wà': ['婠'],
    'lái lài': ['婡', '徕', '徠'],
    'zhōu chōu': ['婤'],
    'chuò nào': ['婥'],
    'nüè àn': ['婩'],
    'hùn kūn': ['婫'],
    'dàng yáng': ['婸'],
    nàn: ['婻'],
    'ruò chuò': ['婼'],
    jiǎ: ['婽', '岬', '斚', '斝', '榎', '槚', '檟', '玾', '甲', '胛', '鉀', '钾'],
    'tōu yú': ['婾', '媮'],
    'yù yú': ['媀'],
    'wéi wěi': ['媁'],
    'dì tí': ['媂', '珶', '苐'],
    róu: [
        '媃',
        '揉',
        '柔',
        '渘',
        '煣',
        '瑈',
        '瓇',
        '禸',
        '粈',
        '糅',
        '脜',
        '腬',
        '葇',
        '蝚',
        '蹂',
        '輮',
        '鍒',
        '鞣',
        '騥',
        '鰇',
        '鶔',
        '𫐓',
    ],
    'ruǎn nèn': ['媆'],
    miáo: ['媌', '嫹', '描', '瞄', '苗', '鶓', '鹋'],
    'yí pèi': ['媐'],
    'mián miǎn': ['媔'],
    'tí shì': ['媞', '惿'],
    'duò tuó': ['媠', '沲'],
    ǎo: ['媪', '媼', '艹', '芺', '袄', '襖', '镺'],
    'chú zòu': ['媰'],
    yìng: ['媵', '映', '暎', '硬', '膡', '鱦'],
    'qín shēn': ['嫀'],
    jià: ['嫁', '幏', '架', '榢', '稼', '駕', '驾'],
    sǎo: ['嫂'],
    'zhēn zhěn': ['嫃'],
    'jiē suǒ': ['嫅'],
    'míng mǐng': ['嫇'],
    niǎo: ['嫋', '嬝', '嬲', '茑', '蔦', '袅', '裊', '褭', '鸟'],
    tāo: [
        '嫍',
        '幍',
        '弢',
        '慆',
        '掏',
        '搯',
        '槄',
        '涛',
        '滔',
        '濤',
        '瑫',
        '絛',
        '縚',
        '縧',
        '绦',
        '詜',
        '謟',
        '轁',
        '鞱',
        '韜',
        '韬',
        '飸',
        '饕',
    ],
    biáo: ['嫑'],
    'piáo piāo': ['嫖', '薸'],
    xuán: [
        '嫙',
        '悬',
        '懸',
        '暶',
        '檈',
        '漩',
        '玄',
        '璇',
        '璿',
        '痃',
        '蜁',
        '𫠊',
    ],
    'màn mān': ['嫚'],
    kāng: [
        '嫝',
        '嵻',
        '康',
        '慷',
        '槺',
        '漮',
        '砊',
        '穅',
        '糠',
        '躿',
        '鏮',
        '鱇',
        '𡐓',
        '𩾌',
    ],
    'hān nǎn': ['嫨'],
    nèn: ['嫩', '嫰'],
    zhē: ['嫬', '遮'],
    'mā má': ['嫲'],
    piè: ['嫳'],
    zhǎn: [
        '嫸',
        '展',
        '搌',
        '斩',
        '斬',
        '琖',
        '盏',
        '盞',
        '輾',
        '醆',
        '颭',
        '飐',
    ],
    'xiān yǎn jìn': ['嬐'],
    liǎn: [
        '嬚',
        '敛',
        '斂',
        '琏',
        '璉',
        '羷',
        '脸',
        '臉',
        '蔹',
        '蘝',
        '蘞',
        '裣',
        '襝',
        '鄻',
    ],
    'qióng huán xuān': ['嬛'],
    dǒng: ['嬞', '懂', '箽', '董', '蕫', '諌'],
    cān: ['嬠', '湌', '爘', '飡', '餐', '驂', '骖'],
    tiǎo: ['嬥', '宨', '晀', '朓', '窱', '脁'],
    bí: ['嬶', '荸', '鼻'],
    liǔ: [
        '嬼',
        '柳',
        '栁',
        '桞',
        '桺',
        '橮',
        '熮',
        '珋',
        '綹',
        '绺',
        '罶',
        '羀',
        '鋶',
        '锍',
    ],
    'qiān xiān': ['孅', '欦'],
    'xié huī': ['孈'],
    'huān quán': ['孉'],
    'lí lì': ['孋', '麗'],
    'zhú chuò': ['孎'],
    kǒng: ['孔', '恐'],
    'mā zī': ['孖'],
    'sūn xùn': ['孙', '孫'],
    'bèi bó': ['孛', '誖'],
    'yòu niū': ['孧'],
    zhuǎn: ['孨', '竱', '轉'],
    hái: ['孩', '骸'],
    nāo: ['孬'],
    'chán càn': ['孱'],
    bò: ['孹', '檗', '蘗', '譒'],
    nái: ['孻', '腉'],
    'níng nìng': ['宁', '寍', '寗', '寜', '寧', '甯'],
    zhái: ['宅'],
    'tū jiā': ['宊'],
    sòng: ['宋', '訟', '誦', '讼', '诵', '送', '鎹', '頌', '颂', '餸'],
    ròu: ['宍', '肉', '譳'],
    zhūn: ['宒', '窀', '衠', '諄', '谆', '迍'],
    'mì fú': ['宓'],
    'dàng tàn': ['宕'],
    'wǎn yuān': ['宛'],
    chǒng: ['宠', '寵'],
    qún: ['宭', '峮', '帬', '羣', '群', '裙', '裠'],
    zǎi: ['宰', '崽'],
    'bǎo shí': ['宲'],
    'jiā jia jie': ['家'],
    'huāng huǎng': ['宺'],
    kuān: ['宽', '寛', '寬', '臗', '鑧', '髋', '髖'],
    'sù xiǔ xiù': ['宿'],
    'jié zǎn': ['寁'],
    'bìng bǐng': ['寎'],
    'jìn qǐn': ['寖'],
    'lóu jù': ['寠'],
    'xiě xiè': ['寫'],
    'qīn qìn': ['寴'],
    cùn: ['寸', '籿'],
    duì: [
        '对',
        '対',
        '對',
        '怼',
        '憝',
        '懟',
        '濧',
        '瀩',
        '碓',
        '祋',
        '綐',
        '薱',
        '譈',
        '譵',
        '轛',
        '队',
        '陮',
    ],
    'lüè luó': ['寽'],
    'shè yè yì': ['射'],
    'jiāng jiàng qiāng': ['将'],
    'jiāng jiàng': ['將', '浆', '漿', '畺'],
    zūn: ['尊', '嶟', '樽', '罇', '遵', '鐏', '鱒', '鳟', '鶎', '鷷', '𨱔'],
    'shù zhù': ['尌', '澍'],
    xiǎo: ['小', '晓', '暁', '曉', '皛', '皢', '筱', '筿', '篠', '謏', '𫍲'],
    'jié jí': ['尐', '诘', '鞊'],
    'shǎo shào': ['少'],
    ěr: [
        '尒',
        '尓',
        '尔',
        '栮',
        '毦',
        '洱',
        '爾',
        '珥',
        '耳',
        '薾',
        '衈',
        '趰',
        '迩',
        '邇',
        '鉺',
        '铒',
        '餌',
        '饵',
        '駬',
    ],
    'wāng yóu': ['尢'],
    wāng: ['尣', '尩', '尪', '尫', '汪'],
    liào: ['尥', '尦', '廖', '撂', '料', '炓', '窷', '鐐', '镣', '𪤗'],
    'méng máng lóng páng': ['尨'],
    gà: ['尬', '魀'],
    'kuì kuǐ': ['尯'],
    tuí: ['尵', '弚', '穨', '蘈', '蹪', '隤', '頹', '頺', '頽', '颓', '魋', '𬯎'],
    yǐn: [
        '尹',
        '嶾',
        '引',
        '朄',
        '檃',
        '檼',
        '櫽',
        '淾',
        '濥',
        '瘾',
        '癮',
        '粌',
        '蘟',
        '蚓',
        '螾',
        '讔',
        '赺',
        '趛',
        '輑',
        '鈏',
        '靷',
    ],
    'chǐ chě': ['尺'],
    kāo: ['尻', '髛'],
    'jìn jǐn': ['尽'],
    'wěi yǐ': ['尾'],
    'niào suī': ['尿'],
    céng: ['层', '層', '嶒', '驓'],
    diǎo: ['屌'],
    'píng bǐng bīng': ['屏'],
    lòu: ['屚', '漏', '瘘', '瘺', '瘻', '鏤', '镂', '陋'],
    'shǔ zhǔ': ['属', '屬'],
    'xiè tì': ['屟'],
    'chè cǎo': ['屮'],
    'tún zhūn': ['屯'],
    'nì jǐ': ['屰'],
    'hóng lóng': ['屸'],
    'qǐ kǎi': ['岂', '豈'],
    áng: ['岇', '昂', '昻'],
    'gǎng gāng': ['岗', '崗'],
    kě: ['岢', '敤', '渇', '渴', '炣'],
    gǒu: ['岣', '狗', '玽', '笱', '耇', '耈', '耉', '苟', '豿'],
    tiáo: [
        '岧',
        '岹',
        '樤',
        '祒',
        '笤',
        '芀',
        '萔',
        '蓚',
        '蓨',
        '蜩',
        '迢',
        '鋚',
        '鎥',
        '鞗',
        '髫',
        '鯈',
        '鰷',
        '鲦',
        '齠',
        '龆',
    ],
    'qū jū': ['岨'],
    lǐng: ['岭', '嶺', '領', '领'],
    pò: ['岶', '敀', '洦', '湐', '烞', '珀', '破', '砶', '粕', '蒪', '魄'],
    'bā kè': ['峇'],
    luò: [
        '峈',
        '摞',
        '洛',
        '洜',
        '犖',
        '珞',
        '笿',
        '纙',
        '荦',
        '詻',
        '雒',
        '駱',
        '骆',
        '鵅',
    ],
    'fù niè': ['峊'],
    ěn: ['峎'],
    'zhì shì': ['峙', '崻'],
    qiǎ: ['峠', '跒', '酠', '鞐'],
    'qiáo jiào': ['峤', '癄'],
    'xié yé': ['峫'],
    bū: ['峬', '庯', '晡', '誧', '逋', '鈽', '錻', '钸', '餔', '鵏'],
    chóng: ['崇', '崈', '爞', '虫', '蝩', '蟲', '褈', '隀'],
    'zú cuì': ['崒', '椊'],
    'líng léng': ['崚'],
    'dòng dōng': ['崠'],
    xiáo: ['崤', '洨', '淆', '訤', '誵'],
    'pí bǐ': ['崥', '芘'],
    'zhǎn chán': ['崭', '嶃', '嶄'],
    'wǎi wēi': ['崴'],
    'yáng dàng': ['崵'],
    'shì dié': ['崼'],
    yào: [
        '崾',
        '曜',
        '熎',
        '燿',
        '矅',
        '穾',
        '窔',
        '筄',
        '耀',
        '艞',
        '药',
        '葯',
        '薬',
        '藥',
        '袎',
        '覞',
        '詏',
        '讑',
        '靿',
        '鷂',
        '鹞',
        '鼼',
    ],
    'kān zhàn': ['嵁'],
    'hán dǎng': ['嵅'],
    'qiàn kàn': ['嵌'],
    'wù máo': ['嵍'],
    'kě jié': ['嵑', '嶱'],
    'wēi wěi': ['嵔'],
    kē: [
        '嵙',
        '柯',
        '棵',
        '榼',
        '樖',
        '牁',
        '牱',
        '犐',
        '珂',
        '疴',
        '瞌',
        '磕',
        '礚',
        '科',
        '稞',
        '窠',
        '萪',
        '薖',
        '蚵',
        '蝌',
        '趷',
        '轲',
        '醘',
        '鈳',
        '钶',
        '頦',
        '顆',
        '颗',
        '髁',
    ],
    'dàng táng': ['嵣'],
    'róng yíng': ['嵤', '爃'],
    'ái kǎi': ['嵦'],
    'kāo qiāo': ['嵪'],
    cuó: ['嵯', '嵳', '痤', '矬', '蒫', '蔖', '虘', '鹺', '鹾'],
    'qiǎn qīn': ['嵰'],
    'dì dié': ['嵽'],
    cēn: ['嵾'],
    dǐng: ['嵿', '艼', '薡', '鐤', '頂', '顶', '鼎', '鼑'],
    'áo ào': ['嶅'],
    'pǐ pèi': ['嶏'],
    'jiào qiáo': ['嶠', '潐'],
    'jué guì': ['嶡', '鳜'],
    'zhān shàn': ['嶦', '鳣'],
    'xiè jiè': ['嶰'],
    'guī xī juàn': ['嶲'],
    rū: ['嶿'],
    'lì liè': ['巁', '棙', '爄', '綟'],
    'xī guī juàn': ['巂'],
    'yíng hōng': ['巆'],
    yǐng: [
        '巊',
        '廮',
        '影',
        '摬',
        '梬',
        '潁',
        '瘿',
        '癭',
        '矨',
        '穎',
        '郢',
        '鐛',
        '頴',
        '颍',
        '颕',
        '颖',
    ],
    chǎo: ['巐', '炒', '煼', '眧', '麨'],
    cuán: ['巑', '櫕', '欑'],
    chuān: ['巛', '川', '氚', '瑏', '穿'],
    'jīng xíng': ['巠'],
    cháo: [
        '巢',
        '巣',
        '晁',
        '漅',
        '潮',
        '牊',
        '窲',
        '罺',
        '謿',
        '轈',
        '鄛',
        '鼌',
    ],
    qiǎo: ['巧', '愀', '髜'],
    gǒng: ['巩', '廾', '拱', '拲', '栱', '汞', '珙', '輁', '鞏'],
    'chà chā chāi cī': ['差'],
    'xiàng hàng': ['巷'],
    shuài: ['帅', '帥', '蟀'],
    pà: ['帊', '帕', '怕', '袙'],
    'tǎng nú': ['帑'],
    'mò wà': ['帓'],
    'tiē tiě tiè': ['帖'],
    zhǒu: ['帚', '晭', '疛', '睭', '箒', '肘', '菷', '鯞'],
    'juǎn juàn': ['帣'],
    shuì: ['帨', '涗', '涚', '睡', '稅', '税', '裞'],
    'chóu dào': ['帱', '幬'],
    'jiǎn jiān sàn': ['帴'],
    'shà qiè': ['帹'],
    'qí jì': ['帺', '荠'],
    'shān qiāo shēn': ['幓'],
    'zhuàng chuáng': ['幢'],
    'chān chàn': ['幨'],
    miè: [
        '幭',
        '懱',
        '搣',
        '滅',
        '灭',
        '烕',
        '礣',
        '篾',
        '蔑',
        '薎',
        '蠛',
        '衊',
        '鑖',
        '鱴',
        '鴓',
    ],
    'gān gàn': ['干'],
    'bìng bīng': ['并', '幷'],
    'jī jǐ': ['幾'],
    'guǎng ān': ['广'],
    guǎng: ['広', '廣', '犷', '獷'],
    me: ['庅'],
    'dùn tún': ['庉'],
    'bài tīng': ['庍'],
    'yìng yīng': ['应'],
    'dǐ de': ['底'],
    'dù duó': ['度'],
    'máng méng páng': ['庬'],
    'bìng píng': ['庰'],
    chěng: ['庱', '悜', '睈', '逞', '騁', '骋'],
    'jī cuò': ['庴'],
    qǐng: ['庼', '廎', '檾', '漀', '苘', '請', '謦', '请', '頃', '顷'],
    'guī wěi huì': ['廆'],
    'jǐn qín': ['廑'],
    kuò: [
        '廓',
        '扩',
        '拡',
        '擴',
        '濶',
        '筈',
        '萿',
        '葀',
        '蛞',
        '闊',
        '阔',
        '霩',
        '鞟',
        '鞹',
        '韕',
        '頢',
        '鬠',
    ],
    'qiáng sè': ['廧', '薔'],
    'yǐn yìn': ['廴', '隐', '隠', '隱', '飮', '飲', '饮'],
    'pò pǎi': ['廹', '迫'],
    'nòng lòng': ['弄'],
    'dì tì tuí': ['弟'],
    'jué zhāng': ['弡'],
    'mí mǐ': ['弥', '彌', '靡'],
    chāo: ['弨', '怊', '抄', '欩', '訬', '超', '鈔', '钞'],
    yi: ['弬'],
    shāo: [
        '弰',
        '旓',
        '烧',
        '焼',
        '燒',
        '筲',
        '艄',
        '萷',
        '蕱',
        '輎',
        '髾',
        '鮹',
    ],
    'xuān yuān': ['弲'],
    'qiáng qiǎng jiàng': ['強', '强'],
    'tán dàn': ['弹', '醈'],
    biè: ['彆'],
    'qiáng jiàng qiǎng': ['彊'],
    'jì xuě': ['彐'],
    tuàn: ['彖', '褖'],
    yuē: ['彟', '曰', '曱', '矱'],
    'shān xiǎn': ['彡'],
    wén: [
        '彣',
        '文',
        '炆',
        '珳',
        '瘒',
        '繧',
        '聞',
        '芠',
        '蚉',
        '蚊',
        '螡',
        '蟁',
        '閺',
        '閿',
        '闅',
        '闦',
        '闻',
        '阌',
        '雯',
        '馼',
        '駇',
        '魰',
        '鳼',
        '鴍',
        '鼤',
        '𫘜',
    ],
    'péng bāng': ['彭'],
    'piāo piào': ['彯'],
    'zhuó bó': ['彴'],
    'tuǒ yí': ['彵'],
    'páng fǎng': ['彷'],
    wǎng: [
        '彺',
        '往',
        '徃',
        '惘',
        '枉',
        '棢',
        '網',
        '网',
        '罒',
        '罓',
        '罔',
        '罖',
        '菵',
        '蛧',
        '蝄',
        '誷',
        '輞',
        '辋',
        '魍',
    ],
    cú: ['徂', '殂'],
    'dài dāi': ['待'],
    huái: ['徊', '怀', '懐', '懷', '槐', '淮', '耲', '蘹', '褢', '褱', '踝'],
    'wā wàng jiā': ['徍'],
    'chěng zhèng': ['徎'],
    'dé děi de': ['得'],
    'cóng zòng': ['從'],
    'shì tǐ': ['徥'],
    'tí chí': ['徲', '鶗', '鶙'],
    dé: ['徳', '德', '恴', '悳', '惪', '淂', '鍀', '锝'],
    'zhǐ zhēng': ['徴', '徵'],
    bié: ['徶', '癿', '莂', '蛂', '襒', '蹩'],
    'chōng zhǒng': ['徸'],
    'jiǎo jiào': ['徼', '笅', '筊'],
    'lòng lǒng': ['徿'],
    'qú jù': ['忂', '渠', '瞿', '螶'],
    'dìng tìng': ['忊'],
    gǎi: ['忋', '改'],
    rěn: ['忍', '栠', '栣', '秹', '稔', '綛', '荏', '荵', '躵'],
    chàn: ['忏', '懴', '懺', '硟', '羼', '韂', '顫'],
    tè: ['忑', '慝', '特', '蟘', '鋱', '铽'],
    'tè tēi tuī': ['忒'],
    'gān hàn': ['忓', '攼'],
    'yì qì': ['忔'],
    'tài shì': ['忕'],
    'xī liě': ['忚'],
    'yīng yìng': ['応', '應', '譍'],
    'mǐn wěn mín': ['忞', '忟'],
    'sōng zhōng': ['忪'],
    'yù shū': ['忬', '悆'],
    'qí shì': ['忯', '耆'],
    'tún zhūn dùn': ['忳'],
    'qián qín': ['忴', '扲'],
    hún: ['忶', '浑', '渾', '餛', '馄', '魂', '鼲'],
    niǔ: ['忸', '扭', '炄', '狃', '紐', '纽', '莥', '鈕', '钮', '靵'],
    'kuáng wǎng': ['忹'],
    'kāng hàng': ['忼'],
    'kài xì': ['忾', '愾'],
    òu: ['怄', '慪'],
    'bǎo bào': ['怉'],
    'mín mén': ['怋'],
    'zuò zhà': ['怍'],
    zěn: ['怎'],
    yàng: ['怏', '恙', '样', '様', '樣', '漾', '羕', '詇'],
    'kòu jù': ['怐'],
    'náo niú': ['怓'],
    'zhēng zhèng': ['怔', '掙', '钲', '铮'],
    'tiē zhān': ['怗'],
    'hù gù': ['怘'],
    'cū jù zū': ['怚'],
    'sī sāi': ['思'],
    'yóu chóu': ['怞'],
    'tū dié': ['怢'],
    'yōu yào': ['怮'],
    xuàn: [
        '怰',
        '昡',
        '楦',
        '泫',
        '渲',
        '炫',
        '琄',
        '眩',
        '碹',
        '絢',
        '縼',
        '繏',
        '绚',
        '蔙',
        '衒',
        '袨',
        '贙',
        '鉉',
        '鏇',
        '铉',
        '镟',
        '颴',
    ],
    'xù xuè': ['怴'],
    'bì pī': ['怶'],
    'xī shù': ['怸'],
    'nèn nín': ['恁'],
    'tiāo yáo': ['恌'],
    'xī qī xù': ['恓'],
    'xiào jiǎo': ['恔'],
    'hū kuā': ['恗'],
    nǜ: ['恧', '朒', '衂', '衄'],
    hèn: ['恨'],
    'dòng tōng': ['恫'],
    'quán zhuān': ['恮'],
    'è wù ě wū': ['恶', '惡'],
    tòng: ['恸', '慟', '憅', '痛', '衕'],
    'yuān juàn': ['悁'],
    'qiāo qiǎo': ['悄'],
    'jiè kè': ['悈'],
    'hào jiào': ['悎'],
    huǐ: ['悔', '檓', '毀', '毁', '毇', '燬', '譭'],
    'mán mèn': ['悗', '鞔'],
    'yī yì': ['悘', '衣'],
    quān: ['悛', '箞', '鐉', '𨟠'],
    'kuī lǐ': ['悝'],
    'yì niàn': ['悥'],
    'mèn mēn': ['悶'],
    guàn: [
        '悹',
        '悺',
        '惯',
        '慣',
        '掼',
        '摜',
        '樌',
        '欟',
        '泴',
        '涫',
        '潅',
        '灌',
        '爟',
        '瓘',
        '盥',
        '礶',
        '祼',
        '罆',
        '罐',
        '貫',
        '贯',
        '躀',
        '遦',
        '鏆',
        '鑵',
        '鱹',
        '鸛',
        '鹳',
    ],
    'kōng kǒng': ['悾'],
    'lǔn lùn': ['惀'],
    guǒ: [
        '惈',
        '果',
        '椁',
        '槨',
        '粿',
        '綶',
        '菓',
        '蜾',
        '裹',
        '褁',
        '輠',
        '餜',
        '馃',
    ],
    'yuān wǎn': ['惌', '箢'],
    'lán lín': ['惏'],
    'yù xù': ['惐', '淢'],
    'chuò chuì': ['惙'],
    'hūn mèn': ['惛'],
    'chǎng tǎng': ['惝'],
    'suǒ ruǐ': ['惢'],
    cǎn: ['惨', '慘', '憯', '黪', '黲', '䅟'],
    cán: ['惭', '慙', '慚', '残', '殘', '蚕', '蝅', '蠶', '蠺'],
    'dàn dá': ['惮', '憚'],
    rě: ['惹'],
    'yú tōu': ['愉'],
    'kài qì': ['愒'],
    'dàng táng shāng yáng': ['愓'],
    'chén xìn dān': ['愖'],
    'kè qià': ['愘'],
    nuò: [
        '愞',
        '懦',
        '懧',
        '掿',
        '搦',
        '榒',
        '稬',
        '穤',
        '糑',
        '糥',
        '糯',
        '諾',
        '诺',
        '蹃',
        '逽',
        '鍩',
        '锘',
    ],
    gǎn: [
        '感',
        '擀',
        '敢',
        '桿',
        '橄',
        '澉',
        '澸',
        '皯',
        '秆',
        '稈',
        '笴',
        '芉',
        '衦',
        '赶',
        '趕',
        '鱤',
        '鳡',
    ],
    'còng sōng': ['愡'],
    'sāi sī sǐ': ['愢'],
    'gōng gòng hǒng': ['愩', '慐'],
    'shuò sù': ['愬', '洬'],
    'yáo yào': ['愮'],
    huàng: ['愰', '曂', '榥', '滉', '皝', '皩', '鎤', '㿠'],
    zhěng: ['愸', '抍', '拯', '整', '晸'],
    cǎo: ['愺', '艸', '草', '騲'],
    'xì xié': ['慀'],
    'cǎo sāo': ['慅'],
    'xù chù': ['慉'],
    'qiè qiàn': ['慊'],
    'cáo cóng': ['慒'],
    'ào áo': ['慠'],
    'lián liǎn': ['慩', '梿', '槤', '櫣'],
    'jìn qín jǐn': ['慬'],
    'dì chì': ['慸'],
    'zhí zhé': ['慹'],
    'lóu lǚ': ['慺', '鷜'],
    còng: ['憁', '謥'],
    'zhī zhì': ['憄', '知', '織', '织'],
    chēng: [
        '憆',
        '摚',
        '撐',
        '撑',
        '晿',
        '柽',
        '棦',
        '橕',
        '檉',
        '泟',
        '浾',
        '琤',
        '瞠',
        '碀',
        '緽',
        '罉',
        '蛏',
        '蟶',
        '赪',
        '赬',
        '鏿',
        '鐣',
        '阷',
        '靗',
        '頳',
        '饓',
    ],
    biē: ['憋', '虌', '鱉', '鳖', '鼈', '龞'],
    'chéng dèng zhèng': ['憕'],
    'xǐ xī': ['憘'],
    'duì dùn tūn': ['憞'],
    'xiāo jiāo': ['憢'],
    'xián xiàn': ['憪'],
    'liáo liǎo': ['憭', '燎', '爎', '爒'],
    shéng: ['憴', '縄', '繉', '繩', '绳', '譝'],
    'náo nǎo náng': ['憹'],
    'jǐng jìng': ['憼'],
    'jǐ jiǎo': ['憿'],
    'xuān huān': ['懁'],
    'cǎo sāo sào': ['懆'],
    mèn: ['懑', '懣', '暪', '焖', '燜'],
    'mèng méng měng': ['懜'],
    'ài yì nǐ': ['懝'],
    'méng měng': ['懞', '瞢', '矒'],
    'qí jī jì': ['懠'],
    mǒ: ['懡'],
    'lán xiàn': ['懢'],
    'yōu yǒu': ['懮'],
    'liú liǔ': ['懰', '藰'],
    ràng: ['懹', '譲', '讓', '让'],
    huān: ['懽', '欢', '歓', '歡', '獾', '讙', '貛', '酄', '驩', '鴅', '鵍'],
    nǎn: ['戁', '揇', '湳', '煵', '腩', '蝻', '赧'],
    'mí mó': ['戂'],
    'gàng zhuàng': ['戅', '戆'],
    'zhuàng gàng': ['戇'],
    'xū qu': ['戌'],
    'xì hū': ['戏', '戯', '戲'],
    'jiá gā': ['戛'],
    zéi: ['戝', '蠈', '賊', '贼', '鰂', '鱡', '鲗'],
    děng: ['戥', '等'],
    'hū xì': ['戱'],
    chuō: ['戳', '踔', '逴'],
    'biǎn piān': ['扁'],
    'shǎng jiōng': ['扄'],
    'shàn shān': ['扇'],
    cái: ['才', '材', '纔', '裁', '財', '财'],
    'zhā zā zhá': ['扎'],
    'lè lì cái': ['扐'],
    'bā pá': ['扒'],
    'dǎ dá': ['打'],
    rēng: ['扔'],
    'fǎn fú': ['払'],
    'diǎo dí yuē lì': ['扚'],
    'káng gāng': ['扛'],
    'yū wū': ['扜'],
    'yū wū kū': ['扝'],
    'tuō chǐ yǐ': ['扡'],
    'gǔ jié xì gē': ['扢'],
    dèn: ['扥', '扽'],
    'sǎo sào': ['扫', '掃'],
    rǎo: ['扰', '擾', '隢'],
    'xī chā qì': ['扱'],
    'bān pān': ['扳'],
    'bā ào': ['扷'],
    'xī zhé': ['扸'],
    'zhì sǔn kǎn': ['扻'],
    zhǎo: ['找', '沼', '瑵'],
    'kuáng wǎng zài': ['抂'],
    'hú gǔ': ['抇', '鹄', '鹘'],
    'bǎ bà': ['把'],
    'dǎn shěn': ['抌'],
    'nè nì ruì nà': ['抐'],
    zhuā: ['抓', '檛', '簻', '膼', '髽'],
    póu: ['抔', '裒'],
    'zhé shé zhē': ['折'],
    'póu pōu fū': ['抙', '捊'],
    pāo: ['抛', '拋', '脬', '萢'],
    'ǎo ào niù': ['抝'],
    'lūn lún': ['抡', '掄'],
    'qiǎng qiāng chēng': ['抢'],
    'zhǐ zhǎi': ['抧'],
    'bù pū': ['抪', '柨'],
    'yǎo tāo': ['抭'],
    'hē hè qiā': ['抲'],
    'nǐ ní': ['抳'],
    'pī pēi': ['抷'],
    'mǒ mò mā': ['抹'],
    chōu: ['抽', '犨', '犫', '瘳', '篘'],
    'jiā yá': ['拁'],
    'fú bì': ['拂', '畐', '鶝'],
    zhǎ: ['拃', '眨', '砟', '鮺', '鲝'],
    'dān dàn dǎn': ['担'],
    'chāi cā': ['拆'],
    niān: ['拈', '蔫'],
    'lā lá lǎ là': ['拉'],
    'bàn pàn': ['拌'],
    pāi: ['拍'],
    līn: ['拎'],
    guǎi: ['拐', '枴', '柺'],
    'tuò tà zhí': ['拓'],
    'ào ǎo niù': ['拗'],
    'jū gōu': ['拘'],
    'pīn pàn fān': ['拚'],
    'bài bái': ['拜'],
    bài: ['拝', '敗', '稗', '粺', '薭', '贁', '败', '韛'],
    qiá: ['拤'],
    'nǐng níng nìng': ['拧'],
    'zé zhái': ['择', '擇'],
    hén: ['拫', '痕', '鞎'],
    'kuò guā': ['括'],
    'jié jiá': ['拮'],
    nǐn: ['拰'],
    shuān: ['拴', '栓', '閂', '闩'],
    'cún zùn': ['拵'],
    'zā zǎn': ['拶', '桚'],
    kǎo: ['拷', '攷', '栲', '烤', '考'],
    'yí chǐ hài': ['拸'],
    'cè sè chuò': ['拺'],
    'zhuài zhuāi yè': ['拽'],
    'shí shè': ['拾'],
    bāi: ['挀', '掰'],
    'kuò guāng': ['挄'],
    nòng: ['挊', '挵', '齈'],
    'jiào jiāo': ['挍', '敎', '教'],
    'kuà kū': ['挎'],
    'ná rú': ['挐'],
    'tiāo tiǎo': ['挑'],
    'dié shè': ['挕'],
    liě: ['挘', '毟'],
    'yà yǎ': ['挜', '掗'],
    'wō zhuā': ['挝'],
    'xié jiā': ['挟', '挾'],
    'dǎng dàng': ['挡', '擋'],
    'zhèng zhēng': ['挣', '正', '症'],
    'āi ái': ['挨'],
    'tuō shuì': ['挩', '捝'],
    'tǐ tì': ['挮'],
    'suō shā': ['挱'],
    'sā shā suō': ['挲'],
    'kēng qiān': ['挳', '摼'],
    'bàng péng': ['挷'],
    'ruó ruá': ['挼'],
    'jiǎo kù': ['捁'],
    'wǔ wú': ['捂'],
    tǒng: ['捅', '桶', '筒', '筩', '統', '綂', '统', '㛚'],
    'huò chì': ['捇'],
    'tú shū chá': ['捈'],
    'lǚ luō': ['捋'],
    'shāo shào': ['捎', '稍'],
    niē: ['捏', '揑'],
    'shù sǒng sōu': ['捒'],
    'yé yú': ['捓'],
    'jué zhuó': ['捔'],
    'bù pú zhì': ['捗'],
    zùn: ['捘', '銌'],
    lāo: ['捞', '撈', '粩'],
    sǔn: ['损', '損', '榫', '笋', '筍', '箰', '鎨', '隼'],
    'wàn wǎn wān yù': ['捥'],
    pěng: ['捧', '淎', '皏'],
    shě: ['捨'],
    'fǔ fù bǔ': ['捬'],
    dáo: ['捯'],
    'luò luǒ wǒ': ['捰'],
    'juǎn quán': ['捲'],
    'chēn tiǎn': ['捵'],
    'niǎn niē': ['捻'],
    'ruó wěi ré': ['捼'],
    zuó: ['捽', '昨', '秨', '稓', '筰', '莋', '鈼'],
    'wò xiá': ['捾'],
    'qìng qiàn': ['掅'],
    'póu pǒu': ['掊'],
    qiā: ['掐', '葜'],
    'pái pǎi': ['排'],
    'qiān wàn': ['掔'],
    'yè yē': ['掖'],
    'niè nǐ yì': ['掜'],
    'huò xù': ['掝'],
    'yàn shàn yǎn': ['掞'],
    'zhěng dìng': ['掟'],
    kòng: ['控', '鞚'],
    tuī: ['推', '蓷', '藬'],
    'zōu zhōu chōu': ['掫'],
    tiàn: ['掭', '舚'],
    kèn: ['掯', '裉', '褃'],
    pá: ['掱', '杷', '潖', '爬', '琶', '筢'],
    'guó guāi': ['掴'],
    'dǎn shàn': ['掸', '撣'],
    'chān xiān càn shǎn': ['掺'],
    sāo: ['掻', '搔', '溞', '繅', '缫', '螦', '騒', '騷', '鰠', '鱢', '鳋'],
    pèng: ['掽', '椪', '槰', '碰', '踫'],
    'zhēng kēng': ['揁'],
    'jiū yóu': ['揂'],
    'jiān jiǎn': ['揃', '籛'],
    'pì chè': ['揊'],
    'sāi zǒng cāi': ['揌'],
    'tí dī dǐ': ['提'],
    'zǒng sōng': ['揔'],
    'huáng yóng': ['揘'],
    'zǎn zuàn': ['揝'],
    'xū jū': ['揟'],
    'ké qiā': ['揢'],
    'chuāi chuǎi chuài tuán zhuī': ['揣'],
    'dì tì': ['揥'],
    'lá là': ['揦'],
    là: [
        '揧',
        '楋',
        '溂',
        '瓎',
        '瘌',
        '翋',
        '臘',
        '蝋',
        '蝲',
        '蠟',
        '辢',
        '辣',
        '鑞',
        '镴',
        '鬎',
        '鯻',
        '𬶟',
    ],
    'jiē qì': ['揭'],
    'chòng dǒng': ['揰'],
    'dié shé yè': ['揲'],
    'jiàn qián jiǎn': ['揵'],
    yé: ['揶', '爷', '爺', '瑘', '鋣', '鎁', '铘'],
    chān: ['搀', '摻', '攙', '裧', '襜', '覘', '觇', '辿', '鋓'],
    'gē gé': ['搁', '擱'],
    'lǒu lōu': ['搂', '摟'],
    'chōu zǒu': ['搊'],
    chuāi: ['搋'],
    sūn: ['搎', '槂', '狲', '猻', '荪', '蓀', '蕵', '薞', '飧', '飱'],
    'róng náng nǎng': ['搑'],
    'péng bàng': ['搒'],
    cuō: ['搓', '瑳', '磋', '蹉', '遳', '醝'],
    'kē è': ['搕'],
    'nù nuò nòu': ['搙'],
    'lā xié xiàn': ['搚'],
    qiǔ: ['搝', '糗'],
    'xiǎn xiān': ['搟'],
    'jié zhé': ['搩'],
    'pán bān pó': ['搫'],
    bān: [
        '搬',
        '攽',
        '斑',
        '斒',
        '班',
        '瘢',
        '癍',
        '肦',
        '螁',
        '螌',
        '褩',
        '辬',
        '頒',
        '颁',
        '𨭉',
    ],
    'zhì nái': ['搱'],
    'wā wǎ wà': ['搲'],
    huá: ['搳', '撶', '滑', '猾', '蕐', '螖', '譁', '鏵', '铧', '驊', '骅', '鷨'],
    'qiāng qiǎng chēng': ['搶'],
    'tián shēn': ['搷'],
    'ná nuò': ['搻'],
    èn: ['摁'],
    'shè niè': ['摄', '攝'],
    bìn: ['摈', '擯', '殡', '殯', '膑', '臏', '髌', '髕', '髩', '鬂', '鬓', '鬢'],
    'shā sà shǎi': ['摋'],
    'chǎn sùn': ['摌'],
    'jiū liú liáo jiǎo náo': ['摎'],
    'féng pěng': ['摓'],
    shuāi: ['摔'],
    'dì tú zhí': ['摕'],
    'qì jì chá': ['摖'],
    'sōu sǒng': ['摗'],
    'liǎn liàn': ['摙'],
    'gài xì': ['摡'],
    'hù chū': ['摢'],
    tàng: ['摥', '烫', '燙', '鐋'],
    'nái zhì': ['摨'],
    'mó mā': ['摩'],
    'jiāng qiàng': ['摪'],
    'áo qiáo': ['摮'],
    'niè chè': ['摰'],
    'mán màn': ['摱'],
    'chàn cán': ['摲'],
    'sè mí sù': ['摵'],
    'biāo biào': ['摽'],
    'juē jué': ['撅'],
    piē: ['撆', '暼', '氕', '瞥'],
    'piě piē': ['撇'],
    'zǎn zān zēn qián': ['撍'],
    'sā sǎ': ['撒'],
    hòng: ['撔', '訌', '讧', '闀', '鬨'],
    'héng guàng': ['撗'],
    niǎn: [
        '撚',
        '撵',
        '攆',
        '涊',
        '焾',
        '碾',
        '簐',
        '蹍',
        '蹨',
        '躎',
        '輦',
        '辇',
    ],
    'chéng zhěng': ['撜'],
    'huī wéi': ['撝'],
    cāo: ['撡', '操', '糙'],
    'xiāo sōu': ['撨'],
    'liáo liāo': ['撩'],
    'cuō zuǒ': ['撮'],
    'wěi tuǒ': ['撱'],
    cuān: ['撺', '攛', '汆', '蹿', '躥', '鑹', '镩'],
    'qiào yāo jī': ['撽'],
    'zhuā wō': ['撾'],
    'lèi léi': ['擂'],
    nǎng: ['擃', '攮', '曩', '灢'],
    'qíng jǐng': ['擏'],
    kuǎi: ['擓', '蒯', '㧟'],
    'pǐ bò': ['擗'],
    'bò bāi': ['擘'],
    'jù jǐ': ['據'],
    mēng: ['擝'],
    'sǒu sòu': ['擞'],
    xǐng: ['擤', '箵', '醒'],
    cā: ['擦'],
    'níng nǐng nìng': ['擰'],
    'zhì jié': ['擳'],
    'là liè': ['擸', '爉'],
    'sòu sǒu': ['擻'],
    'lì luò yuè': ['擽'],
    'tī zhāi zhì': ['擿'],
    pān: ['攀', '潘', '眅', '萠'],
    lèi: [
        '攂',
        '泪',
        '涙',
        '淚',
        '禷',
        '类',
        '纇',
        '蘱',
        '酹',
        '銇',
        '錑',
        '頛',
        '頪',
        '類',
        '颣',
    ],
    'cā sǎ': ['攃'],
    'jùn pèi': ['攈'],
    'lì luò': ['攊', '躒'],
    'là lài': ['攋', '櫴'],
    'lú luó': ['攎'],
    'zǎn cuán': ['攒'],
    'xiān jiān': ['攕'],
    'mí mǐ mó': ['攠'],
    'zǎn cuán zàn zuān': ['攢'],
    zuàn: ['攥'],
    'lì shài': ['攦'],
    'lì luǒ': ['攭'],
    'guǐ guì': ['攱'],
    'jī qī yǐ': ['攲'],
    fàng: ['放'],
    'wù móu': ['敄'],
    'chù shōu': ['敊'],
    'gé guó è': ['敋'],
    'duó duì': ['敓', '敚'],
    'duō què': ['敠', '敪'],
    'sàn sǎn': ['散'],
    'dūn duì': ['敦', '镦'],
    'qī yǐ jī': ['敧'],
    'xiào xué': ['敩'],
    'shù shǔ shuò': ['数', '數'],
    'ái zhú': ['敱', '敳'],
    'xiòng xuàn': ['敻'],
    'zhuó zhú': ['斀'],
    'yì dù': ['斁'],
    'lí tái': ['斄'],
    'fěi fēi': ['斐'],
    'yǔ zhōng': ['斔'],
    'dòu dǒu': ['斗'],
    'wò guǎn': ['斡'],
    'tǒu tiǎo': ['斢'],
    dòu: [
        '斣',
        '梪',
        '浢',
        '痘',
        '窦',
        '竇',
        '脰',
        '荳',
        '豆',
        '逗',
        '郖',
        '酘',
        '閗',
        '闘',
        '餖',
        '饾',
        '鬥',
        '鬦',
        '鬪',
        '鬬',
        '鬭',
    ],
    'yín zhì': ['斦'],
    'chǎn jiè': ['斺'],
    'wū yū yú': ['於'],
    'yóu liú': ['斿'],
    'páng bàng': ['旁'],
    'máo mào': ['旄'],
    'pī bì': ['旇'],
    'xuán xuàn': ['旋'],
    'wú mó': ['无'],
    zǎo: ['早', '枣', '栆', '棗', '澡', '璪', '薻', '藻', '蚤'],
    gā: ['旮'],
    'gàn hàn': ['旰'],
    'tái yīng': ['旲'],
    'xū xù': ['旴'],
    'tūn zhùn': ['旽'],
    'wù wǔ': ['旿'],
    'pò pèi': ['昢'],
    zòng: ['昮', '猔', '疭', '瘲', '粽', '糉', '糭', '縦'],
    ǎi: ['昹', '毐', '矮', '蔼', '藹', '譪', '躷', '霭', '靄'],
    'huàng huǎng': ['晃'],
    xuǎn: ['晅', '癣', '癬', '选', '選'],
    'xù kuā': ['晇'],
    hǒng: ['晎'],
    shài: ['晒', '曬'],
    'yūn yùn': ['晕', '煴'],
    'shèng chéng': ['晟', '椉', '盛'],
    'jǐng yǐng': ['景'],
    shǎn: ['晱', '熌', '睒', '覢', '閃', '闪', '陕', '陝'],
    'qǐ dù': ['晵'],
    'ǎn àn yǎn': ['晻'],
    'wǎng wàng': ['暀'],
    zàn: [
        '暂',
        '暫',
        '瓉',
        '瓒',
        '瓚',
        '禶',
        '襸',
        '讃',
        '讚',
        '賛',
        '贊',
        '赞',
        '蹔',
        '鄼',
        '錾',
        '鏨',
        '饡',
    ],
    'yùn yūn': ['暈'],
    'mín mǐn': ['暋'],
    'dǔ shǔ': ['暏'],
    shǔ: [
        '暑',
        '曙',
        '潻',
        '癙',
        '糬',
        '署',
        '薥',
        '薯',
        '藷',
        '蜀',
        '蠴',
        '襡',
        '襩',
        '鱪',
        '鱰',
        '黍',
        '鼠',
        '鼡',
    ],
    'jiǎn lán': ['暕'],
    nuǎn: ['暖', '煗', '餪'],
    'bào pù': ['暴'],
    'xī xǐ': ['暿'],
    'pù bào': ['曝', '瀑'],
    'qū qǔ': ['紶'],
    'qǔ qū': ['曲'],
    'gèng gēng': ['更'],
    'hū hù': ['曶', '雽'],
    'zēng céng': ['曽', '橧'],
    'céng zēng': ['曾', '竲'],
    'cǎn qián jiàn': ['朁'],
    'qiè hé': ['朅'],
    'bì pí': ['朇', '禆', '笓', '裨'],
    'yǒu yòu': ['有'],
    'bān fén': ['朌', '鳻'],
    'fú fù': ['服', '洑'],
    'fěi kū': ['朏', '胐'],
    'qú xù chǔn': ['朐'],
    'juān zuī': ['朘'],
    'huāng máng wáng': ['朚'],
    'qī jī': ['期'],
    'tóng chuáng': ['朣', '橦'],
    zhá: ['札', '牐', '箚', '蚻', '譗', '鍘', '铡', '閘', '闸'],
    'zhú shù shú': ['朮'],
    'shù shú zhú': ['术'],
    'zhū shú': ['朱'],
    'pǔ pò pō piáo': ['朴'],
    'dāo tiáo mù': ['朷'],
    'guǐ qiú': ['朹'],
    xiǔ: ['朽', '滫', '潃', '糔'],
    'chéng chēng': ['朾'],
    zá: ['杂', '沯', '砸', '襍', '雑', '雜', '雥', '韴'],
    'yú wū': ['杅'],
    'gān gǎn': ['杆'],
    'chā chà': ['杈'],
    'shān shā': ['杉'],
    cūn: ['村', '皴', '竴', '膥', '踆', '邨'],
    'rèn ér': ['杒', '梕'],
    'sháo biāo': ['杓'],
    'dì duò': ['杕', '枤'],
    'gū gài': ['杚'],
    'yí zhì lí duò': ['杝'],
    'gàng gāng': ['杠'],
    'tiáo tiāo': ['条', '條'],
    'mà mǎ': ['杩'],
    'sì zhǐ xǐ': ['杫'],
    'yuán wán': ['杬', '蚖'],
    'bèi fèi': ['杮'],
    'shū duì': ['杸'],
    'niǔ chǒu': ['杻'],
    'wò yuè': ['枂', '臒'],
    máo: [
        '枆',
        '毛',
        '氂',
        '渵',
        '牦',
        '矛',
        '罞',
        '茅',
        '茆',
        '蝥',
        '蟊',
        '軞',
        '酕',
        '鉾',
        '錨',
        '锚',
        '髦',
        '鶜',
    ],
    'pī mì': ['枈'],
    àng: ['枊', '盎', '醠'],
    'fāng bìng': ['枋'],
    'hù dǐ': ['枑'],
    xín: ['枔', '襑', '鐔', '鬵'],
    'yāo yǎo': ['枖'],
    'ě è': ['枙'],
    'zhī qí': ['枝'],
    'cōng zōng': ['枞', '樅'],
    'xiān zhēn': ['枮'],
    'tái sì': ['枱'],
    'gǒu jǔ gōu': ['枸'],
    'bāo fú': ['枹'],
    'yì xiè': ['枻', '栧'],
    'tuó duò': ['柁', '馱', '駄', '驮'],
    'yí duò lí': ['柂'],
    'nǐ chì': ['柅'],
    'pán bàn': ['柈', '跘'],
    'yǎng yàng yāng yīng': ['柍'],
    'fù fū fǔ': ['柎'],
    'bǎi bó bò': ['柏'],
    mǒu: ['某'],
    'sháo shào': ['柖'],
    zhè: ['柘', '樜', '浙', '淛', '蔗', '蟅', '這', '鷓', '鹧', '䗪'],
    'yòu yóu': ['柚', '櫾'],
    'guì jǔ': ['柜'],
    'zhà zuò': ['柞'],
    'dié zhì': ['柣', '眰'],
    'zhā zǔ zū': ['柤'],
    'chá zhā': ['查', '査'],
    'āo ào': ['柪', '軪'],
    'bā fú pèi bó biē': ['柭'],
    'duò zuó wù': ['柮'],
    'bì bié': ['柲'],
    'zhù chù': ['柷'],
    'bēi pēi': ['柸'],
    'shì fèi': ['柹'],
    'shān zhà shi cè': ['栅'],
    'lì yuè': ['栎', '櫟'],
    'qì qiè': ['栔', '砌'],
    'qī xī': ['栖', '蹊'],
    'guā kuò': ['栝'],
    'bīng bēn': ['栟'],
    'xiào jiào': ['校'],
    'jiàn zùn': ['栫', '袸'],
    'yǒu yù': ['栯'],
    'hé hú': ['核'],
    gēn: ['根', '跟'],
    'zhī yì': ['栺'],
    'gé gē': ['格'],
    'héng háng': ['桁'],
    'guàng guāng': ['桄'],
    'yí tí': ['桋', '荑'],
    sāng: ['桑', '桒', '槡'],
    'jú jié': ['桔'],
    'yú móu': ['桙'],
    'ráo náo': ['桡', '橈'],
    'guì huì': ['桧', '檜'],
    'chén zhèn': ['桭'],
    'tīng yíng': ['桯'],
    'bó po': ['桲'],
    'bèn fàn': ['桳'],
    'fēng fèng': ['桻', '葑'],
    'sù yìn': ['梀'],
    'tǐng tìng': ['梃'],
    'xuān juān xié': ['梋'],
    'tú chá': ['梌'],
    'āo yòu': ['梎'],
    kuǎn: ['梡', '欵', '款', '歀'],
    'shāo sào': ['梢'],
    'qín chén cén': ['梣'],
    'lí sì qǐ': ['梩'],
    'chān yán': ['梴'],
    'bīn bīng': ['梹', '槟', '檳'],
    'táo chóu dào': ['梼'],
    'cōng sōng': ['棇'],
    'gùn hùn': ['棍'],
    'dé zhé': ['棏'],
    'pái bèi pèi': ['棑'],
    'bàng pǒu bèi bēi': ['棓'],
    'dì dài tì': ['棣'],
    sēn: ['森', '椮', '槮', '襂'],
    'rěn shěn': ['棯'],
    'léng lēng líng': ['棱'],
    'fú sù': ['棴'],
    'zōu sǒu': ['棷'],
    zōu: [
        '棸',
        '箃',
        '緅',
        '諏',
        '诹',
        '邹',
        '郰',
        '鄒',
        '鄹',
        '陬',
        '騶',
        '驺',
        '鯫',
        '鲰',
        '黀',
        '齱',
        '齺',
    ],
    'zhào zhuō': ['棹'],
    'chēn shēn': ['棽'],
    'jiē qiè': ['椄'],
    'yǐ yī': ['椅'],
    'chóu zhòu diāo': ['椆'],
    'qiāng kōng': ['椌'],
    'zhuī chuí': ['椎'],
    'bēi pí': ['椑'],
    mēn: ['椚'],
    'quān juàn quán': ['椦'],
    'duǒ chuán': ['椯'],
    'wěi huī': ['椲'],
    'jiǎ jiā': ['椵'],
    'hán jiān': ['椷'],
    'shèn zhēn': ['椹'],
    'yàn yà': ['椻'],
    'zhā chá': ['楂'],
    'guō kuǎ': ['楇'],
    'jí zhì': ['楖'],
    'kǔ hù': ['楛'],
    'yóu yǒu': ['楢'],
    'sǒng cōng': ['楤'],
    'yuán xuàn': ['楥'],
    'yǎng yàng yīng': ['楧'],
    pián: ['楩', '胼', '腁', '賆', '蹁', '駢', '騈', '骈', '骿', '㛹'],
    'dié yè': ['楪'],
    'dùn shǔn': ['楯'],
    'còu zòu': ['楱'],
    'dì dǐ shì': ['楴'],
    'kǎi jiē': ['楷'],
    'róu ròu': ['楺'],
    'lè yuè': ['楽'],
    'wēn yùn': ['榅', '鞰'],
    lǘ: ['榈', '櫚', '氀', '膢', '藘', '閭', '闾', '驢', '驴'],
    shén: ['榊', '神', '鉮', '鰰', '𬬹'],
    'bī pi': ['榌'],
    'zhǎn niǎn zhèn': ['榐'],
    'fú fù bó': ['榑'],
    'jiàn jìn': ['榗'],
    'bǎng bàng': ['榜'],
    'shā xiè': ['榝', '樧'],
    nòu: ['槈', '耨', '鎒', '鐞'],
    'qiǎn lián xiàn': ['槏'],
    gàng: ['槓', '焵', '焹', '筻', '鿍'],
    gāo: [
        '槔',
        '槹',
        '橰',
        '櫜',
        '睾',
        '篙',
        '糕',
        '羔',
        '臯',
        '韟',
        '餻',
        '高',
        '髙',
        '鷎',
        '鷱',
        '鼛',
    ],
    'diān zhěn zhēn': ['槙'],
    'kǎn jiàn': ['槛'],
    'xí dié': ['槢'],
    'jī guī': ['槣'],
    'róng yōng': ['槦'],
    'tuán shuàn quán': ['槫'],
    'qì sè': ['槭'],
    'cuī zhǐ': ['槯'],
    'yǒu chǎo': ['槱'],
    'màn wàn': ['槾'],
    'lí chī': ['樆'],
    'léi lěi': ['樏', '櫑', '礌'],
    'cháo jiǎo chāo': ['樔'],
    'chēng táng': ['樘'],
    'jiū liáo': ['樛'],
    'mó mú': ['模'],
    'niǎo mù': ['樢'],
    'héng hèng': ['横', '橫'],
    xuě: ['樰', '膤', '艝', '轌', '雪', '鱈', '鳕'],
    'fá fèi': ['橃'],
    rùn: ['橍', '润', '潤', '膶', '閏', '閠', '闰'],
    'zhǎn jiǎn': ['橏'],
    shùn: ['橓', '瞚', '瞬', '舜', '蕣', '順', '顺', '鬊'],
    'tuí dūn': ['橔'],
    'táng chēng': ['橖'],
    'sù qiū': ['橚'],
    'tán diàn': ['橝'],
    'fén fèn fèi': ['橨'],
    'rǎn yān': ['橪'],
    'cū chu': ['橻'],
    'shū qiāo': ['橾'],
    'píng bò': ['檘'],
    'zhái shì tú': ['檡'],
    'biǎo biāo': ['檦'],
    'qiān lián': ['檶'],
    'nǐ mí': ['檷'],
    'jiàn kǎn': ['檻'],
    'nòu ruǎn rú': ['檽'],
    'jī jì': ['櫅', '禨'],
    'huǎng guǒ gǔ': ['櫎'],
    'lǜ chū': ['櫖'],
    'miè mèi': ['櫗'],
    ōu: [
        '櫙',
        '欧',
        '歐',
        '殴',
        '毆',
        '瓯',
        '甌',
        '膒',
        '藲',
        '謳',
        '讴',
        '鏂',
        '鴎',
        '鷗',
        '鸥',
    ],
    'zhù zhuó': ['櫡'],
    'jué jì': ['櫭'],
    'huái guī': ['櫰'],
    'chán zhàn': ['欃'],
    'wéi zuì': ['欈'],
    cáng: ['欌', '鑶'],
    'yù yì': ['欥'],
    'chù qù xì': ['欪'],
    'kài ài': ['欬'],
    'yì yīn': ['欭'],
    'xì kài': ['欯'],
    'shuò sòu': ['欶'],
    'ǎi ēi éi ěi èi ê̄ ế ê̌ ề': ['欸'],
    'qī yī': ['欹'],
    'chuā xū': ['欻'],
    'chǐ chuài': ['欼'],
    'kǎn qiàn': ['欿'],
    'kǎn kè': ['歁'],
    'chuǎn chuán': ['歂'],
    'yīn yān': ['歅'],
    'jìn qūn': ['歏'],
    pēn: ['歕'],
    'xū chuā': ['歘'],
    'xī shè': ['歙'],
    'liǎn hān': ['歛'],
    'zhì chí': ['歭'],
    'sè shà': ['歰'],
    sǐ: ['死'],
    'wěn mò': ['歾'],
    piǎo: ['殍', '皫', '瞟', '醥', '顠'],
    'qíng jìng': ['殑'],
    'fǒu bó': ['殕'],
    'zhí shi': ['殖'],
    'yè yān yàn': ['殗'],
    'hūn mèi': ['殙'],
    chòu: ['殠', '臰', '遚'],
    'kuì huì': ['殨', '溃', '潰'],
    cuàn: ['殩', '熶', '爨', '窜', '竄', '篡', '簒'],
    'yīn yān yǐn': ['殷'],
    'qìng kēng shēng': ['殸'],
    'yáo xiáo xiào': ['殽'],
    'gū gǔ': ['毂', '蛄'],
    'guàn wān': ['毌'],
    'dú dài': ['毒'],
    'xún xùn': ['毥'],
    mú: ['毪', '氁'],
    'dòu nuò': ['毭'],
    'sāi suī': ['毸'],
    lu: ['氇'],
    sào: ['氉', '瘙', '矂', '髞'],
    'shì zhī': ['氏'],
    'dī dǐ': ['氐'],
    'máng méng': ['氓'],
    'yáng rì': ['氜'],
    shuǐ: ['水', '氵', '氺', '閖'],
    'zhěng chéng zhèng': ['氶'],
    tǔn: ['氽'],
    'fán fàn': ['氾'],
    'guǐ jiǔ': ['氿'],
    'bīn pà pā': ['汃'],
    'zhuó què': ['汋'],
    'dà tài': ['汏'],
    pìn: ['汖', '牝', '聘'],
    'hàn hán': ['汗', '馯'],
    tu: ['汢'],
    'tāng shāng': ['汤', '湯'],
    'zhī jì': ['汥'],
    'gàn hán cén': ['汵'],
    'wèn mén': ['汶'],
    'fāng pāng': ['汸'],
    'hǔ huǎng': ['汻'],
    'niú yóu': ['汼'],
    hàng: ['沆'],
    'shěn chén': ['沈'],
    'dùn zhuàn': ['沌'],
    'nǜ niǔ': ['沑'],
    'méi mò': ['沒', '没'],
    'tà dá': ['沓'],
    'mì wù': ['沕'],
    'hóng pāng': ['沗'],
    'shā shà': ['沙'],
    'zhuǐ zǐ': ['沝'],
    'ōu òu': ['沤', '漚'],
    'jǔ jù': ['沮'],
    'tuō duó': ['沰'],
    'mǐ lì': ['沵'],
    'yí chí': ['沶'],
    'xiè yì': ['泄'],
    'bó pō': ['泊'],
    'mì bì': ['泌', '秘'],
    'chù shè': ['泏'],
    'yōu yòu āo': ['泑'],
    'pēng píng': ['泙', '硑'],
    'pào pāo': ['泡'],
    'ní nì': ['泥', '秜'],
    'yuè sà': ['泧'],
    'jué xuè': ['泬', '疦'],
    'lóng shuāng': ['泷', '瀧'],
    'luò pō': ['泺', '濼'],
    'zé shì': ['泽', '澤'],
    'sǎ xǐ': ['洒'],
    'sè qì zì': ['洓'],
    'xǐ xiǎn': ['洗'],
    'kǎo kào': ['洘'],
    'àn yàn è': ['洝'],
    'lěi lèi': ['洡'],
    'qiè jié': ['洯'],
    'qiǎn jiān': ['浅'],
    'jì jǐ': ['济', '済', '濟', '纪'],
    'hǔ xǔ': ['浒', '滸'],
    'jùn xùn': ['浚', '濬'],
    'yǐng chéng yíng': ['浧'],
    'liàn lì': ['浰'],
    'féng hóng': ['浲', '溄'],
    'jiǒng jiōng': ['浻'],
    'suī něi': ['浽'],
    'yǒng chōng': ['涌'],
    'tūn yūn': ['涒'],
    'wō guō': ['涡', '渦'],
    hēng: ['涥', '脝'],
    'zhǎng zhàng': ['涨', '漲'],
    'shòu tāo': ['涭'],
    shuàn: ['涮', '腨'],
    'kōng náng': ['涳'],
    'wò wǎn yuān': ['涴'],
    'tuō tuò': ['涶'],
    wō: ['涹', '猧', '窝', '窩', '莴', '萵', '蜗', '蝸', '踒'],
    'qiè jí': ['淁'],
    'guǒ guàn': ['淉'],
    'lín lìn': ['淋', '獜', '疄'],
    'tǎng chǎng': ['淌'],
    'nào chuò zhuō': ['淖'],
    'péng píng': ['淜'],
    féi: ['淝', '肥', '腓', '蜰'],
    'pì pèi': ['淠'],
    'niǎn shěn': ['淰'],
    'biāo hǔ': ['淲'],
    'chún zhūn': ['淳'],
    'hùn hún': ['混'],
    qiǎn: ['淺', '繾', '缱', '肷', '膁', '蜸', '譴', '谴', '遣', '鑓'],
    'wèn mín': ['渂'],
    'rè ruò luò': ['渃'],
    'dú dòu': ['渎', '瀆', '读'],
    'jiàn jiān': ['渐', '溅', '漸', '濺'],
    'miǎn shéng': ['渑', '澠'],
    'nuǎn nuán': ['渜'],
    'qiú wù': ['渞'],
    'tíng tīng': ['渟'],
    'dì tí dī': ['渧'],
    'gǎng jiǎng': ['港'],
    'hōng qìng': ['渹'],
    tuān: ['湍', '煓'],
    'huì mǐn xū': ['湏'],
    'xǔ xù': ['湑'],
    pén: ['湓', '瓫', '盆', '葐'],
    'mǐn hūn': ['湣'],
    'tuàn nuǎn': ['湪'],
    'qiū jiǎo': ['湫', '湬'],
    'yān yīn': ['湮'],
    'bàn pán': ['湴'],
    'zhuāng hún': ['湷'],
    'yàn guì': ['溎'],
    'lián liǎn nián xián xiàn': ['溓'],
    'dá tǎ': ['溚', '鿎'],
    'liū liù': ['溜', '澑', '蹓'],
    lùn: ['溣'],
    mǎ: [
        '溤',
        '犸',
        '獁',
        '玛',
        '瑪',
        '码',
        '碼',
        '遤',
        '鎷',
        '馬',
        '马',
        '鰢',
        '鷌',
    ],
    'zhēn qín': ['溱'],
    'nì niào': ['溺'],
    'chù xù': ['滀', '畜'],
    'wěng wēng': ['滃'],
    'hào xuè': ['滈'],
    'qì xì xiē': ['滊'],
    'xíng yíng': ['滎'],
    'zé hào': ['滜'],
    'piāo piào piǎo': ['漂'],
    'cóng sǒng': ['漎'],
    'féng péng': ['漨'],
    'luò tà': ['漯'],
    'pēng bēn': ['漰'],
    'chóng shuāng': ['漴'],
    'huǒ kuò huò': ['漷'],
    'liáo liú': ['漻'],
    'cuǐ cuī': ['漼'],
    'cóng zǒng': ['潀'],
    'cóng zōng': ['潈'],
    'pì piē': ['潎'],
    'dàng xiàng': ['潒'],
    'huáng guāng': ['潢'],
    'liáo lào lǎo': ['潦'],
    'cōng zòng': ['潨'],
    'zhí zhì': ['潪'],
    'tān shàn': ['潬'],
    'tú zhā': ['潳'],
    'sàn sǎ': ['潵'],
    hēi: ['潶', '黑', '黒', '𬭶'],
    'chéng dèng': ['澄', '瀓'],
    'cūn cún': ['澊'],
    'péng pēng': ['澎'],
    'hòng gǒng': ['澒', '銾'],
    'wàn màn': ['澫'],
    'kuài huì': ['澮'],
    'guō wō': ['濄'],
    'pēn fén': ['濆'],
    'jí shà': ['濈'],
    'huì huò': ['濊'],
    'dǐng tìng': ['濎'],
    'mǐ nǐ': ['濔'],
    'bì pì': ['濞'],
    'cuì zuǐ': ['濢'],
    'hù huò': ['濩'],
    'ǎi kài kè': ['濭'],
    'wěi duì': ['濻', '瀢'],
    'zàn cuán': ['濽', '灒'],
    'yǎng yàng': ['瀁'],
    'wǎng wāng': ['瀇'],
    'mò miè': ['瀎', '眜'],
    suǐ: ['瀡', '膸', '髓'],
    'huái wāi': ['瀤'],
    'zùn jiàn': ['瀳'],
    'yīng yǐng yìng': ['瀴'],
    'ráng ràng': ['瀼'],
    shuàng: ['灀'],
    'zhuó jiào zé': ['灂'],
    sǎ: ['灑', '訯', '靸'],
    'luán luàn': ['灓'],
    'dǎng tǎng': ['灙'],
    'xún quán quàn': ['灥'],
    'huǒ biāo': ['灬'],
    'zhà yù': ['灹'],
    'fén bèn': ['炃'],
    'jiǒng guì': ['炅'],
    'pàng fēng': ['炐'],
    quē: ['炔', '缺', '缼', '蒛'],
    biān: [
        '炞',
        '煸',
        '甂',
        '砭',
        '笾',
        '箯',
        '籩',
        '編',
        '编',
        '蝙',
        '邉',
        '邊',
        '鍽',
        '鞭',
        '鯾',
        '鯿',
        '鳊',
    ],
    'zhāo zhào': ['炤'],
    'zhuō chù': ['炪'],
    'pào páo bāo': ['炮'],
    'páo fǒu': ['炰'],
    'shǎn qián shān': ['炶'],
    'zhà zhá': ['炸'],
    'jiǎo yào': ['烄'],
    quǎn: ['烇', '犬', '犭', '畎', '綣', '绻', '虇'],
    'yàng yáng': ['烊'],
    'lào luò': ['烙'],
    'huí huǐ': ['烠'],
    rè: ['热', '熱'],
    'fú páo': ['烰'],
    'xiè chè': ['烲', '焎'],
    'yàn shān': ['烻'],
    'hūn xūn': ['焄'],
    kào: ['焅', '犒', '銬', '铐', '靠', '鮳', '鯌', '鲓', '㸆'],
    'juān yè': ['焆'],
    'jùn qū': ['焌'],
    'tāo dào': ['焘'],
    'chǎo jù': ['焣'],
    'wò ài': ['焥'],
    'zǒng cōng': ['焧'],
    'xī yì': ['焬'],
    'xìn xīn': ['焮'],
    'chāo zhuō': ['焯'],
    'xiǒng yīng': ['焸', '焽'],
    kuǐ: ['煃', '跬', '蹞', '頍', '𫠆'],
    'huī yùn xūn': ['煇'],
    'jiǎo qiāo': ['煍'],
    'qián shǎn shān': ['煔'],
    'xī yí': ['煕'],
    'shà shā': ['煞'],
    'yè zhá': ['煠'],
    'yáng yàng': ['煬'],
    'ēn yūn': ['煾'],
    'yūn yǔn': ['熅'],
    'hè xiāo': ['熇'],
    xióng: ['熊', '熋', '雄'],
    'xūn xùn': ['熏', '爋'],
    gòng: ['熕', '貢', '贡'],
    liū: ['熘'],
    'cōng zǒng': ['熜'],
    'lù āo': ['熝'],
    'shú shóu': ['熟'],
    'fēng péng': ['熢'],
    'cuǐ suī': ['熣'],
    tēng: ['熥', '膯', '鼟'],
    'yùn yù': ['熨'],
    'áo āo': ['熬'],
    'hàn rǎn': ['熯'],
    'ōu ǒu': ['熰'],
    'huáng huǎng': ['熿'],
    'chǎn dǎn chàn': ['燀'],
    'jiāo zhuó qiáo jué': ['燋'],
    'yàn yān': ['燕'],
    'tài liè': ['燤'],
    āo: ['爊'],
    'yàn xún': ['爓'],
    'jué jiào': ['爝', '覐', '覚', '覺', '觉'],
    'lǎn làn': ['爦'],
    'zhuǎ zhǎo': ['爪'],
    'zhǎo zhuǎ': ['爫'],
    'fù fǔ': ['父'],
    diē: ['爹', '褺', '跌'],
    zāng: ['牂', '羘', '臧', '賍', '賘', '贓', '贜', '赃', '髒'],
    'piàn piān': ['片'],
    'biān miàn': ['牑'],
    bǎng: ['牓', '綁', '绑'],
    'yǒu yōng': ['牗'],
    'chēng chèng': ['牚', '竀'],
    niú: ['牛', '牜'],
    'jiū lè': ['牞'],
    'mù móu': ['牟'],
    māng: ['牤'],
    'gē qiú': ['牫'],
    'yòu chōu': ['牰'],
    'tè zhí': ['犆'],
    bēn: ['犇', '錛', '锛'],
    'jiān qián': ['犍', '玪'],
    má: ['犘', '痲', '蔴', '蟇', '麻'],
    'máo lí': ['犛'],
    'bá quǎn': ['犮'],
    'zhuó bào': ['犳'],
    'àn hān': ['犴'],
    'kàng gǎng': ['犺'],
    'pèi fèi': ['犻'],
    'fān huān': ['犿'],
    kuáng: ['狂', '狅', '誑', '诳', '軖', '軠', '鵟', '𫛭'],
    'yí quán chí': ['狋'],
    'xīng shēng': ['狌'],
    'tuó yí': ['狏'],
    kǔ: ['狜', '苦'],
    'huán huān': ['狟'],
    'hé mò': ['狢'],
    'tà shì': ['狧'],
    'máng dòu': ['狵'],
    'xī shǐ': ['狶'],
    suān: ['狻', '痠', '酸'],
    'bài pí': ['猈'],
    'jiān yàn': ['猏', '豣'],
    'yī yǐ': ['猗'],
    'yá wèi': ['猚'],
    cāi: ['猜'],
    'māo máo': ['猫', '貓'],
    'chuàn chuān': ['猭'],
    'tuān tuàn': ['猯', '貒'],
    'yà jiá qiè': ['猰'],
    'hè xiē gé hài': ['猲'],
    'biān piàn': ['猵', '獱'],
    'bó pò': ['猼'],
    'háo gāo': ['獋'],
    'fén fèn': ['獖'],
    'yào xiāo': ['獟'],
    'shuò xī': ['獡'],
    'gé liè xiē': ['獦'],
    'nòu rú': ['獳'],
    'náo nǎo yōu': ['獶'],
    ráng: ['獽', '瓤', '禳', '穣', '穰', '蘘', '躟', '鬤'],
    'náo yōu': ['獿'],
    'lǜ shuài': ['率'],
    'wáng wàng': ['王'],
    'yáng chàng': ['玚'],
    'mín wén': ['玟'],
    'bīn fēn': ['玢'],
    'mén yǔn': ['玧'],
    'qiāng cāng': ['玱', '瑲', '篬'],
    'án gān': ['玵'],
    'xuán xián': ['玹'],
    'cī cǐ': ['玼', '跐'],
    'yí tāi': ['珆'],
    'zǔ jù': ['珇'],
    fà: ['珐', '琺', '蕟', '髪', '髮'],
    'yín kèn': ['珢'],
    'huī hún': ['珲'],
    'xuán qióng': ['琁'],
    'fú fū': ['琈'],
    'bǐng pín': ['琕'],
    'cuì sè': ['琗'],
    'yù wéi': ['琟'],
    'tiǎn tiàn': ['琠'],
    'zhuó zuó': ['琢'],
    'běng pěi': ['琣'],
    guǎn: ['琯', '璭', '痯', '筦', '管', '舘', '輨', '錧', '館', '馆', '鳤'],
    'hún huī': ['琿'],
    'xié jiē': ['瑎'],
    'chàng dàng yáng': ['瑒'],
    'tiàn zhèn': ['瑱'],
    'bīn pián': ['瑸', '璸'],
    'tú shū': ['瑹'],
    cuǐ: ['璀', '皠', '趡'],
    'zǎo suǒ': ['璅'],
    'jué qióng': ['璚'],
    'lú fū': ['璷'],
    'jì zī': ['璾'],
    suí: ['瓍', '綏', '绥', '遀', '随', '隨', '髄'],
    'mí xǐ': ['瓕'],
    'qióng wěi wèi': ['瓗'],
    'huán yè yà': ['瓛'],
    'bó páo': ['瓟'],
    'zhí hú': ['瓡'],
    piáo: ['瓢', '闝'],
    'wǎ wà': ['瓦'],
    'xiáng hóng': ['瓨'],
    wèng: ['瓮', '甕', '罋', '蕹', '齆'],
    'shèn shén': ['甚'],
    ruí: ['甤', '緌', '蕤'],
    yòng: ['用', '砽', '苚', '蒏', '醟', '㶲'],
    shuǎi: ['甩'],
    béng: ['甭', '甮'],
    'yóu zhá': ['甴'],
    'diàn tián shèng': ['甸'],
    'tǐng dīng': ['町', '甼'],
    'zāi zī': ['甾'],
    'bì qí': ['畁'],
    'dá fú': ['畗'],
    'cè jì': ['畟'],
    'zāi zī tián': ['畠'],
    'zhì chóu shì': ['畤'],
    'fān pān': ['畨', '番'],
    'shē yú': ['畬'],
    'dāng dàng dǎng': ['當'],
    'jiāng qiáng': ['疆'],
    'pǐ yǎ shū': ['疋'],
    'jié qiè': ['疌'],
    'yí nǐ': ['疑'],
    nè: ['疒', '眲', '訥', '讷'],
    'gē yì': ['疙'],
    'nüè yào': ['疟', '瘧'],
    'lì lài': ['疠', '癘'],
    'yǎ xiā': ['疨'],
    xuē: ['疶', '蒆', '薛', '辥', '辪', '靴', '鞾'],
    'dǎn da': ['疸'],
    'fá biǎn': ['疺'],
    'fèi féi': ['疿', '痱'],
    'shān diàn': ['痁'],
    'téng chóng': ['痋'],
    'tōng tóng': ['痌'],
    'wěi yòu yù': ['痏'],
    'tān shǐ': ['痑'],
    'pū pù': ['痡', '鋪'],
    'bēng péng': ['痭'],
    'má lìn': ['痳'],
    'tiǎn diàn': ['痶'],
    'ān yè è': ['痷'],
    'kē ē': ['痾'],
    'zhì chì': ['瘈'],
    'jiǎ xiá xiā': ['瘕'],
    'lěi huì': ['瘣'],
    'chài cuó': ['瘥'],
    'diān chēn': ['瘨'],
    'da dá': ['瘩'],
    'biě biē': ['瘪'],
    qué: ['瘸'],
    'dàn dān': ['癉'],
    'guì wēi': ['癐'],
    'nòng nóng': ['癑'],
    'biē biě': ['癟'],
    'bō bǒ': ['癷'],
    bái: ['白'],
    'jí bī': ['皀'],
    'de dì dí dī': ['的'],
    'pā bà': ['皅'],
    'gāo háo': ['皋'],
    'gāo yáo': ['皐'],
    'lì luò bō': ['皪'],
    'zhā cǔ': ['皻'],
    'zhāo zhǎn dǎn': ['皽'],
    'jiān jiàn': ['监', '監', '鋻', '间', '鞬'],
    'gài gě hé': ['盖'],
    'máng wàng': ['盳'],
    yuǎn: ['盶', '逺', '遠'],
    'tián xián': ['盷'],
    'xiāng xiàng': ['相'],
    dǔn: ['盹', '趸', '躉'],
    'xì pǎn': ['盻'],
    'shěng xǐng': ['省'],
    'yún hùn': ['眃'],
    'miǎn miàn': ['眄'],
    'kàn kān': ['看'],
    'yìng yāng yǎng': ['眏'],
    'yǎo āo ǎo': ['眑'],
    'jū xū kōu': ['眗'],
    'yí chì': ['眙'],
    'dié tì': ['眣'],
    'bǐng fǎng': ['眪'],
    'pàng pán': ['眫'],
    'mī mí': ['眯', '瞇'],
    'xuàn shùn xún': ['眴'],
    tiào: ['眺', '粜', '糶', '覜', '趒'],
    'zhe zhuó zháo zhāo': ['着'],
    'qiáo shào xiāo': ['睄'],
    'cuó zhuài': ['睉'],
    gùn: ['睔', '謴'],
    'suì zuì': ['睟'],
    'pì bì': ['睥', '稫', '辟'],
    'yì zé gāo': ['睪'],
    'xǐng xìng': ['睲'],
    'guì wèi kuì': ['瞆'],
    'kòu jì': ['瞉'],
    'qióng huán': ['瞏'],
    'mán mén': ['瞒', '瞞'],
    'diāo dōu': ['瞗'],
    'lou lóu lǘ': ['瞜'],
    'shùn rún': ['瞤'],
    'liào liǎo': ['瞭', '钌'],
    'jiàn xián': ['瞯'],
    'wǔ mí': ['瞴'],
    'guì kuì': ['瞶'],
    'nǐng chēng': ['矃'],
    'huò yuè': ['矆'],
    'mēng méng': ['矇'],
    'kuàng guō': ['矌'],
    'guàn quán': ['矔'],
    'mǎn mán': ['矕'],
    'jīn guān qín': ['矜'],
    'jīn qín guān': ['矝'],
    'yù xù jué': ['矞'],
    'jiǎo jiáo': ['矫', '矯'],
    duǎn: ['短'],
    'shí dàn': ['石'],
    'gāng qiāng kòng': ['矼'],
    'huā xū': ['砉'],
    'pīn bīn fēn': ['砏'],
    'yán yàn': ['研', '硏'],
    'luǒ kē': ['砢'],
    'fú fèi': ['砩', '笰'],
    'zhǔ zhù': ['砫'],
    'lá lì lā': ['砬'],
    'kuāng guāng': ['硄'],
    'gè luò': ['硌'],
    'shuò shí': ['硕', '碩'],
    'wèi wéi ái': ['硙'],
    'què kè kù': ['硞'],
    'mǎng bàng': ['硥'],
    'luò lòng': ['硦'],
    'yǒng tóng': ['硧'],
    nüè: ['硸', '虐'],
    'kēng kěng': ['硻'],
    'yān yǎn': ['硽'],
    'zhuì chuí duǒ': ['硾'],
    'kōng kòng': ['硿'],
    'zòng cóng': ['碂'],
    'jiān zhàn': ['碊'],
    'lù liù': ['碌', '陆'],
    'què xī': ['碏'],
    'lún lǔn lùn': ['碖'],
    'náo gāng': ['碙'],
    'jié yà': ['碣'],
    'wèi wěi': ['碨'],
    'tí dī': ['碮'],
    'chá chā': ['碴'],
    'qiāo què': ['碻'],
    'sù xiè': ['碿'],
    'liú liù': ['磂', '遛', '鎦', '馏'],
    'sī tí': ['磃'],
    'bàng páng': ['磅'],
    'huá kě gū': ['磆'],
    'wěi kuǐ': ['磈'],
    'xiá qià yà': ['磍'],
    'lián qiān': ['磏'],
    'wèi ái gài': ['磑'],
    'lá lā': ['磖'],
    'áo qiāo': ['磝'],
    'pēng pèng': ['磞', '閛'],
    'yīn yǐn': ['磤'],
    'lěi léi': ['磥'],
    'mó mò': ['磨'],
    'qì zhú': ['磩'],
    'láo luò': ['磱'],
    'pán bō': ['磻'],
    'jí shé': ['磼'],
    'hé qiāo qiào': ['礉'],
    'kè huò': ['礊'],
    'què hú': ['礐'],
    'è qì': ['礘'],
    cǎ: ['礤', '礸'],
    'xián xín': ['礥'],
    'léi lěi lèi': ['礧'],
    'yán yǎn': ['礹'],
    'qí zhǐ': ['祇', '蚔'],
    'bēng fāng': ['祊'],
    'bì mì': ['祕'],
    suàn: ['祘', '笇', '筭', '算', '蒜'],
    'piào piāo': ['票'],
    'jì zhài': ['祭'],
    'shuì lèi': ['祱'],
    'jìn jīn': ['禁'],
    'chán shàn': ['禅'],
    'yáng shāng': ['禓'],
    'zhī zhǐ tí': ['禔'],
    'shàn chán': ['禪'],
    'yú yù ǒu': ['禺'],
    'zǐ zì': ['秄'],
    'chá ná': ['秅'],
    'zhǒng zhòng chóng': ['种'],
    'hào mào': ['秏'],
    'kù kū': ['秙'],
    zū: ['租', '葅'],
    chèng: ['秤', '穪'],
    'huó kuò': ['秮', '秳'],
    'chēng chèn chèng': ['称', '稱'],
    'shì zhì': ['秲', '銴'],
    'fù pū': ['秿'],
    'xùn zè': ['稄'],
    'tú shǔ': ['稌'],
    'zhùn zhǔn': ['稕'],
    'jī qí': ['稘', '綨', '觭'],
    'léng líng': ['稜'],
    'zuì zú sū': ['稡'],
    'xì qiè': ['稧', '郄'],
    'zhǒng zhòng': ['種'],
    'zōng zǒng': ['稯'],
    'xián jiān liàn': ['稴'],
    'zī jiū': ['稵'],
    'jī qǐ': ['稽'],
    ròng: ['穃'],
    'shān cǎn cēn': ['穇'],
    'mén méi': ['穈'],
    'jǐ jì': ['穖'],
    'xiāo rào': ['穘'],
    'zhuō bó': ['穛'],
    'tóng zhǒng zhòng': ['穜'],
    zuō: ['穝'],
    'biāo pāo': ['穮', '藨'],
    'zhuō jué': ['穱'],
    'cuán zàn': ['穳'],
    'kōng kòng kǒng': ['空'],
    'yū yǔ': ['穻'],
    zhǎi: ['窄', '鉙'],
    báo: ['窇', '雹'],
    'kū zhú': ['窋'],
    'jiào liáo liù': ['窌'],
    'wā guī': ['窐'],
    'tiǎo yáo': ['窕'],
    'xūn yìn': ['窨'],
    'yà yē': ['窫'],
    'tián diān yǎn': ['窴'],
    'chāo kē': ['窼'],
    'kuǎn cuàn': ['窽', '窾'],
    'chù qì': ['竐'],
    'qǔ kǒu': ['竘'],
    'jìng zhěn': ['竧'],
    'kǎn kàn': ['竷'],
    'zhú dǔ': ['竺'],
    'lè jīn': ['竻'],
    'zhuì ruì': ['笍'],
    'háng hàng': ['笐'],
    'cén jìn hán': ['笒'],
    'dā xiá nà': ['笚'],
    'zé zuó': ['笮'],
    'lóng lǒng': ['笼', '篭', '籠', '躘', '龓'],
    'zhù zhú': ['筑', '築'],
    'dá dā': ['答', '荅'],
    shāi: ['筛', '篩', '簁', '籭'],
    'yún jūn': ['筠'],
    'láng làng': ['筤', '郎', '阆'],
    'zhì zhǐ': ['筫'],
    o: ['筽'],
    'póu bù fú pú': ['箁'],
    'pái bēi': ['箄'],
    gè: ['箇', '虼', '鉻', '铬'],
    'tái chí': ['箈'],
    'guǎi dài': ['箉'],
    'zhào dào': ['箌'],
    'jīng qìng': ['箐'],
    'lín lǐn': ['箖'],
    'jùn qūn': ['箘'],
    'shī yí': ['箷', '釶'],
    'yuē yào chuò': ['箹'],
    'xiāo shuò qiào': ['箾'],
    'gōng gǎn lǒng': ['篢'],
    'páng péng': ['篣'],
    'zhuó huò': ['篧'],
    'jiǎn jiān': ['篯'],
    'dí zhú': ['篴'],
    'zān cēn cǎn': ['篸'],
    'zhuàn suǎn zuàn': ['篹'],
    'piǎo biāo': ['篻'],
    'guó guì': ['簂'],
    'cè jí': ['簎'],
    'mì miè': ['簚'],
    'shāi sī': ['簛'],
    'sǔn zhuàn': ['簨'],
    'gàn gǎn': ['簳'],
    'bò bǒ': ['簸'],
    'bó bù': ['簿'],
    shi: ['籂'],
    'zhēn jiān': ['籈'],
    'zhuàn zuǎn': ['籑'],
    'fān pān biān': ['籓'],
    'sǒu shǔ': ['籔'],
    zuǎn: ['籫', '繤', '纂', '纉', '纘', '缵'],
    nǚ: ['籹', '釹', '钕'],
    'shā chǎo': ['粆'],
    'kāng jīng': ['粇'],
    fěn: ['粉', '黺'],
    cū: ['粗', '觕', '麁', '麄', '麤'],
    'nián zhān': ['粘'],
    'cè sè': ['粣'],
    'zhōu yù': ['粥'],
    'shēn sǎn': ['糁'],
    'biān biǎn': ['糄', '萹'],
    miàn: ['糆', '面', '靣', '麪', '麫', '麵', '麺'],
    'hú hū hù': ['糊'],
    'gǔ gòu': ['糓'],
    'mí méi': ['糜'],
    'sǎn shēn': ['糝', '糣'],
    zāo: ['糟', '蹧', '遭', '醩'],
    'mì sī': ['糸'],
    'jiū jiǔ': ['糺'],
    'xì jì': ['系', '繫'],
    'zhēng zhěng': ['糽'],
    'chà chǎ': ['紁', '衩'],
    'yuē yāo': ['約', '约'],
    'hóng gōng': ['紅', '红'],
    'hé gē': ['紇', '纥'],
    'wén wèn': ['紋', '纹'],
    fóu: ['紑'],
    'jì jié jiè': ['紒'],
    'pī pí bǐ': ['紕', '纰'],
    'jīn jìn': ['紟'],
    'zhā zā': ['紥', '紮'],
    hā: ['紦'],
    'fū fù': ['紨'],
    'chōu chóu': ['紬'],
    'lèi léi lěi': ['累'],
    'bō bì': ['紴'],
    'tiǎn zhěn': ['紾'],
    'jiōng jiǒng': ['絅'],
    'jié jiē': ['結', '结', '节'],
    'guà kuā': ['絓'],
    'bǎi mò': ['絔'],
    'gēng huán': ['絙'],
    'jié xié': ['絜'],
    'quán shuān': ['絟'],
    'gǎi ǎi': ['絠'],
    'luò lào': ['絡', '络'],
    'bīng bēng pēng': ['絣'],
    'gěi jǐ': ['給', '给'],
    'tóng tōng dòng': ['絧'],
    'tiào diào dào': ['絩'],
    'lěi lèi léi': ['絫'],
    'gāi hài': ['絯'],
    'chī zhǐ': ['絺'],
    'wèn miǎn mán wàn': ['絻'],
    'huán huàn wàn': ['綄'],
    'qīn xiān': ['綅'],
    'tì tí': ['綈'],
    'yán xiàn': ['綖'],
    'zōng zèng zòng': ['綜'],
    'chēn lín': ['綝'],
    'zhǔn zhùn': ['綧'],
    'qiàn qīng zhēng': ['綪'],
    'qìng qǐ': ['綮'],
    'lún guān': ['綸', '纶'],
    'chuò chāo': ['綽', '绰'],
    'tián tǎn chān': ['緂'],
    'lǜ lù': ['緑', '绿'],
    'ruǎn ruàn': ['緛'],
    'jí qī': ['緝'],
    'zhòng chóng': ['緟', '重'],
    'miáo máo': ['緢'],
    'xiè yè': ['緤'],
    huǎn: ['緩', '缓', '㬊'],
    'gēng gèng': ['緪', '縆'],
    'tōu xū shū': ['緰'],
    'zōng zòng': ['緵', '繌'],
    'yùn gǔn': ['緷'],
    'guā wō': ['緺'],
    'yùn yūn wēn': ['緼', '縕'],
    'bāng bàng': ['縍'],
    'gǔ hú': ['縎', '鶻'],
    'cī cuò suǒ': ['縒'],
    'cuī shuāi': ['縗'],
    'róng rǒng ròng': ['縙'],
    'zài zēng': ['縡'],
    cài: ['縩', '菜', '蔡'],
    'féng fèng': ['縫'],
    'suō sù': ['縮', '缩'],
    'yǎn yǐn': ['縯', '酓'],
    'zòng zǒng': ['縱', '纵'],
    'zhuàn juàn': ['縳'],
    'mò mù': ['縸', '莫'],
    'piǎo piāo': ['縹', '缥'],
    'fán pó': ['繁'],
    'bēng bèng': ['繃'],
    'móu miù miào liǎo': ['繆'],
    'yáo yóu zhòu': ['繇'],
    'zēng zèng': ['繒', '缯'],
    'jú jué': ['繘'],
    'chuō chuò': ['繛'],
    'zūn zǔn': ['繜'],
    rào: ['繞', '绕', '遶'],
    'chǎn chán': ['繟'],
    'huì huí': ['繢', '缋', '藱'],
    'qiāo sāo zǎo': ['繰'],
    'jiǎo zhuó': ['繳', '缴'],
    'dàn tán chán': ['繵'],
    nǒng: ['繷'],
    'pú fú': ['纀'],
    'yào lì': ['纅'],
    'rǎng xiāng': ['纕'],
    'lí sǎ xǐ lǐ': ['纚'],
    'xiān qiàn': ['纤'],
    'jīng jìng': ['经'],
    'tí tì': ['绨'],
    'bēng běng bèng': ['绷'],
    'zōng zèng': ['综'],
    'jī qī': ['缉'],
    'wēn yùn yūn': ['缊'],
    'fèng féng': ['缝'],
    'shuāi cuī suī': ['缞'],
    'miù móu liáo miào mù': ['缪'],
    'qiāo sāo': ['缲'],
    fǒu: ['缶', '缹', '缻', '雬', '鴀'],
    'bà ba pí': ['罢', '罷'],
    'guà guǎi': ['罫'],
    'yáng xiáng': ['羊', '羏'],
    'měi gāo': ['羙'],
    'yì xī': ['羛'],
    'qiǎng qiān': ['羟'],
    'qiāng kòng': ['羫'],
    'qián xián yán': ['羬'],
    nóu: ['羺'],
    'hóng gòng': ['羾'],
    'pī bì pō': ['翍'],
    'qú yù': ['翑'],
    ké: ['翗'],
    'qiào qiáo': ['翘'],
    'zhái dí': ['翟'],
    'dào zhōu': ['翢'],
    'hóu qú': ['翵'],
    shuǎ: ['耍'],
    'ruǎn nuò': ['耎'],
    'ér nài': ['耏'],
    'zhuān duān': ['耑'],
    'pá bà': ['耙'],
    'chí sì': ['耛'],
    'qù chú': ['耝'],
    'lún lǔn': ['耣'],
    'jí jiè': ['耤'],
    'tāng tǎng': ['耥'],
    pǎng: ['耪', '覫'],
    'zhá zé': ['耫'],
    'yē yé': ['耶'],
    'yún yíng': ['耺'],
    'wà tuǐ zhuó': ['聉'],
    'ér nǜ': ['聏'],
    'tiē zhé': ['聑'],
    'dǐ zhì': ['聜'],
    qié: ['聺'],
    'nǐ jiàn': ['聻'],
    'lèi lē': ['肋'],
    cào: ['肏', '襙', '鄵', '鼜'],
    'bó dí': ['肑'],
    'xiào xiāo': ['肖'],
    'dù dǔ': ['肚'],
    chāi: ['肞', '釵', '钗'],
    'hán qín hàn': ['肣'],
    'pàng pán pàn': ['肨', '胖'],
    'zhūn chún': ['肫'],
    āng: ['肮', '骯'],
    'yù yō': ['育'],
    'pí bǐ bì': ['肶'],
    'fèi bì': ['胇'],
    'bèi bēi': ['背'],
    'fèi zǐ': ['胏'],
    'píng pēng': ['胓', '苹'],
    'fū fú zhǒu': ['胕'],
    'shèng shēng': ['胜'],
    kuà: ['胯', '跨', '骻'],
    'gǎi hǎi': ['胲'],
    'gē gé gā': ['胳'],
    'néng nài': ['能'],
    'guī kuì': ['胿'],
    'mài mò': ['脉'],
    'zāng zàng': ['脏'],
    'jiǎo jué': ['脚', '角'],
    cuǒ: ['脞'],
    'de te': ['脦'],
    'zuī juān': ['脧'],
    něi: ['脮', '腇', '餒', '馁', '鮾', '鯘'],
    'pú fǔ': ['脯'],
    niào: ['脲'],
    shuí: ['脽'],
    guò: ['腂', '過', '鐹'],
    'là xī': ['腊'],
    'yān ā': ['腌'],
    'gāo gào': ['膏'],
    'lù biāo': ['膔'],
    chuái: ['膗'],
    'zhuān chuán chún zhuǎn': ['膞'],
    chuài: ['膪', '踹'],
    'fán pán': ['膰'],
    'wǔ hū': ['膴'],
    'shān dàn': ['膻'],
    tún: ['臀', '臋', '蛌', '豘', '豚', '軘', '霕', '飩', '饨', '魨', '鲀', '黗'],
    'bì bei': ['臂'],
    'là gé': ['臈'],
    'sào sāo': ['臊'],
    nào: ['臑', '閙', '闹', '鬧'],
    'ní luán': ['臡'],
    'qiān xián': ['臤'],
    'guàng jiǒng': ['臦'],
    'guǎng jiǒng': ['臩'],
    'chòu xiù': ['臭'],
    'mián biān': ['臱'],
    'dié zhí': ['臷'],
    'zhī jìn': ['臸'],
    'shè shě': ['舍'],
    pù: ['舖', '舗'],
    'bān bō pán': ['般'],
    kuā: ['舿'],
    'gèn gěn': ['艮'],
    'sè shǎi': ['色'],
    'fú bó': ['艴'],
    'jiāo qiú': ['艽'],
    'chāi chā': ['芆'],
    'sháo què': ['芍'],
    'hù xià': ['芐'],
    'zì zǐ': ['芓'],
    'huì hū': ['芔'],
    'tún chūn': ['芚'],
    'jiè gài': ['芥'],
    'xù zhù': ['芧'],
    'yuán yán': ['芫'],
    'xīn xìn': ['芯'],
    'lún huā': ['芲'],
    'wù hū': ['芴'],
    'gōu gǒu': ['芶'],
    'mào máo': ['芼'],
    'fèi fú': ['芾'],
    'chán yín': ['苂'],
    qiē: ['苆'],
    'sū sù': ['苏'],
    'tiáo sháo': ['苕'],
    'lì jī': ['苙'],
    'kē hē': ['苛'],
    'jù qǔ': ['苣'],
    'ruò rě': ['若'],
    'zhù níng': ['苧'],
    'pā bó': ['苩'],
    xiú: ['苬'],
    'zhǎ zuó': ['苲'],
    'jū chá': ['苴'],
    nié: ['苶'],
    'shēng ruí': ['苼'],
    'qié jiā': ['茄'],
    'zǐ cí': ['茈'],
    'qiàn xī': ['茜'],
    chǎi: ['茝'],
    'fá pèi': ['茷'],
    ráo: ['荛', '蕘', '襓', '饒', '饶'],
    'yíng xíng': ['荥'],
    'qián xún': ['荨', '蕁'],
    'yìn yīn': ['荫'],
    'hé hè': ['荷'],
    'shā suō': ['莎'],
    'péng fēng': ['莑'],
    'shēn xīn': ['莘'],
    'wǎn guān guǎn': ['莞'],
    'yóu sù': ['莤'],
    'shāo xiāo': ['莦', '蛸'],
    'làng liáng': ['莨'],
    'piǎo fú': ['莩'],
    'wèn wǎn miǎn': ['莬'],
    'shì shí': ['莳', '蒔'],
    'tù tú': ['莵'],
    'xiān liǎn': ['莶', '薟'],
    'wǎn yù': ['菀'],
    'zōu chù': ['菆'],
    'lù lǜ': ['菉'],
    'jūn jùn': ['菌'],
    'niè rěn': ['菍'],
    'zī zì zāi': ['菑'],
    'tú tù': ['菟'],
    'jiē shà': ['菨'],
    'qiáo zhǎo': ['菬'],
    'tái zhī chí': ['菭'],
    'fēi fěi': ['菲', '蜚'],
    'qín qīn jīn': ['菳'],
    'zū jù': ['菹', '蒩'],
    'lǐn má': ['菻'],
    'tián tiàn': ['菾'],
    tiē: ['萜', '貼', '贴'],
    'luò là lào luō': ['落'],
    'zhù zhuó zhe': ['著'],
    'shèn rèn': ['葚'],
    'gě gé': ['葛'],
    'jùn suǒ': ['葰'],
    'kuì kuài': ['蒉'],
    'rú ná': ['蒘'],
    'méng mēng měng': ['蒙'],
    'yuán huán': ['蒝'],
    'xú shú': ['蒣'],
    'xí xì': ['蒵'],
    'mì míng': ['蓂'],
    'sōu sǒu': ['蓃'],
    'gài gě hé hài': ['蓋'],
    'yǎo zhuó': ['蓔'],
    'diào tiáo dí': ['蓧'],
    'xū qiū fū': ['蓲'],
    'zí jú': ['蓻'],
    'liǎo lù': ['蓼'],
    xu: ['蓿'],
    'hàn hǎn': ['蔊'],
    'màn wàn mán': ['蔓'],
    'pó bò': ['蔢'],
    'fān fán bō': ['蕃'],
    'hóng hòng': ['蕻'],
    'yù ào': ['薁', '隩'],
    'xí xiào': ['薂'],
    'báo bó bò': ['薄'],
    'cí zī': ['薋'],
    'wàn luàn': ['薍'],
    'kǎo hāo': ['薧'],
    'yuǎn wěi': ['薳'],
    'zhòu chóu': ['薵'],
    'wō mái': ['薶'],
    'xiāo hào': ['藃'],
    'yù xù xū': ['藇'],
    'jiè jí': ['藉'],
    'diào zhuó': ['藋'],
    'cáng zàng': ['藏'],
    lǎ: ['藞'],
    'chú zhū': ['藸'],
    'pín píng': ['蘋'],
    'gān hán': ['虷'],
    'hóng jiàng': ['虹'],
    'huī huǐ': ['虺'],
    'xiā há': ['虾'],
    'mǎ mà mā': ['蚂'],
    'fāng bàng': ['蚄'],
    'bàng bèng': ['蚌'],
    'jué quē': ['蚗'],
    'qín qián': ['蚙'],
    'gōng zhōng': ['蚣'],
    'fǔ fù': ['蚥'],
    'dài dé': ['蚮'],
    'gǒu qú xù': ['蚼'],
    'bǒ pí': ['蚾'],
    'shé yí': ['蛇'],
    tiě: ['蛈', '鉄', '銕', '鐡', '鐵', '铁', '驖'],
    'gé luò': ['蛒'],
    'máng bàng': ['蛖'],
    'yì xǔ': ['蛡'],
    'há gé': ['蛤'],
    'qiè ní': ['蛪'],
    'é yǐ': ['蛾'],
    'zhē zhé': ['蜇'],
    'là zhà': ['蜡'],
    suò: ['蜶', '逤'],
    'yóu qiú': ['蝤'],
    'xiā hā': ['蝦'],
    'xī qī': ['螇'],
    'bī pí': ['螕'],
    'nài něng': ['螚'],
    'hé xiá': ['螛'],
    'guì huǐ': ['螝'],
    'mǎ mā mà': ['螞'],
    'shì zhē': ['螫'],
    'zhì dié': ['螲'],
    'jiàn chán': ['螹'],
    'ma má mò': ['蟆'],
    'mǎng měng': ['蟒'],
    'biē bié': ['蟞'],
    'bēn fèi': ['蟦'],
    'láo liáo': ['蟧'],
    'yín xún': ['蟫'],
    'lí lǐ': ['蠡'],
    'xuè xiě': ['血'],
    'xíng háng hàng héng': ['行'],
    'shuāi cuī': ['衰'],
    'tuó tuō': ['袉'],
    'lǐng líng': ['袊'],
    'bào páo pào': ['袌'],
    'jù jiē': ['袓'],
    'hè kè': ['袔'],
    'yí yì': ['袘', '貤'],
    'nà jué': ['袦'],
    'bèi pī': ['被'],
    'chǐ nuǒ': ['袲'],
    'chǐ qǐ duǒ nuǒ': ['袳'],
    'jiá qiā jié': ['袷'],
    'bó mò': ['袹'],
    'guī guà': ['袿'],
    'liè liě': ['裂'],
    'chéng chěng': ['裎'],
    'jiē gé': ['裓'],
    'dāo chóu': ['裯'],
    'shang cháng': ['裳'],
    'yuān gǔn': ['裷'],
    'yǎn ān': ['裺'],
    'tì xī': ['裼'],
    'fù fú': ['褔'],
    'chǔ zhǔ': ['褚'],
    'tuì tùn': ['褪'],
    lǎi: ['襰'],
    'yào yāo': ['要'],
    'qín tán': ['覃'],
    'jiàn xiàn': ['見', '见'],
    piǎn: ['覑', '諞', '谝', '貵', '𡎚'],
    'piē miè': ['覕'],
    'yíng yǐng': ['覮'],
    'qù qū': ['覰', '覷', '觑'],
    'jiàn biǎn': ['覵'],
    'luó luǎn': ['覶'],
    'zī zuǐ': ['觜'],
    'huà xiè': ['觟'],
    'jiě jiè xiè': ['解', '觧'],
    'xué hù': ['觷'],
    'lì lù': ['觻'],
    tǎo: ['討', '讨'],
    zhùn: ['訰'],
    'zī zǐ': ['訾'],
    'yí dài': ['詒', '诒'],
    xiòng: ['詗', '诇'],
    'diào tiǎo': ['誂'],
    'yí chǐ chì': ['誃'],
    'lǎng làng': ['誏'],
    'ēi éi ěi èi xī': ['誒', '诶'],
    shuà: ['誜'],
    'yǔ yù': ['語', '语', '雨'],
    'shuō shuì yuè': ['說', '说'],
    'shuí shéi': ['誰', '谁'],
    'qū juè': ['誳'],
    'chī lài': ['誺'],
    'nì ná': ['誽'],
    'diào tiáo': ['調'],
    'pǐ bēi': ['諀'],
    'jì jī': ['諅'],
    'zé zuò zhǎ cuò': ['諎'],
    'chù jí': ['諔'],
    'háo xià': ['諕'],
    'lùn lún': ['論', '论'],
    'shì dì': ['諟'],
    'huà guā': ['諣'],
    'xǐ shāi āi': ['諰'],
    'nán nàn': ['諵', '難'],
    miù: ['謬', '谬'],
    zèn: ['譖', '谮'],
    'shí zhì': ['識', '识'],
    'juàn xuān': ['讂'],
    'yí tuī': ['讉'],
    zhán: ['讝'],
    'xǔ hǔ': ['许'],
    'xiáng yáng': ['详'],
    'tiáo diào zhōu': ['调'],
    'chén shèn': ['谌'],
    'mí mèi': ['谜'],
    'màn mán': ['谩'],
    'gǔ yù': ['谷'],
    'huō huò huá': ['豁'],
    'zhì zhài': ['豸'],
    'huān huán': ['貆'],
    'kěn kūn': ['貇'],
    'mò hé': ['貈'],
    'mò hé háo': ['貉'],
    'jù lóu': ['貗'],
    'zé zhài': ['責', '责'],
    'dài tè': ['貸'],
    'bì bēn': ['賁'],
    'jiǎ gǔ jià': ['賈'],
    'xiōng mín': ['賯'],
    càng: ['賶'],
    'zhuàn zuàn': ['賺', '赚'],
    'wàn zhuàn': ['贃'],
    'gàn gòng zhuàng': ['贛'],
    'yuán yùn': ['贠'],
    'bēn bì': ['贲'],
    'jiǎ gǔ': ['贾'],
    zǒu: ['走', '赱', '鯐'],
    'dié tú': ['趃'],
    'jū qiè': ['趄'],
    'qū cù': ['趋', '趨'],
    'jí jié': ['趌'],
    'guā huó': ['趏'],
    'què qì jí': ['趞'],
    'tàng tāng': ['趟'],
    'chuō zhuó': ['趠'],
    'qù cù': ['趣'],
    'yuè tì': ['趯'],
    'bō bào': ['趵'],
    'kuà wù': ['趶'],
    'guì jué': ['趹'],
    'fāng fàng páng': ['趽'],
    'páo bà': ['跁'],
    'qí qǐ': ['跂'],
    'jiàn chén': ['跈'],
    'pǎo páo': ['跑'],
    'diǎn diē tiē': ['跕'],
    'jū jù qiè': ['跙'],
    bǒ: ['跛'],
    'luò lì': ['跞'],
    'dài duò duō chí': ['跢'],
    zhuǎi: ['跩'],
    'bèng pián': ['跰'],
    'tiào táo': ['跳'],
    'shū chōu': ['跾'],
    'liàng liáng': ['踉'],
    'tà tā': ['踏'],
    chǎ: ['蹅', '鑔', '镲'],
    'dí zhí': ['蹢'],
    'dēng dèng': ['蹬', '鐙', '镫'],
    cèng: ['蹭'],
    'dūn cún': ['蹲'],
    'juě jué': ['蹶'],
    liāo: ['蹽'],
    'xiè sǎ': ['躠'],
    tǐ: ['躰', '軆', '骵'],
    'yà zhá gá': ['轧', '軋'],
    'xìn xiàn': ['軐'],
    'fàn guǐ': ['軓'],
    'zhuàn zhuǎn': ['転'],
    'zhóu zhòu': ['軸', '轴'],
    bú: ['轐', '醭', '鳪'],
    'zhuǎn zhuàn zhuǎi': ['转'],
    'zǎi zài': ['载'],
    'niǎn zhǎn': ['辗'],
    'biān bian': ['边'],
    'dào biān': ['辺'],
    'yǐ yí': ['迆', '迤', '迱'],
    'guò guo guō': ['过'],
    'wàng kuāng': ['迋'],
    'hái huán': ['还'],
    'zhè zhèi': ['这'],
    'yuǎn yuàn': ['远'],
    'zhì lì': ['迣'],
    'zhù wǎng': ['迬'],
    'zhuī duī': ['追'],
    'shì kuò': ['适'],
    tòu: ['透'],
    'tōng tòng': ['通'],
    guàng: ['逛'],
    'dǎi dài': ['逮'],
    'suì suí': ['遂'],
    'tí dì': ['遆'],
    'yí wèi': ['遗'],
    'shì dí zhé': ['適'],
    cà: ['遪'],
    'huán hái': ['還'],
    'lí chí': ['邌'],
    'kàng háng': ['邟'],
    'nà nèi nā': ['那'],
    'xié yá yé yú xú': ['邪'],
    'gāi hái': ['郂'],
    'huán xún': ['郇'],
    'chī xī': ['郗'],
    hǎo: ['郝'],
    'lì zhí': ['郦'],
    'xiáo ǎo': ['郩'],
    'dōu dū': ['都'],
    liǎo: ['曢', '鄝', '镽'],
    'zàn cuán cuó': ['酂', '酇'],
    'dīng dǐng': ['酊'],
    'cù zuò': ['酢'],
    'fā pō': ['酦'],
    'shāi shī': ['酾'],
    niàng: ['酿', '醸'],
    'qiú chōu': ['醔'],
    'pō fā': ['醗', '醱'],
    'chǎn chěn': ['醦'],
    'yàn liǎn xiān': ['醶'],
    'niàng niáng': ['釀'],
    'lǐ li': ['里'],
    'lí xǐ xī': ['釐'],
    'liǎo liào': ['釕'],
    'dīng dìng': ['釘', '钉'],
    'qiǎo jiǎo': ['釥'],
    'yú huá': ['釪'],
    'huá wū': ['釫'],
    'rì rèn jiàn': ['釰', '釼'],
    'dì dài': ['釱'],
    'pī zhāo': ['釽'],
    'yá yé': ['釾'],
    'bǎ pá': ['鈀', '钯'],
    'tā tuó': ['鉈', '铊'],
    běi: ['鉳'],
    'bǐng píng': ['鉼'],
    'hā kē': ['鉿', '铪'],
    chòng: ['銃', '铳'],
    'xiǎng jiōng': ['銄'],
    'yù sì': ['銉'],
    'xù huì': ['銊'],
    'rén rěn': ['銋'],
    'shàn shuò': ['銏'],
    'chì lì': ['銐'],
    'xiǎn xǐ': ['銑', '铣'],
    'hóu xiàng': ['銗'],
    'diào tiáo yáo': ['銚'],
    'xiān kuò tiǎn guā': ['銛', '銽', '铦'],
    'zhé niè': ['銸'],
    'zhōng yōng': ['銿'],
    'tōu tù dòu': ['鋀'],
    'méi méng': ['鋂'],
    'wàn jiǎn': ['鋄', '鎫'],
    'tǐng dìng': ['鋌', '铤'],
    'juān jiān cuān': ['鋑'],
    'sī tuó': ['鋖'],
    'juān xuān juàn': ['鋗'],
    'wú huá wū': ['鋘'],
    'zhuó chuò': ['鋜'],
    'xíng xìng jīng': ['鋞'],
    'jū jú': ['鋦', '锔'],
    'zuì niè': ['鋷'],
    'yuān yuǎn wǎn wān': ['鋺'],
    'gāng gàng': ['鋼', '钢'],
    zhuī: ['錐', '锥', '騅', '骓', '鵻'],
    ā: ['錒', '锕'],
    'cuō chā': ['鎈'],
    'suǒ sè': ['鎍'],
    'yáo zú': ['鎐'],
    'yè tà gé': ['鎑'],
    'qiāng chēng': ['鎗'],
    'gé lì': ['鎘', '镉', '鬲'],
    'bī pī bì': ['鎞'],
    'gǎo hào': ['鎬'],
    'zú chuò': ['鏃'],
    'xiū xiù': ['鏅'],
    'shòu sōu': ['鏉'],
    'dí dī': ['鏑', '镝'],
    'qiāo sǎn càn': ['鏒'],
    'lù áo': ['鏕'],
    'tāng táng': ['鏜'],
    'jiàn zàn': ['鏩'],
    'huì suì ruì': ['鏸'],
    'qiǎng qiāng': ['鏹', '镪'],
    'sǎn xiàn sà': ['鏾'],
    'jiǎn jiàn': ['鐧', '锏'],
    'dāng chēng': ['鐺', '铛'],
    'zuān zuàn': ['鑽'],
    'sà xì': ['钑'],
    'yào yuè': ['钥'],
    'tǒu dǒu': ['钭'],
    'zuàn zuān': ['钻'],
    'qiān yán': ['铅'],
    'pí pī': ['铍'],
    'yáo diào tiáo': ['铫'],
    'tāng tàng': ['铴'],
    'pù pū': ['铺'],
    'tán xiān': ['锬'],
    'liù liú': ['镏'],
    'hào gǎo': ['镐'],
    'táng tāng': ['镗'],
    'tán chán xín': ['镡'],
    'huò shǎn': ['閄'],
    'hàn bì': ['閈', '闬'],
    'kāng kàng': ['閌', '闶'],
    'xián jiàn jiān jiǎn': ['閒'],
    'xiā xiǎ': ['閕'],
    'xiǎ kě': ['閜'],
    'biàn guān': ['閞'],
    'hé gé': ['閤', '颌'],
    'hòng xiàng': ['閧'],
    'sē xī': ['閪'],
    'tíng tǐng': ['閮'],
    'è yān': ['閼', '阏'],
    'hòng juǎn xiàng': ['闂'],
    'bǎn pàn': ['闆'],
    'dū shé': ['闍', '阇'],
    'què quē': ['闕'],
    'tāng táng chāng': ['闛'],
    'kàn hǎn': ['闞', '阚'],
    'xì sè tà': ['闟'],
    'mēn mèn': ['闷'],
    'quē què': ['阙'],
    'yán diàn': ['阽'],
    'ā ē': ['阿'],
    'bēi pō pí': ['陂'],
    'yàn yǎn': ['隁'],
    'yú yáo shù': ['隃'],
    'lóng lōng': ['隆'],
    'duì zhuì': ['隊'],
    'suí duò': ['隋'],
    'gāi qí ái': ['隑'],
    'huī duò': ['隓', '隳'],
    'wěi kuí': ['隗'],
    'lì dài': ['隸'],
    'zhuī cuī wéi': ['隹'],
    'hè hú': ['隺', '鶮'],
    'jùn juàn': ['隽', '雋'],
    'nán nàn nuó': ['难'],
    'què qiāo qiǎo': ['雀'],
    'guàn huán': ['雚'],
    'guī xī': ['雟'],
    'sè xí': ['雭'],
    án: ['雸'],
    'wù méng': ['雺'],
    tèng: ['霯'],
    'lù lòu': ['露'],
    mái: ['霾'],
    'jìng liàng': ['靚'],
    'gé jí': ['革'],
    bǎ: ['靶'],
    'yāng yàng': ['鞅'],
    'gé tà sǎ': ['鞈'],
    'biān yìng': ['鞕'],
    'qiào shāo': ['鞘'],
    'juān xuān': ['鞙'],
    'shàng zhǎng': ['鞝'],
    'pí bǐng bì bēi': ['鞞'],
    la: ['鞡'],
    'xiè dié': ['鞢'],
    ēng: ['鞥'],
    'móu mù': ['鞪'],
    'bì bǐng': ['鞸'],
    'mèi wà': ['韎'],
    rǒu: ['韖'],
    'shè xiè': ['韘'],
    'yùn wēn': ['韫'],
    'dùn dú': ['頓', '顿'],
    duǐ: ['頧'],
    luō: ['頱'],
    'bīn pín': ['頻'],
    yóng: ['顒', '颙', '鰫'],
    mān: ['顢', '颟'],
    'jǐng gěng': ['颈'],
    'jié xié jiá': ['颉'],
    'kē ké': ['颏'],
    'pín bīn': ['频'],
    'chàn zhàn': ['颤'],
    'fēng fěng': ['風', '风'],
    'biāo diū': ['颩'],
    'bá fú': ['颰'],
    'sāo sōu': ['颾'],
    'liù liáo': ['飂'],
    'shí sì yì': ['食'],
    'yǎng juàn': ['飬'],
    'zhù tǒu': ['飳'],
    'yí sì': ['飴'],
    'zuò zé zhā': ['飵'],
    tiè: ['飻', '餮'],
    'xiǎng náng': ['饟'],
    'táng xíng': ['饧'],
    'gē le': ['饹'],
    'chā zha': ['馇'],
    'náng nǎng': ['馕'],
    'yūn wò': ['馧'],
    'zhī shì': ['馶'],
    'xìn jìn': ['馸'],
    'kuài jué': ['駃'],
    zǎng: ['駔', '驵'],
    'tái dài': ['駘'],
    'xún xuān': ['駨'],
    'liáng láng': ['駺'],
    piàn: ['騗', '騙', '骗', '魸'],
    'dài tái': ['骀'],
    'sāo sǎo': ['骚'],
    'gǔ gū': ['骨'],
    'bèi mó': ['骳'],
    'xiāo qiāo': ['骹'],
    'bǎng pǎng': ['髈'],
    'bó jué': ['髉'],
    'bì pǒ': ['髲'],
    'máo méng': ['髳'],
    'kuò yuè': ['髺'],
    'bā bà': ['魞', '鲃'],
    'jì cǐ': ['鮆'],
    'bó bà': ['鮊'],
    'zhǎ zhà': ['鮓', '鲊'],
    'chóu dài': ['鮘'],
    'luò gé': ['鮥'],
    'guī xié wā kuí': ['鮭'],
    'xiān xiǎn': ['鮮', '鲜'],
    'pū bū': ['鯆'],
    'yì sī': ['鯣'],
    'bà bó': ['鲌'],
    'guī xié': ['鲑'],
    'sāi xǐ': ['鳃'],
    'niǎo diǎo': ['鳥'],
    'diāo zhāo': ['鳭'],
    'gān hàn yàn': ['鳱'],
    'fū guī': ['鳺'],
    'jiān qiān zhān': ['鳽'],
    'hé jiè': ['鶡'],
    'piān biǎn': ['鶣'],
    'chuàn zhì': ['鶨'],
    'cāng qiāng': ['鶬'],
    'sǔn xùn': ['鶽'],
    'biāo páo': ['麃'],
    'zhù cū': ['麆'],
    'jūn qún': ['麇', '麕'],
    chi: ['麶'],
    'mó me': ['麼'],
    'mó me ma': ['麽'],
    'mí mǒ': ['麿'],
    'dàn shèn': ['黮'],
    'zhěn yān': ['黰'],
    'dǎn zhǎn': ['黵'],
    'miǎn mǐn měng': ['黾'],
    hōu: ['齁'],
    nàng: ['齉'],
    'qí jì zī zhāi': ['齐'],
    'yín kěn yǎn': ['龂'],
    'yín kěn': ['龈'],
    'gōng wò': ['龏'],
    'guī jūn qiū': ['龜', '龟'],
    'kuí wā': ['䖯'],
    lōu: ['䁖'],
    'ōu qū': ['𫭟'],
    'lóu lǘ': ['𦝼'],
    'gǎ gā gá': ['嘎'],
    'wā guà': ['坬'],
    'zhǐ dǐ': ['茋'],
    'gǒng hóng': ['硔'],
    'yáo xiào': ['滧'],
};
const DICT1 = new _common_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .FastDictFactory */ .pj();
Object.keys(map).forEach((key) => {
    const chars = map[key];
    for (let char of chars) {
        DICT1.set(char, key);
    }
});




/***/ })

}]);